import { defineComponent as B, useSlots as ce, computed as r, openBlock as o, createElementBlock as s, normalizeClass as p, createCommentVNode as x, createBlock as R, resolveDynamicComponent as H, renderSlot as z, createElementVNode as m, unref as u, normalizeStyle as Q, useModel as N, ref as M, watchEffect as Ee, createVNode as V, toDisplayString as D, mergeModels as W, Fragment as j, Teleport as ue, Transition as oe, withCtx as U, createTextVNode as ee, shallowRef as We, useId as pe, withDirectives as fe, mergeProps as he, vModelDynamic as ht, useTemplateRef as xt, vModelText as Je, nextTick as re, withModifiers as _, watch as $, onMounted as le, onBeforeUnmount as q, renderList as J, vShow as $e, provide as ge, inject as se, vModelSelect as mt, readonly as we, markRaw as _e, normalizeProps as yt, guardReactiveProps as At, onUnmounted as bt, getCurrentInstance as Ct, createSlots as wt, TransitionGroup as kt } from "vue";
import { AlertIcon as ne, CheckmarkIcon as Ie, InfoIcon as Lt, ChevronRightIcon as et, MinusIcon as Et, InfoSmallIcon as xe, ExternalLinkIcon as It, SearchIcon as Ft, CloseIcon as Re, CheckedSolidIcon as zt, DragDropIcon as Bt, ArrowSelectIcon as je, MenuIcon as Qe, CheckboxSelectedIcon as Gt, CheckboxIcon as Tt, ArrowUpIcon as Mt } from "@dacr/icons";
import { useFloating as De, autoUpdate as Ve, offset as Se, flip as Ze, shift as Ue, arrow as Rt, size as Dt } from "@floating-ui/vue";
import { RecycleScroller as Vt } from "vue-virtual-scroller";
const St = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACPTkDJAAADN0lEQVRYCb2WS2sUQRRGM1HjK2LUgGgSEFRcuBBBECSCihv9AQFR0JU7V/of3AmCK8FFVpI/IIIvBBe6U/EFghJBBd+Kb6PjOcPcprrTQxK7xwtnbnV11b1fPbqmGj2ztGazOZ+mm2ArDMMqGATrP7Z5jr8FdxqNxhR+RmvM1ILEy2izD7bDUjDhvLa3XHz23U+4CuMIeYfvaB0FtEe8h567YTEUE0Xyog9x+l8wAQpR1DQrFUDyfloegnWQBiwmW8D7qEvLaR/LD+AEIt7ic9abe+KB5KtxR2EI/pTQpE608DEQvRg3UMAWOE/sjfic5QTQwDUeA2egU3LrUxE8ZknLkptDEWvhLDncuJmFckduowMwAtHJOolptv4+3INJ+ADaSvALGYVdsAhckuirj5h3KR+MPZEK2MELsWE0TgU8ov5C2TpSnxkDcemOwV4I4akAY58hzil8a+oc/RLKR2AhhIBUxDU63ODdrI2Yh2l8HGImQoRxv8MoMV/7oG0Dyx4ewW/KcmmuyenTQ59x3GlIZyFm1LNFcT29KDXxejCxCUOA/iGBbuL/yeh7jo5XIESEV8gYuftMvgb0xeQ/qLsOVe0kAfxqInn4Aep2mngEiskd/WNG4BlfyYjh13IZ0oMqROxXgOuRTrtlj9AnUJddJJACUhEuw2aV9IEzoMVnqX/Tqqnn5zZhTK6lOYZDgKNOzUZf04qK5Zf0DwERyhwjCigmt0Gc8ZYrG/vgM0HMNc2s/AL+B4TFOe+hVCYu2tXi3YQKiK/AzRe4ObtuCvgEjjRFEV65um4KeAUxA6mI5ZxU/qt11RTwHjz1ykQMdTU7wXvZoV4w/EwUUBTRzyzkLhC0qdWcAe0ZeGlMBYSgQUSssFE3rCWAWXDTvQD3QCSO/eDzgDMBHp+1WhyLXkosbwA3nssSQvQhRqGekK09g/DKB1YsgRcIgz2N4PhUgIICDy//P0pPNurnZJkAeyHCkU6C+yESxmzoFRm+8uiJ1bqI6DNDhNOriG+QioiyiWtJTpzsr9Fyztp7wuPYC6vJY4PGfphCrMtUybJN2CkKQlwmRbjmOSH/RUAqDDGKUHRrGeoQ8BdfJBsNaB/5WQAAAABJRU5ErkJggg==", Zt = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAGxlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAACQAAAAAQAAAJAAAAABAAKgAgAEAAAAAQAAACCgAwAEAAAAAQAAACAAAAAAxqyL9QAAAAlwSFlzAAAWJQAAFiUBSVIk8AAABGxJREFUWAm1l11PY1UUhns++gkdpdAB0fFigoERgjZckLmCH+At/4f4Q/whXpsQTTAKAYFhZtAwSWMbB2qBftBzfN7t2fXQVqyl7GR3f5y91vuud++9zqmTGL64pVJput1ufxSG4RPHcXKdTifneZ5Lv0G/SVu7vb19d3x8XMZtMIxr578WLSwspCcmJhZw/AkAScBdFbWqzLn4cHrmOxB7g93POzs7N/dhePc8dFdWVp4D8AXOp8DUWhFmyjGt7Qucvq165rPkaaPReDE3N+f/TmEupPaVgQosLy+ncLBK/VDOo+hMlFHfKuCxxj63c12FQLPKVFKp1Le7u7vXvQz6FFhdXZ3AaQmgSTwlaE206luHPI8rYLYgmjMq0DetbMUGu0m28LNCofCuWq3e2RI97BZFzmCFqjbkYIU4M1V9LbRj9WPFEkqAp6hNjcCtcnlU+GptbS0Xs0vEFXBnZ2c/B2hCpAEy0eNMTmWjaDSvE34aBMFhsVg8yOVyv9Rqtbc4rwqYom2TX3NA6WtrZCsiGfx/vLGxcXR4ePh3QPKswoF7RvNMi2mtdA5Arq4ahtVMJvNq0D7K3pbFxUVFus74eQQOtrk1ViWR/GF/f39HNppMIEuSPSoB5omAJQGwkY/5twcHB79p7bCF7fwSoJdU4xM7owStCNzC6Zu9vb0ro+319fU8BBJEGfDAVBYFjKXp6/8LLpLY/ISv76WCBWdstoJxivmXWqeHDpIVBBiBCtiQQIEKLM+1cJSC7Y/YvcEv2P8kL+ZcVNVh99z19fW8JKcoxRkSEZEOh+vXUYDjNr7vf6dxTAmTL8BKc+U/9aanp4tEnIWRFoVEbW4AJP44OTmpxJ2N0i+Xy42ZmZlZbJ8CqkDNljDWAW+JjbJePHLmgw4L3o8COMgG/68ErPioloDYFH0i9qLD1s3VLHJubm760uYg50POlQUeXxup8cTn9PsKOf5Q/dPT03bv3APGdQAVebcoSOoHPvN94EjTVaNr8YAOV7KF+deDXIhVSyRs1Y6oTyLxBxmMe84nCbWTyaQBA7j7wgFILyQxf9Ti5/P5Jp9ZaaFY6dWiRJap+qOi49zlBVMXoGQHNICMrZnNzc1H3wbv/Py8w2s1z1U0iUjboCoy9Xrdq1Qqdz4gxq2IDqH2XdfEfHgIWLXVaul2pHo/IMZNwCQHomzNz8/rQyRsNpshaaGrAmT8dDodXFxc3I4bXP5scuhMTk7WFDUvD6OAVOB2BFdXVyEHNRspYdePjYv5IIm8OUtLSwUIKDmFFlwtr2udh0BKcFbaJBap0ZfARmEVjyg8Ojp6D0gnDo4S4eXlZQgvkQpRxEUNbd2d3D4KuGziBDQOkPuCrdA/G92EOxUlDBEtpIwlXfdFcXZ2FvBHpsU3vEeOcBS9gFEmZD7MZrPh1NRUyDoReDCJXgVMaPwE/MH8E/CG9l1KiIR9OM723kzHK7kJWIsXU5LW0zlAlUchMmxQ7tbWlre9vS3l/k29YX2ZdX8B/4+Cst1+y+EAAAAASUVORK5CYII=", Ut = ["disabled", "aria-busy"], Ot = ["src"], Ho = /* @__PURE__ */ B({
  __name: "Button",
  props: {
    variant: { default: "stroke" },
    size: { default: "md" },
    icon: {},
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = ce(), l = r(() => !!n.default), a = {
      md: "h-[30px] gap-[6px] rounded-[6px] px-[9px] text-[14px]",
      lg: "h-[38px] gap-[6px] rounded-[7px] px-[11px] text-[16px]",
      xl: "h-[48px] gap-[8px] rounded-[8px] px-[16px] text-[19px]"
    }, i = {
      stroke: "border border-gray-200 text-gray-800 hover:border-gray-300",
      primary: "bg-green-900 text-white hover:brightness-[1.2]",
      danger: "bg-red-600 text-white hover:brightness-[1.1]",
      ghost: "text-gray-800 hover:bg-gray-200/25"
    }, d = {
      stroke: "border border-gray-200/[55%] text-gray-500/[40%]",
      primary: "bg-green-900/[50%] text-white",
      danger: "bg-red-600/[50%] text-white",
      ghost: "text-gray-500/[40%]"
    }, c = {
      md: "size-[14px]",
      lg: "size-[16px]",
      xl: "size-[20px]"
    }, v = {
      md: "size-[18px]",
      lg: "size-[20px]",
      xl: "size-[20px]"
    }, f = r(
      () => (l.value ? c : v)[t.size]
    ), g = {
      md: "size-4",
      lg: "size-[18px]",
      xl: "size-[22px]"
    }, w = r(
      () => t.variant === "primary" || t.variant === "danger" ? St : Zt
    );
    return (G, k) => (o(), s("button", {
      type: "button",
      disabled: e.disabled || e.loading,
      "aria-busy": e.loading,
      class: p([
        "relative inline-flex shrink-0 select-none items-center justify-center whitespace-nowrap align-middle font-normal transition",
        a[e.size],
        e.disabled || e.loading ? d[e.variant] : i[e.variant],
        !(e.disabled || e.loading) && "cursor-pointer"
      ])
    }, [
      e.loading ? (o(), s("img", {
        key: 0,
        src: w.value,
        alt: "",
        "aria-hidden": "true",
        class: p(["absolute inset-0 m-auto animate-spin", g[e.size]])
      }, null, 10, Ot)) : x("", !0),
      e.icon ? (o(), R(H(e.icon), {
        key: 1,
        class: p([f.value, { invisible: e.loading }]),
        "aria-hidden": "true"
      }, null, 8, ["class"])) : x("", !0),
      l.value ? (o(), s("span", {
        key: 2,
        class: p({ invisible: e.loading })
      }, [
        z(G.$slots, "default")
      ], 2)) : x("", !0)
    ], 10, Ut));
  }
}), te = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [l, a] of t)
    n[l] = a;
  return n;
}, Yt = {}, Pt = {
  type: "button",
  class: "inline-flex h-[44px] shrink-0 cursor-pointer items-center justify-center rounded-full bg-white px-[15px] text-[15px] font-medium leading-[23px] whitespace-nowrap text-[#1a1a1a] shadow-[0_3px_28px_0_rgba(0,0,0,0.10)] transition"
};
function jt(e, t) {
  return o(), s("button", Pt, [
    z(e.$slots, "default")
  ]);
}
const No = /* @__PURE__ */ te(Yt, [["render", jt]]), Qt = ["data-variant"], Kt = { class: "min-w-0 flex-1" }, Xt = {
  key: 0,
  class: "mt-[8px]"
}, qo = /* @__PURE__ */ B({
  __name: "Alert",
  props: {
    variant: { default: "info" },
    icon: {},
    arrow: { type: Boolean }
  },
  setup(e) {
    const t = e, n = {
      info: "border border-[#EBEDEF] text-gray-800",
      success: "bg-green-200/50 text-green-800",
      warning: "bg-yellow-200/50 text-yellow-800",
      error: "bg-red-200/50 text-red-700"
    }, l = {
      info: Lt,
      success: Ie,
      warning: ne,
      error: ne
    }, a = r(() => t.icon ?? l[t.variant]);
    return (i, d) => (o(), s("div", {
      role: "alert",
      "data-testid": "alert",
      "data-variant": e.variant,
      class: p([
        "flex w-full items-start gap-[10px] rounded-[12px] px-[14px] py-[10px] text-[14px] leading-[18px]",
        n[e.variant]
      ])
    }, [
      (o(), R(H(a.value), {
        class: "mt-[2px] size-[14px] shrink-0",
        "aria-hidden": "true"
      })),
      m("div", Kt, [
        z(i.$slots, "default"),
        i.$slots.link ? (o(), s("div", Xt, [
          z(i.$slots, "link")
        ])) : x("", !0)
      ]),
      e.arrow ? (o(), R(u(et), {
        key: 0,
        class: "size-[16px] shrink-0 self-center",
        "aria-hidden": "true"
      })) : x("", !0)
    ], 10, Qt));
  }
}), Ht = {}, Nt = {
  "data-testid": "skeleton",
  class: "skeleton bg-[#F6F7F7]"
};
function qt(e, t) {
  return o(), s("div", Nt);
}
const Wt = /* @__PURE__ */ te(Ht, [["render", qt], ["__scopeId", "data-v-d9d552ae"]]), tt = /* @__PURE__ */ B({
  __name: "Avatar",
  props: {
    src: {},
    size: {}
  },
  setup(e) {
    const t = e, n = r(() => ({
      minWidth: `${t.size}px`,
      maxWidth: `${t.size}px`,
      minHeight: `${t.size}px`,
      maxHeight: `${t.size}px`
    })), l = r(() => ({
      ...n.value,
      backgroundImage: `url("${t.src}")`
    }));
    return (a, i) => e.src ? (o(), s("div", {
      key: 0,
      class: "rounded-full bg-cover bg-center",
      style: Q(l.value)
    }, null, 4)) : (o(), R(Wt, {
      key: 1,
      class: "rounded-full",
      style: Q(n.value)
    }, null, 8, ["style"]));
  }
}), Jt = ["checked", "disabled"], $t = {
  key: 0,
  class: "flex flex-col gap-[2px]"
}, ke = /* @__PURE__ */ B({
  __name: "Checkbox",
  props: /* @__PURE__ */ W({
    label: {},
    description: {},
    disabled: { type: Boolean },
    indeterminate: { type: Boolean }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = N(e, "modelValue"), l = M();
    Ee(() => {
      l.value && (l.value.indeterminate = !!t.indeterminate);
    });
    const a = (d) => {
      n.value = d.target.checked;
    }, i = r(() => {
      const d = n.value || t.indeterminate;
      return t.disabled ? d ? "border-transparent bg-green-900 opacity-50" : "border-[#2d2d2d]/[13%] bg-white" : d ? "border-transparent bg-green-900" : "border-[#2d2d2d]/25 bg-white peer-focus-visible:border-green-500";
    });
    return (d, c) => (o(), s("label", {
      class: p(["relative inline-flex select-none items-start gap-[12px]", e.disabled ? "cursor-not-allowed" : "cursor-pointer"])
    }, [
      m("input", {
        ref_key: "input",
        ref: l,
        type: "checkbox",
        class: "peer sr-only",
        checked: n.value,
        disabled: e.disabled,
        onChange: a
      }, null, 40, Jt),
      m("span", {
        class: p(["relative flex size-5 shrink-0 items-center justify-center rounded-[5px] border transition peer-focus-visible:ring-2 peer-focus-visible:ring-green-200/50", i.value])
      }, [
        V(u(Et), {
          class: p(["absolute inset-0 m-auto size-3 text-white transition", e.indeterminate ? "opacity-100" : "opacity-0"]),
          "aria-hidden": "true"
        }, null, 8, ["class"]),
        V(u(Ie), {
          class: p(["absolute inset-0 m-auto size-3 text-white transition", n.value && !e.indeterminate ? "opacity-100" : "opacity-0"]),
          "aria-hidden": "true"
        }, null, 8, ["class"])
      ], 2),
      e.label ? (o(), s("span", $t, [
        m("span", {
          class: p(["text-[14px] font-medium leading-[20px]", e.disabled ? "text-gray-300" : "text-gray-800"])
        }, D(e.label), 3),
        e.description ? (o(), s("span", {
          key: 0,
          class: p(["text-[14px] leading-[20px]", e.disabled ? "text-gray-300" : "text-gray-600"])
        }, D(e.description), 3)) : x("", !0)
      ])) : x("", !0)
    ], 2));
  }
}), _t = ["name", "checked", "disabled"], en = {
  key: 0,
  class: "size-2 rounded-full bg-[#F6F6F6]"
}, tn = {
  key: 0,
  class: "flex flex-col gap-[2px]"
}, Wo = /* @__PURE__ */ B({
  __name: "Radio",
  props: /* @__PURE__ */ W({
    value: {},
    name: {},
    label: {},
    description: {},
    disabled: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = N(e, "modelValue"), l = r(() => n.value === t.value), a = r(() => t.disabled ? l.value ? "border-transparent bg-green-900 opacity-50" : "border-[#2d2d2d]/[13%] bg-white" : l.value ? "border-transparent bg-green-900" : "border-[#2d2d2d]/25 bg-white peer-focus-visible:border-green-500");
    return (i, d) => (o(), s("label", {
      class: p(["relative inline-flex select-none items-start gap-[12px]", e.disabled ? "cursor-not-allowed" : "cursor-pointer"])
    }, [
      m("input", {
        type: "radio",
        class: "peer sr-only",
        name: e.name,
        checked: l.value,
        disabled: e.disabled,
        onChange: d[0] || (d[0] = (c) => n.value = e.value)
      }, null, 40, _t),
      m("span", {
        class: p(["relative flex size-5 shrink-0 items-center justify-center rounded-full border transition peer-focus-visible:ring-2 peer-focus-visible:ring-green-200/50", a.value])
      }, [
        l.value ? (o(), s("span", en)) : x("", !0)
      ], 2),
      e.label ? (o(), s("span", tn, [
        m("span", {
          class: p(["text-[14px] font-medium leading-[20px]", e.disabled ? "text-gray-300" : "text-gray-800"])
        }, D(e.label), 3),
        e.description ? (o(), s("span", {
          key: 0,
          class: p(["text-[14px] leading-[20px]", e.disabled ? "text-gray-300" : "text-gray-600"])
        }, D(e.description), 3)) : x("", !0)
      ])) : x("", !0)
    ], 2));
  }
}), nn = ["checked", "disabled"], on = {
  key: 0,
  class: "flex flex-col gap-[2px]"
}, Jo = /* @__PURE__ */ B({
  __name: "Toggle",
  props: /* @__PURE__ */ W({
    size: { default: "md" },
    label: {},
    description: {},
    disabled: { type: Boolean }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = N(e, "modelValue"), l = (f) => {
      n.value = f.target.checked;
    }, a = {
      md: "h-[20px] w-[34px]",
      lg: "h-[30px] w-[49px]"
    }, i = {
      md: "size-4",
      lg: "size-[26px]"
    }, d = {
      md: "translate-x-[14px]",
      lg: "translate-x-[19px]"
    }, c = r(() => {
      const f = t.disabled ? n.value ? "bg-green-900/50" : "bg-gray-300/20" : n.value ? "bg-green-900" : "bg-gray-300/40";
      return `${a[t.size]} ${f}`;
    }), v = r(
      () => `${i[t.size]} ${n.value ? d[t.size] : "translate-x-0"}`
    );
    return (f, g) => (o(), s("label", {
      class: p([
        "relative inline-flex select-none items-start gap-[12px]",
        e.disabled ? "pointer-events-none" : "cursor-pointer"
      ])
    }, [
      m("input", {
        type: "checkbox",
        role: "switch",
        class: "peer sr-only",
        checked: n.value,
        disabled: e.disabled,
        onChange: l
      }, null, 40, nn),
      m("span", {
        class: p(["relative shrink-0 rounded-full transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-green-200/50", c.value])
      }, [
        m("span", {
          class: p(["absolute left-[2px] top-[2px] rounded-full bg-white transition-transform", v.value]),
          style: { boxShadow: "0 1px 1px rgba(66,68,70,0.08)" }
        }, null, 2)
      ], 2),
      e.label && e.size !== "lg" ? (o(), s("span", on, [
        m("span", {
          class: p(["text-[14px] font-medium leading-[20px]", e.disabled ? "text-gray-300" : "text-gray-800"])
        }, D(e.label), 3),
        e.description ? (o(), s("span", {
          key: 0,
          class: p(["text-[14px] leading-[20px]", e.disabled ? "text-gray-300" : "text-gray-600"])
        }, D(e.description), 3)) : x("", !0)
      ])) : x("", !0)
    ], 2));
  }
}), Ke = 8, ln = 5, sn = /* @__PURE__ */ B({
  inheritAttrs: !1,
  __name: "Tooltip",
  props: {
    content: {},
    placement: { default: "top" },
    size: { default: "sm" },
    arrow: { type: Boolean, default: !0 },
    disabled: { type: Boolean }
  },
  setup(e) {
    const t = e, n = ce(), l = M(), a = M(), i = M(), d = M(!1), c = r(() => t.arrow && t.size !== "lg"), { floatingStyles: v, middlewareData: f, placement: g } = De(
      l,
      a,
      {
        placement: t.placement,
        whileElementsMounted: Ve,
        transform: !1,
        middleware: r(() => [
          Se(c.value ? Ke : Ke - ln),
          Ze({ padding: 8 }),
          Ue({ padding: 8 }),
          Rt({ element: i })
        ])
      }
    ), w = r(() => !!t.content || !!n.content), G = () => {
      !t.disabled && w.value && (d.value = !0);
    }, k = () => {
      d.value = !1;
    }, F = {
      sm: "rounded-[6px] bg-gray-700 px-[9px] py-[5px] leading-[18px] text-white",
      md: "rounded-[6px] bg-gray-700 px-[12px] py-[7px] leading-[18px] text-white",
      lg: "max-w-[250px] rounded-[8px] border border-gray-200 bg-white px-[16px] py-[12px] leading-[20px] text-gray-800"
    }, L = r(() => F[t.size]), C = r(
      () => t.size === "lg" ? "0 3px 6px rgba(0,0,0,0.05)" : "0 2px 10px rgba(0,0,0,0.1), 0 0 20px rgba(0,0,0,0.05)"
    ), I = r(
      () => g.value.split("-")[0]
    ), A = {
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }, y = r(() => {
      const b = f.value.arrow;
      return {
        left: b?.x != null ? `${b.x}px` : "",
        top: b?.y != null ? `${b.y}px` : "",
        [A[I.value]]: "-4px"
      };
    });
    return (b, E) => (o(), s(j, null, [
      m("span", {
        ref_key: "reference",
        ref: l,
        class: "inline-flex w-fit",
        onMouseenter: G,
        onMouseleave: k,
        onFocusin: G,
        onFocusout: k
      }, [
        z(b.$slots, "default", {}, void 0, !0)
      ], 544),
      (o(), R(ue, { to: "body" }, [
        V(oe, { name: "tooltip-popover" }, {
          default: U(() => [
            d.value ? (o(), s("div", {
              key: 0,
              ref_key: "floating",
              ref: a,
              role: "tooltip",
              class: p([
                "pointer-events-none z-[999] w-fit text-[14px] opacity-95",
                L.value,
                b.$attrs.class
              ]),
              style: Q([u(v), { boxShadow: C.value }])
            }, [
              z(b.$slots, "content", {}, () => [
                ee(D(e.content), 1)
              ], !0),
              c.value ? (o(), s("div", {
                key: 0,
                ref_key: "arrowEl",
                ref: i,
                class: "absolute h-[10px] w-[10px] rotate-45 rounded-[2px] bg-gray-700",
                style: Q(y.value)
              }, null, 4)) : x("", !0)
            ], 6)) : x("", !0)
          ]),
          _: 3
        })
      ]))
    ], 64));
  }
}), me = /* @__PURE__ */ te(sn, [["__scopeId", "data-v-2058292d"]]), $o = /* @__PURE__ */ B({
  __name: "Pill",
  props: {
    variant: { default: "default" },
    icon: {},
    info: {}
  },
  setup(e) {
    const t = e, n = {
      default: "border-gray-300/25 bg-gray-200/25 text-gray-800",
      success: "border-green-300/50 bg-green-200/50 text-green-900",
      warning: "border-yellow-300/75 bg-yellow-200/50 text-yellow-700",
      danger: "border-red-300/45 bg-red-200/50 text-red-700"
    }, l = r(() => n[t.variant]);
    return (a, i) => (o(), s("span", {
      class: p([
        "inline-flex w-fit items-center gap-[4px] rounded-[4px] border px-[5px] py-[4px] text-[12px] leading-[10px] whitespace-nowrap",
        l.value
      ])
    }, [
      e.icon ? (o(), R(H(e.icon), {
        key: 0,
        class: "size-[10px] shrink-0",
        "aria-hidden": "true"
      })) : x("", !0),
      z(a.$slots, "default"),
      e.info ? (o(), R(me, {
        key: 1,
        size: "lg",
        content: e.info
      }, {
        default: U(() => [
          V(u(xe), {
            class: "size-[11px] shrink-0 cursor-help",
            tabindex: "0"
          })
        ]),
        _: 1
      }, 8, ["content"])) : x("", !0)
    ], 2));
  }
}), an = ["aria-valuenow"], _o = /* @__PURE__ */ B({
  __name: "Progress",
  props: {
    percentage: {},
    size: { default: "md" },
    color: { default: "var(--color-green-700)" },
    trackColor: { default: "rgba(0, 0, 0, 0.06)" }
  },
  setup(e) {
    const t = e, n = {
      sm: "h-[6px]",
      md: "h-[8px]"
    }, l = r(() => n[t.size]), a = r(() => Math.min(100, Math.max(0, t.percentage))), i = r(() => ({
      width: `${a.value}%`,
      backgroundColor: t.color
    }));
    return (d, c) => (o(), s("div", {
      class: p(["w-full rounded-full", l.value]),
      style: Q({ backgroundColor: e.trackColor }),
      role: "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      "aria-valuenow": a.value
    }, [
      m("div", {
        class: "h-full rounded-full",
        style: Q(i.value)
      }, null, 4)
    ], 14, an));
  }
}), rn = ["href"], dn = ["width", "height", "viewBox"], cn = ["x1", "y1", "x2", "y2"], un = ["points"], el = /* @__PURE__ */ B({
  __name: "Link",
  props: {
    href: {},
    size: { default: "sm" },
    icon: {},
    leadingIcon: {}
  },
  setup(e) {
    const t = e, n = {
      sm: "text-[14px] leading-[18px]",
      md: "text-[15px] leading-[18px]",
      lg: "text-[16px] leading-[20px]"
    }, l = r(() => n[t.size]), a = {
      sm: "translate-y-[1px]",
      md: "translate-y-[1.5px]",
      lg: "translate-y-[1px]"
    }, i = r(() => a[t.size]), d = {
      width: 13,
      height: 11,
      stemX1: 1.69,
      stemX2: 11,
      stemY: 5.48,
      stemClass: "origin-[1.69px] scale-x-[0.839]",
      head: "6.14 2.12 9.5 5.48 6.14 8.85"
    }, v = {
      sm: d,
      md: d,
      lg: {
        width: 14,
        height: 12,
        stemX1: 1.85,
        stemX2: 11.85,
        stemY: 5.98,
        stemClass: "origin-[1.85px] scale-x-[0.852]",
        head: "6.69 2.31 10.37 5.98 6.69 9.66"
      }
    }, f = r(() => v[t.size]);
    return (g, w) => (o(), s("a", {
      href: e.href,
      class: p([
        "group/link inline-flex w-fit cursor-pointer items-center font-medium text-green-700 hover:text-green-600",
        l.value
      ])
    }, [
      e.leadingIcon ? (o(), R(H(e.leadingIcon), {
        key: 0,
        class: "mr-[6px] size-[14px] shrink-0",
        "aria-hidden": "true"
      })) : x("", !0),
      z(g.$slots, "default"),
      e.icon === "arrow" ? (o(), s("svg", {
        key: 1,
        class: p(["ml-[4px] shrink-0", i.value]),
        width: f.value.width,
        height: f.value.height,
        viewBox: `0 0 ${f.value.width} ${f.value.height}`,
        fill: "none",
        "aria-hidden": "true"
      }, [
        m("line", {
          class: p([
            "transition-transform duration-200 group-hover/link:scale-x-100",
            f.value.stemClass
          ]),
          x1: f.value.stemX1,
          y1: f.value.stemY,
          x2: f.value.stemX2,
          y2: f.value.stemY,
          stroke: "currentColor",
          "stroke-width": "1.5"
        }, null, 10, cn),
        m("polyline", {
          class: "translate-x-0 transition-transform duration-200 group-hover/link:translate-x-[2px]",
          points: f.value.head,
          stroke: "currentColor",
          "stroke-width": "1.5",
          "stroke-linecap": "square",
          "stroke-linejoin": "round"
        }, null, 8, un)
      ], 10, dn)) : e.icon === "external" ? (o(), R(u(It), {
        key: 2,
        class: "ml-[6px] size-[11px] shrink-0",
        "aria-hidden": "true"
      })) : x("", !0)
    ], 10, rn));
  }
}), pn = ["data-variant"], fn = { class: "flex min-w-0 flex-1 items-center gap-[10px] px-[14px]" }, gn = { class: "min-w-0 flex-1 truncate" }, vn = /* @__PURE__ */ B({
  __name: "Toast",
  props: {
    variant: { default: "light" },
    icon: {},
    action: {}
  },
  emits: ["action"],
  setup(e) {
    const t = e, n = ce(), l = {
      light: "border-black/[0.08] bg-white text-gray-800",
      dark: "border-black/[0.08] bg-gray-800 text-white",
      success: "border-[#01758d]/[0.12] bg-[color-mix(in_srgb,var(--color-green-200)_50%,white)] text-green-800",
      error: "border-[#ac0000]/[0.12] bg-[color-mix(in_srgb,var(--color-red-200)_50%,white)] text-red-700"
    }, a = {
      light: "group-hover:bg-gray-200/25 group-focus-visible:bg-gray-200/25",
      dark: "group-hover:bg-white/15 group-focus-visible:bg-white/15",
      success: "group-hover:bg-green-200/40 group-focus-visible:bg-green-200/40",
      error: "group-hover:bg-red-200/40 group-focus-visible:bg-red-200/40"
    }, i = {
      light: ne,
      dark: ne,
      success: Ie,
      error: ne
    }, d = r(() => t.icon ?? i[t.variant]), c = r(() => !!t.action || !!n.action);
    return (v, f) => (o(), s("div", {
      role: "status",
      "data-testid": "toast",
      "data-variant": e.variant,
      class: p([
        "inline-flex h-[44px] items-stretch overflow-hidden rounded-[10px] border text-[14px] leading-[20px]",
        "shadow-[0_0.8px_2.925px_0_rgba(0,0,0,0.02),0_2.025px_7.8px_0_rgba(0,0,0,0.004),0_4px_18px_0_rgba(0,0,0,0.04)]",
        l[e.variant]
      ])
    }, [
      m("div", fn, [
        d.value ? (o(), R(H(d.value), {
          key: 0,
          class: "size-4 shrink-0",
          "aria-hidden": "true"
        })) : x("", !0),
        m("span", gn, [
          z(v.$slots, "default")
        ])
      ]),
      c.value ? (o(), s("button", {
        key: 0,
        type: "button",
        class: "group flex shrink-0 cursor-pointer items-stretch p-[4px] outline-none",
        onClick: f[0] || (f[0] = (g) => v.$emit("action"))
      }, [
        m("span", {
          class: p([
            "flex items-center rounded-[6px] px-[10px] font-medium transition-colors",
            a[e.variant]
          ])
        }, [
          z(v.$slots, "action", {}, () => [
            ee(D(e.action), 1)
          ])
        ], 2)
      ])) : x("", !0)
    ], 10, pn));
  }
}), de = We(null), hn = de;
let xn = 0, Ce, ie, Fe = !1;
const nt = () => {
  Ce && clearTimeout(Ce), Ce = void 0;
}, ot = () => {
  de.value && (de.value = null, Fe = !0);
}, Oe = (e) => {
  if (e !== void 0 && ie?.toast.id === e) {
    ie = void 0;
    return;
  }
  e !== void 0 && de.value?.id !== e || (nt(), ie = void 0, ot());
}, mn = (e, t) => {
  t && (Ce = setTimeout(() => Oe(e.id), t));
}, lt = (e, t) => {
  de.value = e, Fe = !1, mn(e, t);
}, st = ({
  variant: e = "light",
  message: t,
  icon: n,
  action: l,
  duration: a
}) => {
  nt();
  const i = { id: ++xn, variant: e, message: t, icon: n, action: l };
  return de.value || Fe ? (ie = { toast: i, duration: a }, ot()) : lt(i, a), i.id;
}, yn = () => {
  if (Fe = !1, !ie) return;
  const e = ie;
  ie = void 0, lt(e.toast, e.duration);
}, An = (e) => {
  if (!e) return;
  const t = e.action;
  Oe(e.id), t?.onClick();
}, Ae = (e) => (t, n) => st({ variant: e, message: t, ...n }), tl = () => ({
  show: st,
  dismiss: Oe,
  light: Ae("light"),
  dark: Ae("dark"),
  success: Ae("success"),
  error: Ae("error")
}), bn = () => ({
  current: hn,
  onAfterLeave: yn,
  runAction: An
}), Cn = { class: "pointer-events-none fixed inset-x-0 top-[16px] z-[1000] flex justify-center px-[16px]" }, nl = /* @__PURE__ */ B({
  __name: "ToastHost",
  setup(e) {
    const { current: t, onAfterLeave: n, runAction: l } = bn();
    return (a, i) => (o(), R(ue, { to: "body" }, [
      m("div", Cn, [
        V(oe, {
          mode: "out-in",
          "enter-active-class": "transition duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]",
          "leave-active-class": "transition duration-200 ease-[cubic-bezier(0.4,0,0.2,1)]",
          "enter-from-class": "opacity-0 -translate-y-[10px]",
          "leave-to-class": "opacity-0 -translate-y-[10px]",
          onAfterLeave: u(n)
        }, {
          default: U(() => [
            u(t) ? (o(), R(vn, {
              key: u(t).id,
              variant: u(t).variant,
              icon: u(t).icon,
              action: u(t).action?.label,
              class: "pointer-events-auto",
              onAction: i[0] || (i[0] = (d) => u(l)(u(t)))
            }, {
              default: U(() => [
                ee(D(u(t).message), 1)
              ]),
              _: 1
            }, 8, ["variant", "icon", "action"])) : x("", !0)
          ]),
          _: 1
        }, 8, ["onAfterLeave"])
      ])
    ]));
  }
}), wn = { class: "flex w-full flex-col gap-[6px]" }, kn = {
  key: 0,
  class: "flex items-center gap-[6px]"
}, Ln = ["for"], En = {
  type: "button",
  "aria-label": "More information",
  class: "flex rounded-full text-gray-500 outline-none focus-visible:ring-2 focus-visible:ring-green-200/50"
}, In = { class: "relative w-full" }, Fn = ["id", "type", "placeholder", "disabled", "aria-invalid"], zn = ["for"], Bn = {
  key: 1,
  class: "flex items-center gap-[6px] text-red-500"
}, Gn = { class: "text-[12px] leading-[16px]" }, ol = /* @__PURE__ */ B({
  inheritAttrs: !1,
  __name: "Input",
  props: /* @__PURE__ */ W({
    size: { default: "md" },
    label: {},
    hint: {},
    placeholder: {},
    error: {},
    disabled: { type: Boolean },
    type: { default: "text" },
    id: {}
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = N(e, "modelValue"), l = pe(), a = r(() => t.id ?? l), i = r(() => t.label || t.placeholder), d = r(
      () => t.size === "xl" && !!i.value
    ), c = r(() => t.size === "md" ? "h-[30px] rounded-[6px] px-[10px] py-[5px]" : t.size === "lg" ? "h-[38px] rounded-[7px] px-[14px] py-[9px]" : d.value ? "h-[48px] rounded-[8px] px-[16px] pt-[21px] pb-[7px]" : "h-[48px] rounded-[8px] px-[16px] py-[14px]"), v = r(() => t.disabled ? "bg-gray-800/[0.03] text-gray-800/50 placeholder:text-gray-500/50 border-gray-200/50" : t.error ? "bg-white text-gray-800 placeholder:text-gray-500/70 border-red-500" : "bg-white text-gray-800 placeholder:text-gray-500/70 border-gray-200 hover:border-gray-300 focus:border-green-500 focus:ring-2 focus:ring-green-200/50");
    return (f, g) => (o(), s("div", wn, [
      e.label && !d.value ? (o(), s("div", kn, [
        m("label", {
          for: a.value,
          class: "text-[14px] font-medium leading-[18px] text-gray-800"
        }, D(e.label), 9, Ln),
        e.hint ? (o(), R(me, {
          key: 0,
          content: e.hint,
          size: "lg",
          placement: "top"
        }, {
          default: U(() => [
            m("button", En, [
              V(u(xe), {
                class: "size-[12px]",
                "aria-hidden": "true"
              })
            ])
          ]),
          _: 1
        }, 8, ["content"])) : x("", !0)
      ])) : x("", !0),
      m("div", In, [
        fe(m("input", he({
          id: a.value,
          "onUpdate:modelValue": g[0] || (g[0] = (w) => n.value = w)
        }, f.$attrs, {
          type: e.type,
          placeholder: d.value ? " " : e.placeholder,
          disabled: e.disabled,
          "aria-invalid": e.error ? "true" : void 0,
          class: [
            "peer w-full appearance-none border text-[14px] leading-[18px] outline-none transition-colors",
            c.value,
            v.value
          ]
        }), null, 16, Fn), [
          [ht, n.value]
        ]),
        d.value ? (o(), s("label", {
          key: 0,
          for: a.value,
          class: p(["pointer-events-none absolute left-[16px] top-1 origin-[0] translate-y-0 scale-75 text-[14px] font-medium leading-[18px] transition-all peer-placeholder-shown:translate-y-[11px] peer-placeholder-shown:scale-100 peer-placeholder-shown:font-normal peer-focus:translate-y-0 peer-focus:scale-75 peer-focus:font-medium", e.disabled ? "text-gray-500/40" : "text-gray-500/70"])
        }, D(i.value), 11, zn)) : x("", !0)
      ]),
      e.error ? (o(), s("div", Bn, [
        V(u(ne), {
          class: "size-[12px] shrink-0",
          "aria-hidden": "true"
        }),
        m("span", Gn, D(e.error), 1)
      ])) : x("", !0)
    ]));
  }
}), Tn = { class: "relative w-full" }, Mn = ["id", "placeholder"], ll = /* @__PURE__ */ B({
  inheritAttrs: !1,
  __name: "Search",
  props: /* @__PURE__ */ W({
    size: { default: "md" },
    placeholder: { default: "Search" },
    id: {}
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = N(e, "modelValue"), l = pe(), a = r(() => t.id ?? l), i = xt("inputRef");
    function d() {
      n.value = "", re(() => i.value?.focus());
    }
    const c = r(
      () => t.size === "md" ? "h-[30px] rounded-[6px] py-[5px] pl-[30px] pr-[30px]" : "h-[38px] rounded-[7px] py-[9px] pl-[36px] pr-[38px]"
    );
    return (v, f) => (o(), s("div", Tn, [
      V(u(Ft), {
        class: p([
          "pointer-events-none absolute top-1/2 size-[14px] -translate-y-1/2 text-gray-500",
          e.size === "md" ? "left-[10px]" : "left-[14px]"
        ]),
        "aria-hidden": "true"
      }, null, 8, ["class"]),
      fe(m("input", he({
        id: a.value,
        ref_key: "inputRef",
        ref: i,
        "onUpdate:modelValue": f[0] || (f[0] = (g) => n.value = g)
      }, v.$attrs, {
        type: "search",
        placeholder: e.placeholder,
        class: [
          "w-full appearance-none border bg-transparent text-[14px] leading-[20px] text-gray-800 outline-none transition-colors placeholder:text-gray-500",
          "[&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none",
          "border-gray-200 hover:border-gray-300 focus:border-green-500 focus:bg-white focus:ring-2 focus:ring-green-200/50",
          c.value
        ]
      }), null, 16, Mn), [
        [Je, n.value]
      ]),
      n.value ? (o(), s("button", {
        key: 0,
        type: "button",
        "aria-label": "Clear search",
        class: p([
          "absolute top-1/2 flex size-[22px] -translate-y-1/2 items-center justify-center rounded-full text-gray-500 outline-none transition-colors hover:text-gray-800 focus-visible:ring-2 focus-visible:ring-green-200/50",
          e.size === "md" ? "right-[4px]" : "right-[8px]"
        ]),
        onClick: d
      }, [
        V(u(Re), {
          class: "size-[13px]",
          "aria-hidden": "true"
        })
      ], 2)) : x("", !0)
    ]));
  }
}), Rn = { class: "min-w-0 truncate" }, sl = /* @__PURE__ */ B({
  __name: "Chip",
  props: {
    size: { default: "sm" },
    selected: { type: Boolean },
    src: {},
    icon: {}
  },
  emits: ["remove"],
  setup(e) {
    const t = e, n = {
      sm: "rounded-[3px] py-[3px] pl-[5px] pr-[5px]",
      lg: "rounded-[5px] py-[5px] pl-[5px] pr-[5px]"
    }, l = r(() => n[t.size]), a = r(
      () => t.selected ? "bg-green-200/50 text-green-700" : "bg-gray-200/50 text-gray-800 hover:bg-gray-200/75"
    );
    return (i, d) => (o(), s("span", {
      class: p([
        "inline-flex w-fit max-w-full cursor-pointer items-center gap-[6px] whitespace-nowrap text-[14px] leading-[18px] transition-colors",
        l.value,
        a.value
      ])
    }, [
      z(i.$slots, "leading", {}, () => [
        e.src ? (o(), R(tt, {
          key: 0,
          src: e.src,
          size: 16,
          class: "shrink-0"
        }, null, 8, ["src"])) : e.icon ? (o(), R(H(e.icon), {
          key: 1,
          class: "size-[14px] shrink-0",
          "aria-hidden": "true"
        })) : x("", !0)
      ]),
      m("span", Rn, [
        z(i.$slots, "default")
      ]),
      m("button", {
        type: "button",
        "aria-label": "Remove",
        class: "flex shrink-0 cursor-pointer rounded-full text-current opacity-60 outline-none transition-opacity hover:opacity-100 focus-visible:opacity-100 focus-visible:ring-2 focus-visible:ring-green-200/50",
        onClick: d[0] || (d[0] = _((c) => i.$emit("remove"), ["stop"]))
      }, [
        V(u(Re), {
          class: "size-[12px]",
          "aria-hidden": "true"
        })
      ])
    ], 2));
  }
}), Dn = { class: "flex w-full flex-col gap-[6px]" }, Vn = {
  key: 0,
  class: "flex items-center gap-[6px]"
}, Sn = ["for"], Zn = {
  type: "button",
  "aria-label": "More information",
  class: "flex rounded-full text-gray-500 outline-none focus-visible:ring-2 focus-visible:ring-green-200/50"
}, Un = { class: "flex min-w-[60px] flex-1 items-center" }, On = {
  key: 1,
  class: "flex items-center gap-[6px] text-red-500"
}, Yn = { class: "text-[12px] leading-[16px]" }, Pn = /* @__PURE__ */ B({
  __name: "Autocomplete",
  props: {
    size: { default: "md" },
    label: {},
    hint: {},
    error: {},
    disabled: { type: Boolean },
    id: {}
  },
  emits: ["remove"],
  setup(e, { emit: t }) {
    const n = e, l = t, a = pe(), i = r(() => n.id ?? a), d = M(), c = M(), v = M(-1), f = () => d.value?.querySelector("input, textarea") ?? null, g = () => c.value?.childElementCount ?? 0, w = () => {
      v.value = -1;
    }, G = () => {
      n.disabled || f()?.focus();
    }, k = () => {
      w(), G();
    };
    function F(A) {
      if (n.disabled) return;
      const y = f(), b = y ? y.selectionStart === 0 && y.selectionEnd === 0 : !0, E = g(), h = v.value;
      switch (A.key) {
        case "Backspace":
          if (!E || !b) return;
          A.preventDefault(), h !== -1 ? (l("remove", h), w()) : v.value = E - 1;
          break;
        case "ArrowLeft":
          if (!E || !b) return;
          A.preventDefault(), v.value = h === -1 ? E - 1 : Math.max(0, h - 1);
          break;
        case "ArrowRight":
          if (h === -1) return;
          A.preventDefault(), h >= E - 1 ? w() : v.value = h + 1;
          break;
        case "Escape":
          h !== -1 && (A.preventDefault(), w());
          break;
        default:
          h !== -1 && A.key.length === 1 && !A.metaKey && !A.ctrlKey && w();
      }
    }
    $(v, (A) => {
      const y = f();
      y && (y.style.caretColor = A === -1 ? "" : "transparent");
    });
    const L = {
      md: "min-h-[30px] rounded-[6px] px-[10px] py-[2px]",
      lg: "min-h-[38px] rounded-[7px] px-[14px] py-[6px]",
      xl: "min-h-[48px] rounded-[8px] px-[16px] py-[9px]"
    }, C = r(() => L[n.size]), I = r(() => n.disabled ? "pointer-events-none border-gray-200/50 bg-gray-800/[0.03] text-gray-800/50" : n.error ? "border-red-500 bg-white text-gray-800" : "border-gray-200 bg-white text-gray-800 hover:border-gray-300 focus-within:border-green-500! focus-within:ring-2 focus-within:ring-green-200/50");
    return (A, y) => (o(), s("div", Dn, [
      e.label ? (o(), s("div", Vn, [
        m("label", {
          for: i.value,
          class: "text-[14px] font-medium leading-[18px] text-gray-800"
        }, D(e.label), 9, Sn),
        e.hint ? (o(), R(me, {
          key: 0,
          content: e.hint,
          size: "lg",
          placement: "top"
        }, {
          default: U(() => [
            m("button", Zn, [
              V(u(xe), {
                class: "size-[12px]",
                "aria-hidden": "true"
              })
            ])
          ]),
          _: 1
        }, 8, ["content"])) : x("", !0)
      ])) : x("", !0),
      m("div", {
        ref_key: "field",
        ref: d,
        class: p([
          "ac-field flex w-full cursor-text flex-wrap items-center gap-x-[6px] gap-y-[4px] border text-[14px] leading-[18px] transition-colors",
          C.value,
          I.value
        ]),
        onClick: k,
        onKeydown: F
      }, [
        m("span", {
          ref_key: "selectionEl",
          ref: c,
          style: { display: "contents" }
        }, [
          z(A.$slots, "selection", { activeIndex: v.value }, void 0, !0)
        ], 512),
        m("div", Un, [
          z(A.$slots, "input", { id: i.value }, void 0, !0)
        ])
      ], 34),
      e.error ? (o(), s("div", On, [
        V(u(ne), {
          class: "size-[12px] shrink-0",
          "aria-hidden": "true"
        }),
        m("span", Yn, D(e.error), 1)
      ])) : x("", !0)
    ]));
  }
}), al = /* @__PURE__ */ te(Pn, [["__scopeId", "data-v-f2b64d87"]]), jn = { class: "flex w-full flex-col gap-[6px]" }, Qn = {
  key: 0,
  class: "flex flex-col"
}, Kn = {
  key: 0,
  class: "flex items-center gap-[6px]"
}, Xn = ["for"], Hn = {
  type: "button",
  "aria-label": "More information",
  class: "flex rounded-full text-gray-500 outline-none focus-visible:ring-2 focus-visible:ring-green-200/50"
}, Nn = {
  key: 1,
  class: "text-[12px] leading-[16px] text-gray-600"
}, qn = { class: "relative w-full" }, Wn = ["id", "placeholder", "disabled", "aria-invalid"], Jn = ["for"], $n = {
  key: 1,
  class: "flex items-center gap-[6px] text-red-500"
}, _n = { class: "text-[12px] leading-[16px]" }, e1 = 110, il = /* @__PURE__ */ B({
  inheritAttrs: !1,
  __name: "Textarea",
  props: /* @__PURE__ */ W({
    size: { default: "md" },
    label: {},
    hint: {},
    description: {},
    placeholder: {},
    error: {},
    disabled: { type: Boolean },
    id: {}
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = N(e, "modelValue"), l = pe(), a = r(() => t.id ?? l), i = M(!1), d = M(null), c = () => {
      i.value = !0;
    }, v = () => {
      i.value = !1;
    }, f = (I) => {
      if (!d.value) return;
      I.preventDefault();
      const A = I.clientY, y = d.value.offsetHeight, b = (h) => {
        if (!d.value) return;
        const T = Math.max(e1, y + h.clientY - A);
        d.value.style.height = `${T}px`;
      }, E = () => {
        window.removeEventListener("pointermove", b), window.removeEventListener("pointerup", E);
      };
      window.addEventListener("pointermove", b), window.addEventListener("pointerup", E);
    }, g = r(() => t.label || t.placeholder), w = r(() => t.size === "xl" && !!g.value), G = r(() => i.value || !!n.value), k = r(() => t.disabled ? "text-gray-500/40" : "text-gray-500/70"), F = r(() => [
      t.disabled ? "bg-[#f9f9f9]" : "bg-white",
      G.value ? "opacity-100" : "opacity-0"
    ]), L = r(() => t.size === "lg" ? "rounded-[7px] px-[14px] py-[10px]" : t.size === "xl" ? "rounded-[8px] px-[15px] pt-[21px] pb-[10px]" : "rounded-[6px] px-[10px] py-[6px]"), C = r(() => t.disabled ? "bg-gray-800/[0.03] text-gray-800/50 placeholder:text-gray-500/50 border-gray-200/50" : t.error ? "bg-white text-gray-800 placeholder:text-gray-500/70 border-red-500" : "bg-white text-gray-800 placeholder:text-gray-500/70 border-gray-200 hover:border-gray-300 focus:border-green-500 focus:ring-2 focus:ring-green-200/50");
    return (I, A) => (o(), s("div", jn, [
      (e.label || e.description) && !w.value ? (o(), s("div", Qn, [
        e.label ? (o(), s("div", Kn, [
          m("label", {
            for: a.value,
            class: "text-[14px] font-medium leading-[20px] text-gray-800"
          }, D(e.label), 9, Xn),
          e.hint ? (o(), R(me, {
            key: 0,
            content: e.hint,
            size: "lg",
            placement: "top"
          }, {
            default: U(() => [
              m("button", Hn, [
                V(u(xe), {
                  class: "size-[12px]",
                  "aria-hidden": "true"
                })
              ])
            ]),
            _: 1
          }, 8, ["content"])) : x("", !0)
        ])) : x("", !0),
        e.description ? (o(), s("span", Nn, D(e.description), 1)) : x("", !0)
      ])) : x("", !0),
      m("div", qn, [
        fe(m("textarea", he({
          id: a.value,
          ref_key: "textareaEl",
          ref: d,
          "onUpdate:modelValue": A[0] || (A[0] = (y) => n.value = y)
        }, I.$attrs, {
          placeholder: w.value ? " " : e.placeholder,
          disabled: e.disabled,
          "aria-invalid": e.error ? "true" : void 0,
          class: [
            "peer block min-h-[110px] w-full resize-none appearance-none border text-[14px] leading-[18px] outline-none transition-colors",
            L.value,
            C.value
          ],
          onFocus: c,
          onBlur: v
        }), null, 16, Wn), [
          [Je, n.value]
        ]),
        e.disabled ? x("", !0) : (o(), s("div", {
          key: 0,
          "aria-hidden": "true",
          class: "absolute bottom-0 right-0 flex size-[18px] cursor-ns-resize touch-none select-none items-end justify-end p-[3px]",
          onPointerdown: f
        }, [...A[1] || (A[1] = [
          m("svg", {
            viewBox: "0 0 8.216 8",
            class: "h-2 w-[8.22px] text-[#8792a2]",
            fill: "currentColor",
            "aria-hidden": "true"
          }, [
            m("path", { d: "M8.216 0 L0 8 L1.084 8 L8.216 1.08 Z" }),
            m("path", { d: "M3.155 8 L4.379 8 L8.216 4.16 L8.216 2.936 Z" })
          ], -1)
        ])], 32)),
        w.value ? (o(), s("span", {
          key: 1,
          "aria-hidden": "true",
          class: p(["pointer-events-none absolute inset-x-px top-px z-10 h-[23px] rounded-t-[7px] transition-opacity", F.value])
        }, null, 2)) : x("", !0),
        w.value ? (o(), s("label", {
          key: 2,
          for: a.value,
          class: p(["pointer-events-none absolute left-[15px] top-1 z-20 origin-[0] translate-y-0 scale-75 text-[14px] font-medium leading-[18px] transition-all peer-placeholder-shown:translate-y-[11px] peer-placeholder-shown:scale-100 peer-placeholder-shown:font-normal peer-focus:translate-y-0 peer-focus:scale-75 peer-focus:font-medium", k.value])
        }, D(g.value), 11, Jn)) : x("", !0)
      ]),
      e.error ? (o(), s("div", $n, [
        V(u(ne), {
          class: "size-[12px] shrink-0",
          "aria-hidden": "true"
        }),
        m("span", _n, D(e.error), 1)
      ])) : x("", !0)
    ]));
  }
}), t1 = ["aria-selected", "tabindex", "disabled", "onClick", "onKeydown"], n1 = {
  key: 0,
  class: "pointer-events-none absolute inset-x-0 -bottom-px h-px bg-gray-400 opacity-0 transition-opacity duration-150 group-hover:opacity-100",
  "aria-hidden": "true"
}, rl = /* @__PURE__ */ B({
  __name: "Tabs",
  props: /* @__PURE__ */ W({
    items: {},
    variant: { default: "fit" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = N(e, "modelValue"), l = M(), a = [], i = (C, I) => {
      C && (a[I] = C);
    }, d = r(() => {
      const C = t.items.findIndex((I) => I.value === n.value && !I.disabled);
      return C >= 0 ? C : t.items.findIndex((I) => !I.disabled);
    }), c = M({ left: 0, width: 0 }), v = () => {
      const C = a[t.items.findIndex((I) => I.value === n.value)];
      c.value = C ? { left: C.offsetLeft, width: C.offsetWidth } : { left: 0, width: 0 };
    }, f = () => re(v);
    $(() => [n.value, t.items, t.variant], f, { deep: !0 });
    let g;
    le(() => {
      v(), document.fonts?.ready.then(f), g = new ResizeObserver(v), l.value && g.observe(l.value);
    }), q(() => g?.disconnect());
    const w = (C) => {
      n.value = C;
    }, G = (C) => {
      const I = t.items[C];
      I && (w(I.value), a[C]?.focus());
    }, k = (C, I) => {
      const A = t.items.length;
      for (let y = 1; y <= A; y++) {
        const b = (C + I * y + A) % A;
        if (!t.items[b].disabled) return G(b);
      }
    }, F = (C) => {
      const I = t.items.length;
      for (let A = 0; A < I; A++) {
        const y = C === 1 ? A : I - 1 - A;
        if (!t.items[y].disabled) return G(y);
      }
    }, L = (C, I) => {
      switch (C.key) {
        case "ArrowRight":
        case "ArrowDown":
          C.preventDefault(), k(I, 1);
          break;
        case "ArrowLeft":
        case "ArrowUp":
          C.preventDefault(), k(I, -1);
          break;
        case "Home":
          C.preventDefault(), F(1);
          break;
        case "End":
          C.preventDefault(), F(-1);
          break;
      }
    };
    return (C, I) => (o(), s("div", {
      ref_key: "rootEl",
      ref: l,
      role: "tablist",
      class: "relative flex w-full border-b border-gray-200"
    }, [
      (o(!0), s(j, null, J(e.items, (A, y) => (o(), s("button", {
        key: A.value,
        ref_for: !0,
        ref: (b) => i(b, y),
        type: "button",
        role: "tab",
        "aria-selected": A.value === n.value,
        tabindex: y === d.value ? 0 : -1,
        disabled: A.disabled,
        class: p([
          "group relative flex h-[38px] shrink-0 cursor-pointer items-start px-[10px] text-[14px] font-medium leading-[26px] outline-none transition-colors focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-green-200/50",
          e.variant === "fit" ? "flex-1 justify-center" : "",
          A.disabled ? "pointer-events-none text-gray-500/40" : A.value === n.value ? "text-gray-800" : "text-gray-600"
        ]),
        onClick: (b) => w(A.value),
        onKeydown: (b) => L(b, y)
      }, [
        ee(D(A.label) + " ", 1),
        !A.disabled && A.value !== n.value ? (o(), s("span", n1)) : x("", !0)
      ], 42, t1))), 128)),
      fe(m("span", {
        class: "absolute -bottom-px left-0 h-[2px] bg-green-900 transition-[transform,width] duration-200 ease-out",
        style: Q({ transform: `translateX(${c.value.left}px)`, width: `${c.value.width}px` }),
        "aria-hidden": "true"
      }, null, 4), [
        [$e, c.value.width > 0]
      ])
    ], 512));
  }
}), at = /* @__PURE__ */ Symbol("TabCards"), o1 = {
  role: "tablist",
  class: "flex gap-2.5 tablet-h:gap-[15px]"
}, l1 = /* @__PURE__ */ B({
  __name: "TabCards",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = N(e, "modelValue"), n = We([]), l = (g) => {
      const w = [...n.value, g];
      w.sort((G, k) => {
        const F = G.el.value, L = k.el.value;
        return !F || !L ? 0 : F.compareDocumentPosition(L) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
      }), n.value = w;
    }, a = (g) => {
      n.value = n.value.filter((w) => w.value !== g);
    }, i = r(() => n.value.filter((g) => !g.disabled.value)), d = r(() => {
      const g = i.value;
      return (g.find((G) => G.value === t.value) ?? g[0])?.value;
    }), c = (g) => {
      t.value = g;
    }, v = (g) => {
      c(g.value), g.el.value?.focus();
    };
    return ge(at, {
      selected: t,
      isFocusable: (g) => d.value === g,
      select: c,
      register: l,
      unregister: a,
      onKeydown: (g, w) => {
        const G = i.value, k = G.findIndex((C) => C.value === w);
        if (k < 0) return;
        const F = G.length;
        let L;
        switch (g.key) {
          case "ArrowRight":
          case "ArrowDown":
            g.preventDefault(), L = G[(k + 1) % F];
            break;
          case "ArrowLeft":
          case "ArrowUp":
            g.preventDefault(), L = G[(k - 1 + F) % F];
            break;
          case "Home":
            g.preventDefault(), L = G[0];
            break;
          case "End":
            g.preventDefault(), L = G[F - 1];
            break;
        }
        L && v(L);
      }
    }), (g, w) => (o(), s("div", o1, [
      z(g.$slots, "default")
    ]));
  }
}), s1 = ["aria-selected", "tabindex", "disabled"], a1 = { class: "text-[14px] font-medium leading-[22px]" }, i1 = {
  key: 0,
  class: "text-[18px] font-medium leading-[22px]"
}, r1 = /* @__PURE__ */ B({
  __name: "Card",
  props: {
    value: {},
    label: {},
    disabled: { type: Boolean }
  },
  setup(e) {
    const t = e, n = se(at);
    if (!n) throw new Error("<TabCards.Card> must be used inside <TabCards>");
    const l = n, a = M(), i = r(() => l.selected.value === t.value), d = r(() => l.isFocusable(t.value));
    le(
      () => l.register({ value: t.value, el: a, disabled: r(() => !!t.disabled) })
    ), q(() => l.unregister(t.value));
    const c = () => l.select(t.value), v = (f) => l.onKeydown(f, t.value);
    return (f, g) => (o(), s("button", {
      ref_key: "el",
      ref: a,
      type: "button",
      role: "tab",
      "aria-selected": i.value,
      tabindex: d.value ? 0 : -1,
      disabled: e.disabled,
      class: p([
        "flex h-[64px] shrink-0 cursor-pointer flex-col items-start rounded-[6px] border pl-[10px] pr-[30px] pt-[8px] text-left outline-none transition-colors focus-visible:ring-2 focus-visible:ring-green-200/50",
        e.disabled ? "pointer-events-none border-gray-200/75 text-gray-500/40" : i.value ? "border-gray-800 text-gray-800" : "border-gray-200/75 text-gray-800 hover:border-gray-300/75"
      ]),
      onClick: c,
      onKeydown: v
    }, [
      m("span", a1, D(e.label), 1),
      f.$slots.default ? (o(), s("span", i1, [
        z(f.$slots, "default")
      ])) : x("", !0)
    ], 42, s1));
  }
}), dl = Object.assign(l1, { Card: r1 }), d1 = ["aria-selected", "tabindex", "disabled", "onClick", "onKeydown"], cl = /* @__PURE__ */ B({
  __name: "Segment",
  props: /* @__PURE__ */ W({
    items: {},
    size: { default: "md" },
    block: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = N(e, "modelValue"), l = {
      md: "h-8 text-[14px]",
      sm: "h-7 text-[12px]"
    }, a = {
      md: "size-4",
      sm: "size-3.5"
    }, i = {
      md: "h-7 px-[10px]",
      sm: "h-6 px-[9px]"
    }, d = M(), c = [], v = (y, b) => {
      y && (c[b] = y);
    }, f = r(() => {
      const y = t.items.findIndex((b) => b.value === n.value && !b.disabled);
      return y >= 0 ? y : t.items.findIndex((b) => !b.disabled);
    }), g = M({ left: 0, top: 0, width: 0, height: 0 }), w = () => {
      const y = t.items.findIndex((E) => E.value === n.value), b = c[y];
      g.value = b && !t.items[y]?.disabled ? { left: b.offsetLeft, top: b.offsetTop, width: b.offsetWidth, height: b.offsetHeight } : { left: 0, top: 0, width: 0, height: 0 };
    }, G = () => re(w);
    $(() => [n.value, t.items, t.size], G, { deep: !0 });
    let k;
    le(() => {
      w(), document.fonts?.ready.then(G), k = new ResizeObserver(w), d.value && k.observe(d.value);
    }), q(() => k?.disconnect());
    const F = (y) => {
      n.value = y;
    }, L = (y) => {
      const b = t.items[y];
      b && (F(b.value), c[y]?.focus());
    }, C = (y, b) => {
      const E = t.items.length;
      for (let h = 1; h <= E; h++) {
        const T = (y + b * h + E) % E;
        if (!t.items[T].disabled) return L(T);
      }
    }, I = (y) => {
      const b = t.items.length;
      for (let E = 0; E < b; E++) {
        const h = y === 1 ? E : b - 1 - E;
        if (!t.items[h].disabled) return L(h);
      }
    }, A = (y, b) => {
      switch (y.key) {
        case "ArrowRight":
        case "ArrowDown":
          y.preventDefault(), C(b, 1);
          break;
        case "ArrowLeft":
        case "ArrowUp":
          y.preventDefault(), C(b, -1);
          break;
        case "Home":
          y.preventDefault(), I(1);
          break;
        case "End":
          y.preventDefault(), I(-1);
          break;
      }
    };
    return (y, b) => (o(), s("div", {
      ref_key: "rootEl",
      ref: d,
      role: "tablist",
      class: p([
        "relative items-center rounded-full bg-gray-800/5 p-[2px]",
        e.block ? "flex w-full" : "inline-flex",
        l[e.size]
      ])
    }, [
      fe(m("span", {
        class: "pointer-events-none absolute left-0 rounded-full bg-white shadow-[0_1px_1px_0_rgba(66,68,70,0.08)] transition-[transform,width] duration-200 ease-out",
        style: Q({
          transform: `translateX(${g.value.left}px)`,
          top: `${g.value.top}px`,
          width: `${g.value.width}px`,
          height: `${g.value.height}px`
        }),
        "aria-hidden": "true"
      }, null, 4), [
        [$e, g.value.width > 0]
      ]),
      (o(!0), s(j, null, J(e.items, (E, h) => (o(), s("button", {
        key: E.value,
        ref_for: !0,
        ref: (T) => v(T, h),
        type: "button",
        role: "tab",
        "aria-selected": E.value === n.value,
        tabindex: h === f.value ? 0 : -1,
        disabled: E.disabled,
        class: p([
          "relative z-10 flex cursor-pointer items-center justify-center gap-[2px] rounded-full font-medium leading-none outline-none transition-colors focus-visible:ring-2 focus-visible:ring-green-200/50",
          e.block && "flex-1",
          i[e.size],
          E.disabled ? "pointer-events-none text-gray-800/20" : E.value === n.value ? "text-gray-800" : "text-gray-800/60"
        ]),
        onClick: (T) => F(E.value),
        onKeydown: (T) => A(T, h)
      }, [
        E.icon ? (o(), R(H(E.icon), {
          key: 0,
          class: p(["mr-[3px] shrink-0", a[e.size]]),
          "aria-hidden": "true"
        }, null, 8, ["class"])) : x("", !0),
        ee(" " + D(E.label) + " ", 1),
        E.callout ? (o(), s("span", {
          key: 1,
          class: p(["text-[12px]", E.disabled ? "text-[#1aae39]/50" : "text-[#1aae39]"])
        }, " · " + D(E.callout), 3)) : x("", !0)
      ], 42, d1))), 128))
    ], 2));
  }
}), it = /* @__PURE__ */ Symbol("dacr-menu-selection"), c1 = {
  role: "menu",
  class: "border-[#000071]/8 shdw flex flex-col rounded-[10px] border bg-white p-[4px]"
}, u1 = /* @__PURE__ */ B({
  __name: "Menu",
  props: /* @__PURE__ */ W({
    select: { default: "none" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = N(e, "modelValue"), l = (i) => t.select === "multiple" ? Array.isArray(n.value) && n.value.includes(i) : n.value === i, a = (i) => {
      if (t.select === "single") {
        n.value = i;
        return;
      }
      if (t.select === "multiple") {
        const d = Array.isArray(n.value) ? [...n.value] : [], c = d.indexOf(i);
        c === -1 ? d.push(i) : d.splice(c, 1), n.value = d;
      }
    };
    return ge(it, {
      mode: r(() => t.select),
      isSelected: l,
      toggle: a
    }), (i, d) => (o(), s("div", c1, [
      z(i.$slots, "default", {}, void 0, !0)
    ]));
  }
}), p1 = /* @__PURE__ */ te(u1, [["__scopeId", "data-v-2b4486d7"]]), f1 = {}, g1 = {
  role: "separator",
  class: "py-[4px]"
};
function v1(e, t) {
  return o(), s("div", g1, [...t[0] || (t[0] = [
    m("div", { class: "h-px bg-gray-800/10" }, null, -1)
  ])]);
}
const h1 = /* @__PURE__ */ te(f1, [["render", v1]]), x1 = ["role", "aria-checked", "disabled"], m1 = { class: "flex min-w-0 flex-1 flex-col" }, y1 = { class: "truncate text-[14px] leading-[20px]" }, A1 = /* @__PURE__ */ B({
  __name: "Item",
  props: {
    value: {},
    size: { default: "base" },
    icon: {},
    avatar: {},
    draggable: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(e) {
    const t = e, n = se(it, null), l = r(() => n?.mode.value ?? "none"), a = r(() => t.value !== void 0), i = r(() => l.value === "multiple" && a.value), d = r(
      () => a.value && !!n?.isSelected(t.value)
    ), c = r(() => l.value === "single" && d.value), v = () => {
      t.disabled || n && a.value && l.value !== "none" && n.toggle(t.value);
    }, f = r(
      () => i.value ? "menuitemcheckbox" : l.value === "single" && a.value ? "menuitemradio" : "menuitem"
    ), g = r(
      () => i.value || l.value === "single" && a.value ? d.value : void 0
    ), w = r(() => t.size === "large"), G = r(
      () => w.value ? "min-h-11 items-center py-[4px]" : "items-start py-[6px]"
    ), k = r(
      () => w.value ? "flex size-7 shrink-0 items-center justify-center" : "flex h-5 shrink-0 items-center justify-center"
    ), F = r(() => w.value ? "size-6" : "size-4"), L = r(() => w.value ? 28 : 16);
    return (C, I) => (o(), s("button", {
      type: "button",
      "data-testid": "menu-item",
      role: f.value,
      "aria-checked": g.value,
      disabled: e.disabled,
      class: p(["flex w-full cursor-pointer gap-[10px] rounded-[6px] px-[10px] text-left outline-none transition-colors hover:bg-gray-200/25 focus-visible:bg-gray-200/25", [
        G.value,
        e.disabled ? "pointer-events-none text-gray-300" : "text-gray-800"
      ]]),
      onClick: v
    }, [
      i.value ? (o(), s("span", {
        key: 0,
        class: p(k.value)
      }, [
        V(ke, {
          "model-value": d.value,
          class: "pointer-events-none"
        }, null, 8, ["model-value"])
      ], 2)) : x("", !0),
      e.avatar || e.icon ? (o(), s("span", {
        key: 1,
        class: p(k.value)
      }, [
        e.avatar ? (o(), R(tt, {
          key: 0,
          src: e.avatar,
          size: L.value
        }, null, 8, ["src", "size"])) : (o(), R(H(e.icon), {
          key: 1,
          class: p(F.value),
          "aria-hidden": "true"
        }, null, 8, ["class"]))
      ], 2)) : x("", !0),
      m("span", m1, [
        m("span", y1, [
          z(C.$slots, "default")
        ]),
        C.$slots.description ? (o(), s("span", {
          key: 0,
          class: p(["line-clamp-2 text-[12px] leading-[16px]", e.disabled ? "text-gray-300" : "text-gray-400"])
        }, [
          z(C.$slots, "description")
        ], 2)) : x("", !0)
      ]),
      c.value ? (o(), s("span", {
        key: 2,
        class: p(k.value)
      }, [
        V(u(zt), {
          class: "size-4",
          "aria-hidden": "true"
        })
      ], 2)) : e.draggable ? (o(), s("span", {
        key: 3,
        class: p(k.value)
      }, [
        V(u(Bt), {
          class: "size-4 text-gray-300",
          "aria-hidden": "true"
        })
      ], 2)) : x("", !0)
    ], 10, x1));
  }
}), b1 = { class: "flex items-center px-[10px] py-[4px] text-[12px] font-medium leading-[18px] text-gray-600" }, C1 = /* @__PURE__ */ B({
  __name: "Section",
  props: {
    label: {}
  },
  setup(e) {
    return (t, n) => (o(), s("div", b1, [
      z(t.$slots, "default", {}, () => [
        ee(D(e.label), 1)
      ])
    ]));
  }
}), Le = Object.assign(p1, { Item: A1, Section: C1, Divider: h1 }), w1 = { class: "flex w-full flex-col gap-[6px]" }, k1 = {
  key: 0,
  class: "flex items-center gap-[6px]"
}, L1 = ["for"], E1 = {
  type: "button",
  "aria-label": "More information",
  class: "flex rounded-full text-gray-500 outline-none focus-visible:ring-2 focus-visible:ring-green-200/50"
}, I1 = {
  key: 1,
  class: "relative w-full"
}, F1 = ["for"], z1 = ["id", "disabled"], B1 = {
  key: 0,
  value: "",
  disabled: "",
  hidden: ""
}, G1 = {
  key: 1,
  value: "",
  disabled: "",
  hidden: ""
}, T1 = ["value"], M1 = { class: "relative w-full" }, R1 = ["for"], D1 = ["id", "disabled", "aria-expanded"], Xe = "w-full appearance-none rounded-[6px] border bg-white leading-[18px] text-[14px] outline-none transition-colors", V1 = /* @__PURE__ */ B({
  __name: "Select",
  props: /* @__PURE__ */ W({
    items: { default: () => [] },
    size: { default: "md" },
    placeholder: {},
    label: {},
    hint: {},
    disabled: { type: Boolean },
    menu: { type: Boolean }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Le.Item, n = e, l = N(e, "modelValue"), a = pe(), i = r(
      () => n.items.find((S) => S.value === l.value) ?? null
    ), d = r(() => n.label || n.placeholder || ""), c = r(
      () => n.size === "xl" && !!d.value
    ), v = r(() => !!l.value), f = r(
      () => (
        // nbsp when the floating label owns the placeholder slot, so the empty trigger
        // keeps its line height (and full 48px) instead of collapsing.
        i.value ? i.value.label : c.value ? " " : n.placeholder ?? ""
      )
    ), g = {
      md: "py-[5px] pl-[10px] pr-[31px]",
      lg: "py-[9px] pl-[14px] pr-[35px]",
      xl: "py-[14px] pl-[16px] pr-[38px]"
    }, w = r(
      () => c.value ? "pt-[21px] pb-[7px] pl-[16px] pr-[38px]" : g[n.size]
    ), G = {
      md: "right-[8px] size-[15px]",
      lg: "right-[12px] size-[15px]",
      xl: "right-[12px] size-[18px]"
    }, k = r(() => [
      "pointer-events-none absolute top-1/2 -translate-y-1/2",
      G[n.size],
      n.disabled ? "text-gray-800/50" : "text-gray-800"
    ]), F = r(() => [
      "pointer-events-none absolute left-[16px] top-[5px] origin-[0] text-[14px] leading-[18px] transition-all",
      v.value ? "translate-y-0 scale-75 font-medium" : "translate-y-[10px] scale-100 font-normal",
      n.disabled ? "text-gray-500/40" : "text-gray-500/70"
    ]), L = r(
      () => n.disabled ? "border-gray-200/50 bg-gray-800/[0.03]" : "border-gray-200 bg-white hover:border-gray-300"
    ), C = M(!1), I = M(), A = M(), { floatingStyles: y } = De(I, A, {
      placement: "bottom-end",
      whileElementsMounted: Ve,
      // Position via top/left, not transform, so the popover transform is free for
      // the open/close slide animation below.
      transform: !1,
      middleware: [
        Se(3),
        Ze({ padding: 8 }),
        Ue({ padding: 8 }),
        // Match the trigger width; cap height + scroll on the Menu itself so the
        // floating wrapper stays overflow-visible and never clips the Menu's shadow.
        Dt({
          padding: 8,
          apply({ rects: S, elements: P, availableHeight: O }) {
            P.floating.style.minWidth = `${S.reference.width}px`;
            const ae = P.floating.querySelector('[role="menu"]');
            ae instanceof HTMLElement && (ae.style.maxHeight = `${O}px`, ae.style.overflowY = "auto");
          }
        })
      ]
    }), b = (S) => {
      l.value = S;
    }, E = (S) => {
      b(S.value), h();
    }, h = () => {
      C.value = !1, I.value?.focus();
    }, T = () => {
      n.disabled || (C.value ? C.value = !1 : Z());
    }, Z = () => {
      C.value = !0, re(
        () => A.value?.querySelector('[role="menuitem"]')?.focus()
      );
    }, Y = (S) => {
      S.key === "ArrowDown" || S.key === "Enter" || S.key === " " ? (S.preventDefault(), C.value ? h() : Z()) : S.key === "Escape" && (C.value = !1);
    }, ye = (S) => {
      const P = S.target;
      I.value?.contains(P) || A.value?.contains(P) || (C.value = !1);
    }, ve = (S) => {
      S.key === "Escape" && h();
    };
    return $(C, (S) => {
      const P = S ? "addEventListener" : "removeEventListener";
      document[P]("pointerdown", ye), document[P]("keydown", ve);
    }), q(() => {
      document.removeEventListener("pointerdown", ye), document.removeEventListener("keydown", ve);
    }), (S, P) => (o(), s("div", w1, [
      e.label && !c.value ? (o(), s("div", k1, [
        m("label", {
          for: u(a),
          class: "text-[14px] font-medium leading-[18px] text-gray-800"
        }, D(e.label), 9, L1),
        e.hint ? (o(), R(me, {
          key: 0,
          content: e.hint,
          size: "lg",
          placement: "top"
        }, {
          default: U(() => [
            m("button", E1, [
              V(u(xe), {
                class: "size-[12px]",
                "aria-hidden": "true"
              })
            ])
          ]),
          _: 1
        }, 8, ["content"])) : x("", !0)
      ])) : x("", !0),
      e.menu ? (o(), s(j, { key: 2 }, [
        m("div", M1, [
          c.value ? (o(), s("label", {
            key: 0,
            for: u(a),
            class: p(F.value)
          }, D(d.value), 11, R1)) : x("", !0),
          m("button", {
            id: u(a),
            ref_key: "reference",
            ref: I,
            type: "button",
            disabled: e.disabled,
            "aria-expanded": C.value,
            "aria-haspopup": "menu",
            class: p([
              Xe,
              "flex items-center text-left",
              w.value,
              L.value,
              !e.disabled && "cursor-pointer",
              !e.disabled && (C.value ? "border-green-500! ring-2 ring-green-200/50" : "focus-visible:border-green-500 focus-visible:ring-2 focus-visible:ring-green-200/50")
            ]),
            onClick: T,
            onKeydown: Y
          }, [
            i.value && i.value.icon ? (o(), R(H(i.value.icon), {
              key: 0,
              class: "mr-[8px] size-[15px] shrink-0",
              "aria-hidden": "true"
            })) : x("", !0),
            m("span", {
              class: p([
                "min-w-0 flex-1 truncate",
                e.disabled ? "text-gray-800/50" : i.value ? "text-gray-800" : "text-gray-500/70"
              ])
            }, [
              z(S.$slots, "value", {
                selected: i.value,
                value: l.value
              }, () => [
                ee(D(f.value), 1)
              ], !0)
            ], 2)
          ], 42, D1),
          V(u(je), {
            class: p(k.value),
            "aria-hidden": "true"
          }, null, 8, ["class"])
        ]),
        (o(), R(ue, { to: "body" }, [
          V(oe, { name: "select-popover" }, {
            default: U(() => [
              C.value ? (o(), s("div", {
                key: 0,
                ref_key: "floating",
                ref: A,
                class: "z-[999]",
                style: Q(u(y))
              }, [
                V(u(Le), null, {
                  default: U(() => [
                    z(S.$slots, "default", {
                      select: b,
                      close: h,
                      selected: l.value
                    }, () => [
                      (o(!0), s(j, null, J(e.items, (O) => (o(), R(u(t), {
                        key: O.value,
                        label: O.label,
                        icon: O.icon,
                        selected: O.value === l.value,
                        onClick: (ae) => E(O)
                      }, null, 8, ["label", "icon", "selected", "onClick"]))), 128))
                    ], !0)
                  ]),
                  _: 3
                })
              ], 4)) : x("", !0)
            ]),
            _: 3
          })
        ]))
      ], 64)) : (o(), s("div", I1, [
        c.value ? (o(), s("label", {
          key: 0,
          for: u(a),
          class: p(F.value)
        }, D(d.value), 11, F1)) : x("", !0),
        fe(m("select", {
          id: u(a),
          "onUpdate:modelValue": P[0] || (P[0] = (O) => l.value = O),
          disabled: e.disabled,
          class: p([
            Xe,
            w.value,
            L.value,
            e.disabled ? "text-gray-800/50" : l.value ? "text-gray-800" : "text-gray-500/70",
            !e.disabled && "cursor-pointer focus:border-green-500 focus:ring-2 focus:ring-green-200/50"
          ])
        }, [
          c.value ? (o(), s("option", B1, " ")) : e.placeholder ? (o(), s("option", G1, D(e.placeholder), 1)) : x("", !0),
          (o(!0), s(j, null, J(e.items, (O) => (o(), s("option", {
            key: O.value,
            value: O.value
          }, D(O.label), 9, T1))), 128))
        ], 10, z1), [
          [mt, l.value]
        ]),
        V(u(je), {
          class: p(k.value),
          "aria-hidden": "true"
        }, null, 8, ["class"])
      ]))
    ]));
  }
}), ul = /* @__PURE__ */ te(V1, [["__scopeId", "data-v-57a8403f"]]), S1 = {
  sm: {
    text: "text-[12px] leading-[16px]",
    sep: "size-[9px]",
    menu: "size-[13px]",
    trigger: "size-[16px]"
  },
  md: {
    text: "text-[14px] leading-[20px]",
    sep: "size-[11px]",
    menu: "size-[16px]",
    trigger: "size-[20px]"
  },
  lg: {
    text: "text-[22px] leading-[26px]",
    sep: "size-[16px]",
    menu: "size-[22px]",
    trigger: "size-[26px]"
  }
};
function Z1(e, t) {
  const n = r(() => e.items.length - 1), l = r(() => S1[e.size]), a = r(() => l.value.text), i = r(() => l.value.sep), d = r(() => l.value.menu), c = r(() => l.value.trigger), v = (Z, Y) => {
    t("select", Z, Y);
  }, f = M(), g = M(), w = M(0), G = r(
    () => e.collapse && e.items.length > e.maxVisible ? e.items.length - e.maxVisible : 0
  ), k = r(
    () => e.items.slice(0, w.value).map((Z, Y) => ({ item: Z, index: Y }))
  ), F = r(
    () => e.items.map((Z, Y) => ({ item: Z, index: Y })).slice(w.value)
  ), L = () => {
    if (!e.collapse || !f.value || !g.value) {
      w.value = 0;
      return;
    }
    const Z = f.value.clientWidth, Y = Array.from(
      g.value.querySelectorAll("[data-bc-unit]")
    ).map((O) => O.offsetWidth), ye = g.value.querySelector("[data-bc-ellipsis]")?.offsetWidth ?? 0, ve = e.items.length, S = (O) => {
      let ae = O > 0 ? ye : 0;
      for (let Ge = O; Ge < ve; Ge++) ae += Y[Ge];
      return ae;
    };
    let P = G.value;
    for (; P < ve - 1 && S(P) > Z; ) P++;
    w.value = P;
  };
  let C;
  le(() => {
    L(), re(L), typeof ResizeObserver < "u" && f.value && (C = new ResizeObserver(() => L()), C.observe(f.value)), document.fonts?.ready.then(() => L());
  }), q(() => C?.disconnect()), $(
    () => [e.items, e.maxVisible, e.collapse],
    () => re(L),
    { deep: !0 }
  );
  const I = M(!1), A = M(), y = M(), { floatingStyles: b } = De(A, y, {
    placement: "bottom-start",
    whileElementsMounted: Ve,
    transform: !1,
    middleware: [Se(3), Ze({ padding: 8 }), Ue({ padding: 8 })]
  }), E = (Z) => {
    I.value = !1, t("select", Z.item, Z.index);
  }, h = (Z) => {
    const Y = Z.target;
    A.value?.contains(Y) || y.value?.contains(Y) || (I.value = !1);
  }, T = (Z) => {
    Z.key === "Escape" && (I.value = !1);
  };
  return $(I, (Z) => {
    const Y = Z ? "addEventListener" : "removeEventListener";
    document[Y]("pointerdown", h), document[Y]("keydown", T);
  }), q(() => {
    document.removeEventListener("pointerdown", h), document.removeEventListener("keydown", T);
  }), {
    lastIndex: n,
    textClass: a,
    sepIconClass: i,
    menuIconClass: d,
    triggerClass: c,
    container: f,
    measureRef: g,
    hidden: w,
    hiddenItems: k,
    visibleItems: F,
    open: I,
    ellipsisTrigger: A,
    floating: y,
    floatingStyles: b,
    select: v,
    choose: E
  };
}
const U1 = ["aria-expanded"], O1 = {
  key: 0,
  "aria-current": "page",
  class: "font-medium text-gray-800"
}, Y1 = ["href", "onClick"], P1 = ["onClick"], j1 = {
  "data-bc-ellipsis": "",
  class: "flex items-center"
}, be = "mx-[4px] flex items-center", Te = "cursor-pointer text-gray-500 outline-none hover:text-gray-600 hover:underline focus-visible:underline", Q1 = /* @__PURE__ */ B({
  __name: "Breadcrumb",
  props: {
    items: {},
    size: { default: "md" },
    collapse: { type: Boolean, default: !1 },
    maxVisible: { default: 4 }
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = Le.Item, l = e, a = t, {
      lastIndex: i,
      textClass: d,
      menuIconClass: c,
      triggerClass: v,
      container: f,
      measureRef: g,
      hidden: w,
      hiddenItems: G,
      visibleItems: k,
      open: F,
      ellipsisTrigger: L,
      floating: C,
      floatingStyles: I,
      select: A,
      choose: y
    } = Z1(l, a);
    return (b, E) => (o(), s("div", {
      ref_key: "container",
      ref: f,
      class: p(["relative", e.collapse ? "w-full overflow-hidden" : "w-fit"])
    }, [
      m("nav", {
        "aria-label": "Breadcrumb",
        class: p(["flex w-fit items-center whitespace-nowrap", u(d)])
      }, [
        u(w) > 0 ? (o(), s(j, { key: 0 }, [
          m("div", {
            ref_key: "ellipsisTrigger",
            ref: L,
            class: "flex items-center"
          }, [
            m("button", {
              type: "button",
              "aria-label": "Show more",
              "aria-expanded": u(F),
              class: p([
                "flex cursor-pointer items-center justify-center rounded-[4px] text-gray-500 outline-none transition-colors hover:bg-gray-800/[0.06] hover:text-gray-600 focus-visible:bg-gray-800/[0.06]",
                u(v)
              ]),
              onClick: E[0] || (E[0] = _((h) => F.value = !u(F), ["stop"]))
            }, [
              V(u(Qe), {
                class: p(u(c)),
                "aria-hidden": "true"
              }, null, 8, ["class"])
            ], 10, U1)
          ], 512),
          m("span", {
            class: p(be),
            "aria-hidden": "true"
          }, [...E[1] || (E[1] = [
            m("span", { class: "text-gray-500" }, "/", -1)
          ])])
        ], 64)) : x("", !0),
        (o(!0), s(j, null, J(u(k), (h) => (o(), s(j, {
          key: h.index
        }, [
          h.index === u(i) ? (o(), s("span", O1, D(h.item.label), 1)) : h.item.href ? (o(), s("a", {
            key: 1,
            href: h.item.href,
            class: p(Te),
            onClick: (T) => u(A)(h.item, h.index)
          }, D(h.item.label), 9, Y1)) : (o(), s("button", {
            key: 2,
            type: "button",
            class: p(Te),
            onClick: (T) => u(A)(h.item, h.index)
          }, D(h.item.label), 9, P1)),
          h.index < u(i) ? (o(), s("span", {
            key: 3,
            class: p(be),
            "aria-hidden": "true"
          }, [...E[2] || (E[2] = [
            m("span", { class: "text-gray-500" }, "/", -1)
          ])])) : x("", !0)
        ], 64))), 128))
      ], 2),
      e.collapse ? (o(), s("nav", {
        key: 0,
        ref_key: "measureRef",
        ref: g,
        "aria-hidden": "true",
        class: p([
          "invisible pointer-events-none absolute left-0 top-0 flex w-max items-center whitespace-nowrap",
          u(d)
        ])
      }, [
        m("span", j1, [
          m("span", {
            class: p(["flex items-center justify-center", u(v)])
          }, [
            V(u(Qe), {
              class: p(u(c))
            }, null, 8, ["class"])
          ], 2),
          m("span", {
            class: p(be)
          }, "/")
        ]),
        (o(!0), s(j, null, J(e.items, (h, T) => (o(), s("span", {
          key: T,
          "data-bc-unit": "",
          class: "flex items-center"
        }, [
          m("span", {
            class: p(T === u(i) ? "font-medium" : Te)
          }, D(h.label), 3),
          T < u(i) ? (o(), s("span", {
            key: 0,
            class: p(be)
          }, "/")) : x("", !0)
        ]))), 128))
      ], 2)) : x("", !0),
      (o(), R(ue, { to: "body" }, [
        V(oe, { name: "bc-popover" }, {
          default: U(() => [
            u(F) ? (o(), s("div", {
              key: 0,
              ref_key: "floating",
              ref: C,
              class: "z-[999]",
              style: Q(u(I))
            }, [
              V(u(Le), null, {
                default: U(() => [
                  (o(!0), s(j, null, J(u(G), (h) => (o(), R(u(n), {
                    key: h.index,
                    onClick: (T) => u(y)(h)
                  }, {
                    default: U(() => [
                      ee(D(h.item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))), 128))
                ]),
                _: 1
              })
            ], 4)) : x("", !0)
          ]),
          _: 1
        })
      ]))
    ], 2));
  }
}), pl = /* @__PURE__ */ te(Q1, [["__scopeId", "data-v-b364bf48"]]), K1 = { class: "relative w-fit" }, X1 = {
  "aria-label": "Breadcrumb",
  class: "flex w-fit items-center whitespace-nowrap text-[14px] leading-[18px]"
}, H1 = {
  key: 0,
  "aria-current": "page",
  class: "font-medium text-gray-600"
}, N1 = ["href", "onClick"], q1 = ["onClick"], W1 = "mx-[4px] flex items-center", He = "cursor-pointer font-medium text-green-700 outline-none hover:text-green-600 focus-visible:underline", fl = /* @__PURE__ */ B({
  __name: "LinkBreadcrumb",
  props: {
    items: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, l = t, a = r(() => n.items.length - 1);
    return (i, d) => (o(), s("div", K1, [
      m("nav", X1, [
        (o(!0), s(j, null, J(e.items, (c, v) => (o(), s(j, { key: v }, [
          v === a.value ? (o(), s("span", H1, D(c.label), 1)) : c.href ? (o(), s("a", {
            key: 1,
            href: c.href,
            class: p(He),
            onClick: (f) => l("select", c, v)
          }, D(c.label), 9, N1)) : (o(), s("button", {
            key: 2,
            type: "button",
            class: p(He),
            onClick: (f) => l("select", c, v)
          }, D(c.label), 9, q1)),
          v < a.value ? (o(), s("span", {
            key: 3,
            class: p(W1),
            "aria-hidden": "true"
          }, [
            V(u(et), { class: "size-[11px] text-gray-400" })
          ])) : x("", !0)
        ], 64))), 128))
      ])
    ]));
  }
}), J1 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>3d</title>
    <g id="Files/3D-File" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Group" transform="translate(6.5, 0)" fill="#000000">
            <g id="Icons/Audio" transform="translate(8, 14)">
                <g id="Outline" transform="translate(0.25, 0.25)">
                    <path d="M0,6.09090909 L0,18.9090909 C0,19.2031985 0.171902078,19.4701632 0.439647792,19.5918658 L12.1896478,24.9327749 C12.6862222,25.1584905 13.25,24.7954665 13.25,24.25 L13.25,11.4318182 C13.25,11.1377106 13.0780979,10.8707459 12.8103522,10.7490433 L1.06035221,5.40813423 C0.563777768,5.18241858 0,5.54544256 0,6.09090909 Z M1.5,7.255 L11.75,11.914 L11.75,23.085 L1.5,18.426 L1.5,7.255 Z" id="Stroke-1" fill-rule="nonzero"></path>
                    <path d="M23.9396478,5.40813423 L12.1896478,10.7490433 C11.9219021,10.8707459 11.75,11.1377106 11.75,11.4318182 L11.75,24.25 C11.75,24.7954665 12.3137778,25.1584905 12.8103522,24.9327749 L24.5603522,19.5918658 C24.8280979,19.4701632 25,19.2031985 25,18.9090909 L25,6.09090909 C25,5.54544256 24.4362222,5.18241858 23.9396478,5.40813423 Z M23.5,7.255 L23.5,18.426 L13.25,23.085 L13.25,11.914 L23.5,7.255 Z" id="Stroke-3" fill-rule="nonzero"></path>
                    <path d="M12.1896478,0.0672251419 C12.3539759,-0.00746946021 12.5385285,-0.0199185606 12.7095981,0.0298778408 L12.8103522,0.0672251419 L24.5603522,5.40813423 L23.9396478,6.77368395 L12.5,1.573 L1.06035221,6.77368395 L0.439647792,5.40813423 L12.1896478,0.0672251419 Z" id="Stroke-5" fill-rule="nonzero"></path>
                </g>
            </g>
        </g>
    </g>
</svg>`, $1 = "data:image/png;base64,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", _1 = "data:image/png;base64,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", e0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>after-effects</title>
    <g id="Files/Adobe-After-Effects" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Icons/File-Types/Adobe-Photoshop" transform="translate(14, 14)" fill="#9A99FF">
            <g id="After-Effects-2026" transform="translate(-1.4, 5)">
                <path d="M5.88854709,0 L10.98966,0 L16.7119351,15.9746921 L12.0406238,15.9746921 L11.2531848,13.5433514 L5.27051556,13.5433514 L4.48307659,15.9746921 L0,15.9746921 L5.88854709,0 Z M10.010846,9.75046104 L8.26969609,4.38582474 L6.52854141,9.75046104 L10.010846,9.75046104 Z" id="Vector-2" fill-rule="nonzero"></path>
                <path d="M28.7149179,9.39283421 C28.7149179,9.96380717 28.6678581,10.5849766 28.5957022,11.0618331 L20.799724,11.0618331 C21.2765805,12.2539744 22.4216669,12.8249459 24.2098787,12.8249459 C25.4961363,12.8249459 26.6192589,12.5865175 27.7392442,12.0626028 L27.7863005,15.3755023 C26.5690615,15.9966707 25.2577071,16.21 23.5667489,16.21 C19.3942545,16.21 16.6052707,13.8978745 16.6052707,9.70028223 C16.6052707,5.86033242 19.2750427,3.30977654 22.8044082,3.30977654 C26.3337737,3.30977654 28.7180534,5.64700117 28.7180534,9.38969752 L28.7149179,9.39283421 Z M20.6585503,8.3450047 L24.8310457,8.3450047 C24.7369292,7.22501934 24.0436034,6.43757924 22.8295017,6.43757924 C21.6154,6.43757924 20.9220763,7.05874701 20.6585503,8.3450047 Z" id="Vector-3" fill-rule="nonzero"></path>
            </g>
        </g>
    </g>
</svg>`, t0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>audio</title>
    <g id="Files/Audio" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Icons/Audio" transform="translate(14, 14)" fill="#2D2D2D">
            <g id="Outlines" transform="translate(2.75, 1)">
                <polygon id="Path" fill-rule="nonzero" points="1.5 7.75 1.5 16.25 0 16.25 0 7.75"></polygon>
                <polygon id="Path" fill-rule="nonzero" points="10.5 7.75 10.5 16.25 9 16.25 9 7.75"></polygon>
                <polygon id="Path" fill-rule="nonzero" points="20.5 7.75 20.5 16.25 19 16.25 19 7.75"></polygon>
                <polygon id="Path" fill-rule="nonzero" points="6 0 6 24 4.5 24 4.5 0"></polygon>
                <polygon id="Path" fill-rule="nonzero" points="15.5 4.5 15.5 19.5 14 19.5 14 4.5"></polygon>
            </g>
        </g>
    </g>
</svg>`, n0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>audition</title>
    <g id="Files/Adobe-Audition" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Icons/File-Types/Adobe-Photoshop" transform="translate(14, 14)" fill="#9A99FF">
            <g id="Audition-2026" transform="translate(-1.4, 5)">
                <path d="M5.87832227,0 L10.9705503,0 L16.6828991,15.9469334 L12.0197018,15.9469334 L11.2336266,13.5198183 L5.26135533,13.5198183 L4.47528016,15.9469334 L0,15.9469334 L5.87832227,0 Z M9.99657704,9.7335151 L8.25845329,4.37820592 L6.52032953,9.7335151 L9.99657704,9.7335151 Z" id="Vector-2" fill-rule="nonzero"></path>
                <path d="M17.1150835,11.1616021 L17.1150835,3.52323137 L21.2803226,3.52323137 L21.2803226,10.9736945 C21.2803226,12.3078249 21.9223245,12.8527514 22.993387,12.8527514 C23.4944689,12.8527514 23.9203999,12.8276976 24.2774207,12.6867684 L24.2774207,3.52323137 L28.4426598,3.52323137 L28.4426598,14.9009212 C26.8485931,15.7089157 25.1355066,16.21 22.9683276,16.21 C18.9001693,16.21 17.1150835,14.590879 17.1150835,11.1647321 L17.1150835,11.1616021 Z" id="Vector-3" fill-rule="nonzero"></path>
            </g>
        </g>
    </g>
</svg>`, o0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>autocad</title>
    <g id="Files/Autodesk-Autocad" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="File-Types/Autodesk" transform="translate(14, 14)">
            <g id="Group" transform="translate(1, 2)">
                <path d="M2.11398964,4 L24,4 L24,22 L3.40725389,22 C2.69299896,22 2.11398964,21.417975 2.11398964,20.7 L2.11398964,4 Z" id="Path" fill="#78082A"></path>
                <path d="M3.87979275,0 L20.9409326,0 C21.6551876,0 22.2341969,0.58203 22.2341969,1.3 L22.2341969,18 L3.87979275,18 L3.87979275,0 Z" id="Path" fill="#E51050"></path>
                <polygon id="Path" fill="#E85984" points="0 2.35 3.87979275 0 3.87979275 18 0 20.35"></polygon>
                <path d="M15.0786155,14 L14.4675233,11.814275 L11.4830674,11.814275 L10.9288041,14 L8.45595855,14 L11.2983047,3.999975 L14.6096332,3.999975 L17.608315,14 L15.0786155,14 Z M13.984315,9.957125 L12.9468684,5.642825 L11.9378238,9.957125 L13.984315,9.957125 Z" id="Shape" fill="#FFFFFF" fill-rule="nonzero"></path>
            </g>
        </g>
    </g>
</svg>`, l0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>autodesk</title>
    <g id="Files/Autodesk" stroke="none" fill="none" fill-rule="evenodd">
        <g id="File-Types/Autodesk" transform="translate(14, 14)" fill="#000000">
            <path d="M15.6590639,5 L1,13.8725304 L1,21 L1.12668894,21 L15.8250372,12.0892264 L23.4530938,12.0892264 C23.6883853,12.0892264 23.9038167,12.2701189 23.9038167,12.5281241 C23.9038167,12.7376599 23.8059557,12.8239383 23.6887614,12.8905191 L16.4711852,17.1073345 C16.0010813,17.3839434 15.8348544,17.9276962 15.8348544,18.3379568 L15.824333,21 L25,21 L25,5.5536363 C25,5.25793613 24.7652184,5 24.4127699,5 L15.6590639,5 Z" id="Autodesk-logo"></path>
        </g>
    </g>
</svg>`, s0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>cinema4d</title>
    <defs>
        <linearGradient x1="80.8992046%" y1="0%" x2="-15.2630345%" y2="124.569834%" id="linearGradient-1">
            <stop stop-color="#71D0FF" offset="0%"></stop>
            <stop stop-color="#2D12D3" offset="100%"></stop>
        </linearGradient>
        <radialGradient cx="85.0178011%" cy="9.44484911%" fx="85.0178011%" fy="9.44484911%" r="108.334381%" gradientTransform="translate(0.8502, 0.0944), scale(1, 1), rotate(135.0001), translate(-0.8502, -0.0944)" id="radialGradient-2">
            <stop stop-color="#71D0FF" offset="0%"></stop>
            <stop stop-color="#524CF6" offset="100%"></stop>
        </radialGradient>
    </defs>
    <g id="Files/Cinema-4D" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Icons/File-Types/Cinema-4D" transform="translate(14, 14)">
            <g id="Group" transform="translate(1, 1)">
                <path d="M23.9979969,11.9769265 C23.9979969,11.1289355 23.9937905,10.3187193 23.8259346,9.48120355 C23.7418063,9.05510499 23.6390496,8.30577722 23.3808558,7.78311849 C23.2758957,7.56902771 23.1436941,7.39269172 22.9758382,7.29194547 C21.7101079,6.53420549 20.8536017,9.01312405 20.7236035,9.86532116 C19.9175743,15.2136451 18.443927,17.5141848 16.8571071,19.2058405 C16.8571071,19.2058405 16.855104,19.2080437 16.8508976,19.2142527 C16.752147,19.319205 16.6535967,19.4199513 16.5548461,19.5206975 C15.8411578,20.2113001 13.8933273,21.7982037 11.0554796,21.8380616 C8.78645935,21.8066159 6.52791507,20.9333482 4.79623426,19.2016344 C3.06455344,17.4701208 2.19138186,15.2114419 2.15989384,12.9425483 C2.19977466,10.1067116 3.78871779,8.15674087 4.47718771,7.44308488 C4.57794136,7.34442165 4.67869501,7.24577846 4.78365507,7.14711523 C4.78994467,7.14290912 4.79204787,7.1408261 4.79204787,7.1408261 C6.48595108,5.55187948 8.78435614,4.07836042 14.1326323,3.27235036 C14.9848519,3.14430448 17.461629,2.28581825 16.7060768,1.02012088 C16.6053231,0.852197106 16.428854,0.719965149 16.2149278,0.615012794 C15.6921305,0.35683801 14.9407847,0.253988707 14.516738,0.170026822 C13.681344,0.00420610586 12.8711285,0 12.0231153,0 C5.38397056,0 2.27390375e-13,5.38395571 2.27390375e-13,12.0231136 C2.27390375e-13,15.2262635 1.2300358,18.2194085 3.48227046,20.4947115 L3.50534565,20.4947115 L3.50534565,20.5177449 C5.78067553,22.7700145 8.77386014,24 11.9769448,24 C18.6139863,24 24,18.6161845 24,11.9769265 L23.9979969,11.9769265 Z" id="Path" fill="url(#linearGradient-1)"></path>
                <path d="M16.3849871,16.2862021 L16.4436766,16.233726 C17.2224643,15.526299 17.6443076,14.7497718 17.7512707,14.539867 C18.4166854,13.0789463 18.798668,11.4753183 19.038033,9.90105303 C19.0402364,9.88006256 19.4031899,7.80414902 20.5765793,7.25210764 C20.6206465,7.23111717 20.6647137,7.21433281 20.7087809,7.19963147 C20.3540399,6.4334993 19.8608879,5.7156372 19.2291244,5.08384004 C19.1828539,5.03765299 19.1367836,4.99567205 19.090513,4.94950503 C19.0464458,4.90331798 19.0023786,4.85504791 18.9561081,4.81096392 C18.3243446,4.17916676 17.6064498,3.68589068 16.8404817,3.33115573 C16.8256591,3.37523972 16.8088335,3.41932372 16.7880017,3.46340771 C16.2337565,4.63675102 14.1578507,4.99987816 14.1389619,5.00198121 C12.5647012,5.23916552 10.9610556,5.62328313 9.50014773,6.28866905 C9.30913643,6.3852092 8.65425774,6.74204721 8.00566864,7.38644265 C7.99725582,7.39483484 7.99096622,7.40114399 7.98257342,7.40743312 C7.96997421,7.42003141 7.957375,7.43471272 7.94269261,7.44941407 C7.90910138,7.48510588 7.87342698,7.52077766 7.83983575,7.55857253 C5.67156914,9.88635169 5.77650918,13.5868836 8.11481509,15.9252782 C10.3901249,18.2005812 13.9584466,18.3600126 16.292446,16.3681211 C16.3240942,16.3408815 16.3555422,16.3156449 16.3869902,16.2884053 L16.3849871,16.2862021 Z" id="Path" fill="url(#radialGradient-2)"></path>
            </g>
        </g>
    </g>
</svg>`, a0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>code</title>
    <g id="Files/Code" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Group" transform="translate(6.5, 0)" fill="#2D2D2D">
            <g id="Icons/Audio" transform="translate(8, 14)">
                <g id="Outline" transform="translate(1.9393, 4.9393)">
                    <polygon id="Stroke-1" fill-rule="nonzero" points="21.8106602 13.6439935 21.8106602 15.1439935 10.3106602 15.1439935 10.3106602 13.6439935"></polygon>
                    <polygon id="Stroke-3" fill-rule="nonzero" points="0 1.06066017 1.06066017 0 8.78798701 7.72732684 1.06066017 15.4546537 0 14.3939935 6.66666017 7.72666017"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>`, i0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>excel</title>
    <defs>
        <radialGradient cx="100.291081%" cy="107.89409%" fx="100.291081%" fy="107.89409%" r="140.859029%" gradientTransform="translate(1.0029, 1.0789), scale(0.9807, 1), rotate(-133.1343), scale(1, 0.7758), translate(-1.0029, -1.0789)" id="radialGradient-1">
            <stop stop-color="#379539" offset="0%"></stop>
            <stop stop-color="#379539" offset="5.99999987%"></stop>
            <stop stop-color="#297C2D" offset="41.9999987%"></stop>
            <stop stop-color="#15561C" offset="69.9999988%"></stop>
            <stop stop-color="#15561C" offset="100%"></stop>
        </radialGradient>
        <radialGradient cx="30.2469239%" cy="36.3701451%" fx="30.2469239%" fy="36.3701451%" r="57.0356692%" gradientTransform="translate(0.3025, 0.3637), scale(0.9807, 1), rotate(-135.5538), scale(1, 0.7737), translate(-0.3025, -0.3637)" id="radialGradient-2">
            <stop stop-color="#073B10" stop-opacity="0.698038995" offset="0%"></stop>
            <stop stop-color="#084A13" stop-opacity="0" offset="99.000001%"></stop>
            <stop stop-color="#084A13" stop-opacity="0" offset="100%"></stop>
        </radialGradient>
        <linearGradient x1="0.000124825358%" y1="49.999247%" x2="76.5796805%" y2="49.999247%" id="linearGradient-3">
            <stop stop-color="#52D17C" offset="0%"></stop>
            <stop stop-color="#4AA647" offset="33.0000013%"></stop>
            <stop stop-color="#4AA647" offset="100%"></stop>
        </linearGradient>
        <linearGradient x1="49.9982763%" y1="-0.000744800004%" x2="49.9982763%" y2="69.4592512%" id="linearGradient-4">
            <stop stop-color="#29852F" stop-opacity="0.301961005" offset="0%"></stop>
            <stop stop-color="#4AA647" stop-opacity="0" offset="50%"></stop>
            <stop stop-color="#4AA647" stop-opacity="0" offset="100%"></stop>
        </linearGradient>
        <linearGradient x1="5.72065073%" y1="81.9119951%" x2="95.4996303%" y2="1.7839887%" id="linearGradient-5">
            <stop stop-color="#66D052" offset="0%"></stop>
            <stop stop-color="#85E972" offset="100%"></stop>
        </linearGradient>
        <radialGradient cx="97.4798315%" cy="41.2433906%" fx="97.4798315%" fy="41.2433906%" r="50.1268677%" gradientTransform="translate(0.9748, 0.4124), scale(1, 0.9857), rotate(180), scale(1, 2.1164), translate(-0.9748, -0.4124)" id="radialGradient-6">
            <stop stop-color="#4EB43B" offset="0%"></stop>
            <stop stop-color="#4EB43B" offset="28.9999992%"></stop>
            <stop stop-color="#72CC61" stop-opacity="0" offset="100%"></stop>
        </radialGradient>
        <linearGradient x1="45.0826911%" y1="50%" x2="0.000123607999%" y2="50%" id="linearGradient-7">
            <stop stop-color="#C0E075" stop-opacity="0" offset="0%"></stop>
            <stop stop-color="#C0E075" stop-opacity="0" offset="18.0000007%"></stop>
            <stop stop-color="#D1EB95" offset="100%"></stop>
        </linearGradient>
        <radialGradient cx="114.079729%" cy="115.255099%" fx="114.079729%" fy="115.255099%" r="179.720479%" gradientTransform="translate(1.1408, 1.1526), scale(0.8116, 1), rotate(-140.622), scale(1, 0.9977), translate(-1.1408, -1.1526)" id="radialGradient-8">
            <stop stop-color="#79E96D" offset="0%"></stop>
            <stop stop-color="#79E96D" offset="43.9999998%"></stop>
            <stop stop-color="#D0EB76" offset="100%"></stop>
        </radialGradient>
        <radialGradient cx="2.93805495%" cy="0.536610645%" fx="2.93805495%" fy="0.536610645%" r="142.432399%" gradientTransform="translate(0.0294, 0.0054), scale(1, 0.9857), rotate(45.4163), scale(1, 2.8475), translate(-0.0294, -0.0054)" id="radialGradient-9">
            <stop stop-color="#20A85E" offset="0%"></stop>
            <stop stop-color="#09442A" offset="93.9999998%"></stop>
            <stop stop-color="#09442A" offset="100%"></stop>
        </radialGradient>
        <radialGradient cx="51.1411522%" cy="60.0068558%" fx="51.1411522%" fy="60.0068558%" r="71.0217466%" gradientTransform="translate(0.5114, 0.6001), scale(1, 0.9857), rotate(90), scale(1, 1.1518), translate(-0.5114, -0.6001)" id="radialGradient-10">
            <stop stop-color="#33A662" stop-opacity="0" offset="0%"></stop>
            <stop stop-color="#33A662" stop-opacity="0" offset="57.9999983%"></stop>
            <stop stop-color="#98F0B0" stop-opacity="0.301961005" offset="97.0000029%"></stop>
            <stop stop-color="#98F0B0" stop-opacity="0.301961005" offset="100%"></stop>
        </radialGradient>
    </defs>
    <g id="Files/MS-Excel" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Icons/File-Types/MS-Word" transform="translate(14, 14)">
            <g id="surface1" transform="translate(0, 1)">
                <path d="M3.28568795,7.6665 C3.28568795,6.0095625 4.60983457,4.6665 6.24306583,4.6665 L23,4.6665 L23,21.99975 C23,23.1043125 22.1172972,24 21.0284764,24 L7.22818064,24 C5.05090869,24 3.28568795,22.2091875 3.28568795,20.00025 L3.28568795,7.6665 Z" id="Vector" fill="url(#radialGradient-1)" fill-rule="nonzero"></path>
                <path d="M3.28568795,7.6665 C3.28568795,6.0095625 4.60983457,4.6665 6.24306583,4.6665 L23,4.6665 L23,21.99975 C23,23.1043125 22.1172972,24 21.0284764,24 L7.22818064,24 C5.05090869,24 3.28568795,22.2091875 3.28568795,20.00025 L3.28568795,7.6665 Z" id="Vector" fill="url(#radialGradient-2)" fill-rule="nonzero"></path>
                <path d="M3.28568795,11.0002501 C3.28568795,9.34312515 4.60983459,8.00025011 6.24306587,8.00025011 L15.1142753,8.00025011 C14.0254545,8.00025011 13.1427517,8.89575014 13.1427517,10.0003127 L13.1427517,14.0002501 C13.1427517,15.1046253 12.2602337,16.0003129 11.171228,16.0003129 L7.22873527,16.0003129 C5.05127843,16.0003129 3.28624252,17.7911254 3.28624252,20.0002501 L3.28624252,11.0002501 L3.28568795,11.0002501 Z" id="Vector" fill="url(#linearGradient-3)" fill-rule="nonzero"></path>
                <path d="M3.28568795,11.0002501 C3.28568795,9.34312515 4.60983459,8.00025011 6.24306587,8.00025011 L15.1142753,8.00025011 C14.0254545,8.00025011 13.1427517,8.89575014 13.1427517,10.0003127 L13.1427517,14.0002501 C13.1427517,15.1046253 12.2602337,16.0003129 11.171228,16.0003129 L7.22873527,16.0003129 C5.05127843,16.0003129 3.28624252,17.7911254 3.28624252,20.0002501 L3.28624252,11.0002501 L3.28568795,11.0002501 Z" id="Vector" fill="url(#linearGradient-4)" fill-rule="nonzero"></path>
                <path d="M3.28568795,3.99975014 C3.28568795,1.79081256 5.05090869,0 7.22818064,0 L15.1139055,0 L15.1139055,8.00025027 L7.22818064,8.00025027 C5.05090869,8.00025027 3.28568795,9.79106283 3.28568795,12 L3.28568795,3.99975014 Z" id="Vector" fill="url(#linearGradient-5)" fill-rule="nonzero"></path>
                <path d="M3.28568795,3.99975014 C3.28568795,1.79081256 5.05090869,0 7.22818064,0 L15.1139055,0 L15.1139055,8.00025027 L7.22818064,8.00025027 C5.05090869,8.00025027 3.28568795,9.79106283 3.28568795,12 L3.28568795,3.99975014 Z" id="Vector" fill="url(#radialGradient-6)" fill-rule="nonzero"></path>
                <path d="M3.28568795,3.99975014 C3.28568795,1.79081256 5.05090869,0 7.22818064,0 L15.1139055,0 L15.1139055,8.00025027 L7.22818064,8.00025027 C5.05090869,8.00025027 3.28568795,9.79106283 3.28568795,12 L3.28568795,3.99975014 Z" id="Vector" fill="url(#linearGradient-7)" fill-rule="nonzero"></path>
                <path d="M15.1139051,0 L21.0279215,0 C22.1167424,0 22.9994452,0.895312512 22.9994452,1.99968753 L22.9994452,6.00056258 C22.9994452,7.1049376 22.1167424,8.00025011 21.0279215,8.00025011 L15.1139051,8.00025011 C14.0250842,8.00025011 13.1423814,7.1049376 13.1423814,6.00056258 L13.1423814,1.99968753 C13.1423814,0.895312512 14.0250842,0 15.1139051,0 Z" id="Vector" fill="url(#radialGradient-8)" fill-rule="nonzero"></path>
                <path d="M2.13567856,11.3332507 L8.37818954,11.3332507 C9.55777622,11.3332507 10.514053,12.3031882 10.514053,13.4994383 L10.514053,19.8335634 C10.514053,21.0300009 9.55777622,21.9997509 8.37818954,21.9997509 L2.13567856,21.9997509 C0.956276742,21.9997509 0,21.0300009 0,19.8335634 L0,13.4994383 C0,12.3031882 0.956276742,11.3332507 2.13567856,11.3332507 Z" id="Vector" fill="url(#radialGradient-9)" fill-rule="nonzero"></path>
                <path d="M2.13567856,11.3332507 L8.37818954,11.3332507 C9.55777622,11.3332507 10.514053,12.3031882 10.514053,13.4994383 L10.514053,19.8335634 C10.514053,21.0300009 9.55777622,21.9997509 8.37818954,21.9997509 L2.13567856,21.9997509 C0.956276742,21.9997509 0,21.0300009 0,19.8335634 L0,13.4994383 C0,12.3031882 0.956276742,11.3332507 2.13567856,11.3332507 Z" id="Vector" fill="url(#radialGradient-10)" fill-rule="nonzero"></path>
                <path d="M8.02048708,19.714126 L6.39964144,19.714126 L5.38217629,17.7714384 C5.34575904,17.7033759 5.31784527,17.6495634 5.29843507,17.6098134 C5.28179771,17.5674383 5.2633118,17.5190634 5.2439016,17.4652509 L5.22744913,17.4652509 C5.20230827,17.5335009 5.17864629,17.5886259 5.15646319,17.6308134 C5.13409519,17.6735634 5.10766037,17.7258758 5.07697372,17.7883134 L4.02161244,19.7135635 L2.49301155,19.7135635 L4.32736959,16.6618133 L2.61890068,13.6185006 L4.21848751,13.6185006 L5.12281881,15.3528757 C5.15923606,15.4237508 5.19010755,15.4861882 5.21506356,15.5400007 C5.24297726,15.5908133 5.27089103,15.6517507 5.29880479,15.7228133 L5.31544211,15.7228133 C5.35426257,15.6408757 5.38494917,15.5754382 5.40768687,15.5274382 C5.43282772,15.4794382 5.46647211,15.4156882 5.50806542,15.3365632 L6.4460411,13.6194381 L7.97039023,13.6194381 L6.23678047,16.6162508 L8.02085679,19.714501 L8.02048708,19.714126 Z" id="Vector" fill="#FFFFFF" fill-rule="nonzero"></path>
            </g>
        </g>
    </g>
</svg>`, r0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>folder</title>
    <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="43.675983%" id="linearGradient-1">
            <stop stop-color="#40A4D6" offset="0%"></stop>
            <stop stop-color="#127BB0" offset="100%"></stop>
        </linearGradient>
        <linearGradient x1="97.2307352%" y1="52.7692648%" x2="97.2307352%" y2="36.9075521%" id="linearGradient-2">
            <stop stop-color="#0D6E9F" offset="0%"></stop>
            <stop stop-color="#228EC4" offset="100%"></stop>
        </linearGradient>
        <linearGradient x1="100%" y1="50%" x2="94.4614704%" y2="50%" id="linearGradient-3">
            <stop stop-color="#48BAEF" offset="0%"></stop>
            <stop stop-color="#65C7F4" offset="100%"></stop>
        </linearGradient>
    </defs>
    <g id="Files/Folder" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Version-1" transform="translate(1, 6.5)">
            <path d="M16.6172532,-2.52109048e-16 C17.2775017,-2.92537605e-16 17.8952075,0.325855191 18.2679834,0.870801205 L21.092,4.999 L50,5 C51.1045695,5 52,5.8954305 52,7 L52,19 C52,20.1045695 51.1045695,21 50,21 L2,21 C0.8954305,21 0,20.1045695 0,19 L0,7 L0,2 C0,0.8954305 0.8954305,7.10574945e-16 2,6.4293957e-16 L16.6172532,-2.52109048e-16 Z" id="Combined-Shape" stroke="url(#linearGradient-2)" fill="url(#linearGradient-1)"></path>
            <rect id="Rectangle" stroke="url(#linearGradient-3)" fill="#75D0FA" transform="translate(26, 23) rotate(90) translate(-26, -23)" x="8" y="-3" width="36" height="52" rx="2"></rect>
        </g>
    </g>
</svg>`, d0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>fusion</title>
    <g id="Files/Autodesk-Fusion" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="File-Types/Autodesk" transform="translate(14, 14)">
            <g id="Group" transform="translate(1, 2)">
                <path d="M10.3675,4.06168484 C10.36915,7.36000728 10.38415,10.6599822 10.36085,13.9599572 C11.20125,14.0532993 12.06325,14.0816425 12.90035,13.9299115 C12.8537,12.629982 12.89865,11.32835 12.8737,10.0282703 C13.9454,9.91334532 15.02535,9.99997724 16.1004,9.96827897 C16.08715,9.38999841 16.08875,8.81332028 16.10205,8.23498964 C15.0304,8.2283295 13.95705,8.24500489 12.8837,8.22497439 C12.8737,7.44498668 12.87535,6.66329638 12.88195,5.88330867 C14.15835,5.88501127 15.43645,5.88000364 16.7128,5.8883163 C16.71615,5.27668495 16.71115,4.66335101 16.7095,4.05001707 C14.596,4.06493979 12.4809,4.04831448 10.3675,4.06168484 M3.9157,0 L20.8731,0 C21.52375,0.0333507841 22.1861,0.50336649 22.22275,1.1933171 C22.2627,2.15663397 22.2211,3.12335602 22.236,4.0883254 C22.246,8.71827556 22.2377,13.3482758 22.2411356,17.9766235 C16.93415,17.9816311 11.62725,17.9732684 6.3204,17.9832836 C5.5233,18.0050167 4.72445,18.0449776 3.92735,17.9766235 C3.88575,11.9933125 3.909,6.00995152 3.91405,0.0266405663 L3.9157,0 L3.9157,0 Z" id="Shape" fill="#FF6902" fill-rule="nonzero"></path>
                <path d="M0,2.39669952 C1.2897,1.58336103 2.60435,0.808481096 3.91405,0.0266906426 C3.909,6.01000159 3.8857,11.9933125 3.92735,17.9766736 C3.32495,18.3333166 2.72915,18.7016275 2.1251,19.0583206 C1.4145,19.4833679 0.71225,19.9200829 0,20.3433273 L0,2.39669952 Z" id="Path" fill="#FF9548"></path>
                <path d="M10.3675,4.06173491 C12.4809,4.04836456 14.596,4.06498987 16.7095,4.05006715 C16.71115,4.66340109 16.71615,5.27673503 16.7128,5.88836638 C15.4364,5.88005372 14.15835,5.88506134 12.88195,5.88335875 C12.87535,6.66334646 12.8737,7.44503676 12.8837,8.22502447 C13.957,8.24505497 15.0304,8.22837958 16.10205,8.23503972 C16.08875,8.81342044 16.08715,9.39004848 16.1004,9.96832905 C15.0254,10.0000273 13.9454,9.9133954 12.8737,10.0283204 C12.8987,11.3284001 12.8537,12.6300321 12.9003,13.9299615 C12.06325,14.0816926 11.20125,14.0533494 10.36085,13.9600073 C10.38415,10.6599822 10.36915,7.36005736 10.3675,4.06173491" id="Path" fill="#FFFEFE"></path>
                <path d="M22.236,4.08837548 C22.8235,4.08336786 23.4126,4.08336786 24,4.08171534 C23.9867,10.0550611 23.99835,16.0266542 23.99335,22 L3.32825,22 C2.79075,21.916623 2.2649,21.5583275 2.15675,20.9983748 C2.05355,20.3566977 2.12845,19.7033528 2.1251,19.0583707 C2.7292,18.7016776 3.32495,18.3332666 3.92735,17.9766736 C4.7245,18.0450277 5.52325,18.0050167 6.32035,17.9833838 C11.6272,17.9733185 16.93415,17.9816812 22.24105,17.9766736 C22.2377,13.3483259 22.24605,8.71837571 22.23605,4.08837548" id="Path" fill="#933B00"></path>
            </g>
        </g>
    </g>
</svg>`, c0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>generic</title>
    <defs>
        <polygon id="path-1" points="0 0 24 0 24 24 0 24"></polygon>
    </defs>
    <g id="Files/Default" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Icons/Audio" transform="translate(14, 14)">
            <g id="Group-12" transform="translate(1, 1)">
                <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1"></use>
                </mask>
                <g id="Clip-11"></g>
                <path d="M14.922798,12.0383877 C14.922798,13.6673065 13.597782,14.9923225 11.9690766,14.9923225 C10.3403711,14.9923225 9.01535509,13.6673065 9.01535509,12.0383877 C9.01535509,10.4096822 10.3403711,9.08466624 11.9690766,9.08466624 L14.922798,9.08466624 L14.922798,12.0383877 Z M22.6225208,6.41863937 L19.4762209,6.41863937 C20.6423544,7.97654084 21.3339731,9.90893581 21.3339731,12 C21.3339731,17.1469396 17.1467264,21.3341864 12,21.3341864 C6.85306035,21.3341864 2.66581361,17.1469396 2.66581361,12 C2.66581361,6.85327362 6.85306035,2.66581361 12,2.66581361 C13.0206867,2.66581361 14.0027724,2.83280017 14.922798,3.13712945 L14.922798,6.41885263 L11.9690766,6.41885263 C8.87054809,6.41885263 6.34954148,8.93985925 6.34954148,12.0383877 C6.34954148,15.1369162 8.87054809,17.6581361 11.9690766,17.6581361 C15.067605,17.6581361 17.5886116,15.1369162 17.5886116,12.0383877 L17.5886116,4.52847089 C17.5890382,4.52889742 17.5894647,4.52911068 17.5898912,4.52953721 L17.5898912,1.38174451 C15.9202389,0.500959693 14.0189806,0 12,0 C5.37257411,0 0,5.37257411 0,12 C0,18.6274259 5.37257411,24 12,24 C18.6274259,24 24,18.6274259 24,12 C24,9.98443165 23.5005332,8.0861591 22.6225208,6.41863937 L22.6225208,6.41863937 Z" id="Fill-10" fill="#2D2D2D" mask="url(#mask-2)"></path>
            </g>
        </g>
    </g>
</svg>`, u0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>illustrator</title>
    <g id="Files/Adobe-Illustrator" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Icons/File-Types/Adobe-Illustrator" transform="translate(14, 14)" fill="#F4981C">
            <g id="Illustrator-2026" transform="translate(1, 4.2)">
                <path d="M5.88846564,0.83401492 L10.9867867,0.83401492 L16.7059352,16.7999723 L12.0340432,16.7999723 L11.2470325,14.369961 L5.26763709,14.369961 L4.48062752,16.7999723 L0,16.7999723 L5.88533066,0.83401492 L5.88846564,0.83401492 Z M10.0085104,10.5791446 L8.26830898,5.21744156 L6.5281076,10.5791446 L10.0085104,10.5791446 Z" id="Vector-2" fill-rule="nonzero"></path>
                <path d="M17.3894735,1.88129906 C17.3894735,0.736842103 18.2705485,0 19.6062709,0 C20.9419933,0 21.7509531,0.761926141 21.7509531,1.88129906 C21.7509531,3.00067198 20.9169092,3.81276605 19.6062709,3.81276605 C18.2235161,3.81276605 17.3894735,3.05083998 17.3894735,1.88129906 Z M17.5086216,4.36147828 L21.6788356,4.36147828 L21.6788356,16.8 L17.5086216,16.8 L17.5086216,4.36147828 Z" id="Vector-3" fill-rule="nonzero"></path>
            </g>
        </g>
    </g>
</svg>`, p0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>image</title>
    <g id="Files/Image" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Icons/Audio" transform="translate(14, 14)" fill="#2D2D2D">
            <g id="Outline" transform="translate(0.9573, 1.25)">
                <path d="M5.54269022,0 C3.1949211,0 1.29269022,1.90223088 1.29269022,4.25 C1.29269022,6.59776912 3.1949211,8.5 5.54269022,8.5 C7.89045934,8.5 9.79269022,6.59776912 9.79269022,4.25 C9.79269022,1.90223088 7.89045934,0 5.54269022,0 Z M5.54269022,1.5 C7.06203222,1.5 8.29269022,2.73065801 8.29269022,4.25 C8.29269022,5.76934199 7.06203222,7 5.54269022,7 C4.02334823,7 2.79269022,5.76934199 2.79269022,4.25 C2.79269022,2.73065801 4.02334823,1.5 5.54269022,1.5 Z" id="Stroke-1" fill-rule="nonzero"></path>
                <path d="M13.9807044,11.3866851 C15.0285038,10.7106872 16.4240667,10.9447238 17.1839852,11.9022042 L17.2835781,12.0372363 L24.0855013,21.9437652 L22.848925,22.7928111 L16.0463795,12.8853746 C15.7750619,12.4889741 15.2099555,12.3787044 14.794821,12.6465315 C14.7330596,12.6865064 14.6769374,12.7335646 14.6275402,12.7865602 L14.5586237,12.8703632 L9.73109751,19.567188 L6.40743233,16.9787422 C6.018318,16.676345 5.44549338,16.7377177 5.12999935,17.1202365 L5.09122794,17.1719279 L1.23710499,22.7926902 L0,21.9444148 L3.8583675,16.3175278 L3.94181896,16.2039862 C3.95479225,16.1874483 3.96747024,16.1719153 3.98011149,16.1571049 C4.76840629,15.2009871 6.16539181,15.0116927 7.18543322,15.691747 L7.32848275,15.7948227 L9.42369022,17.427 L13.3424335,11.9923654 C13.4809072,11.8008342 13.6467126,11.63142 13.8351788,11.4886736 L13.9807044,11.3866851 Z" id="Stroke-3" fill-rule="nonzero"></path>
            </g>
        </g>
    </g>
</svg>`, f0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>indesign</title>
    <g id="Files/Adobe-InDesign" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Icons/File-Types/Adobe-Illustrator" transform="translate(14, 14)" fill="#FF3365">
            <g id="Indesign-2026" transform="translate(4.3, 5)">
                <polygon id="Vector-2" fill-rule="nonzero" points="0 0.487511195 4.30844766 0.487511195 4.30844766 16.0027972 0 16.0027972"></polygon>
                <path d="M5.78014616,10.0276539 C5.78014616,5.81366313 8.93073743,3.7051436 12.1940665,3.7051436 C12.6328335,3.7051436 13.0959732,3.75084826 13.3762965,3.79655315 L13.3762965,0 L17.4287976,0 L17.4287976,15.2136344 C16.4568069,15.7011533 14.5341558,16.21 12.4500128,16.21 C8.88503149,16.21 5.78014616,14.19594 5.78014616,10.0276539 Z M13.3732512,12.8278386 L13.3732512,7.1543392 C13.0959748,7.06292941 12.7486154,6.9928478 12.2854726,6.9928478 C11.0118297,6.9928478 9.82959728,7.7332674 9.82959728,9.95757209 C9.82959728,11.9960102 10.8960461,12.9222946 12.3068038,12.9222946 C12.6297849,12.9222946 13.0715989,12.8979201 13.3732512,12.8308863 L13.3732512,12.8278386 Z" id="Vector-3" fill-rule="nonzero"></path>
            </g>
        </g>
    </g>
</svg>`, g0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>maya</title>
    <g id="Files/Autodesk-Maya" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="File-Types/Autodesk" transform="translate(14, 14)">
            <g id="Group" transform="translate(1, 2)">
                <path d="M2.11398964,4 L24,4 L24,22 L3.40725389,22 C2.69299896,22 2.11398964,21.417975 2.11398964,20.7 L2.11398964,4 Z" id="Path" fill="#36697F"></path>
                <path d="M3.87979275,0 L20.9409326,0 C21.6551876,0 22.2341969,0.58203 22.2341969,1.3 L22.2341969,18 L3.87979275,18 L3.87979275,0 Z" id="Path" fill="#37A5CC"></path>
                <polygon id="Path" fill="#7DC6DD" points="0 2.35 3.87979275 0 3.87979275 18 0 20.35"></polygon>
                <polygon id="Path" fill="#FFFFFF" points="15.1368622 3.99995 18.178172 3.99995 18.178172 13.999975 15.8190342 13.999975 15.8190342 7.542825 14.1562694 13.9857 14.1562694 13.999975 11.8113326 13.999975 10.0490611 7.285675 10.0490611 13.999975 7.91731399 13.999975 7.91731399 3.99995 11.0438798 3.99995 13.047743 12.02855 15.1510881 4.028525"></polygon>
            </g>
        </g>
    </g>
</svg>`, v0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>pdf</title>
    <defs>
        <polygon id="path-1" points="0 0 24 0 24 23.3052363 0 23.3052363"></polygon>
    </defs>
    <g id="Files/Adobe-Acrobat" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Icons/Audio" transform="translate(14, 14)">
            <g id="Group-3" transform="translate(1, 1)">
                <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1"></use>
                </mask>
                <g id="Clip-2"></g>
                <path d="M6.03986977,17.7204542 C4.45299505,20.3391153 2.79832328,21.9959057 1.90424967,21.9959057 C1.76441825,21.9959057 1.62670549,21.9281087 1.48899273,21.8581929 C1.28348292,21.7204802 1.21356721,21.5128517 1.28348292,21.2374262 C1.48899273,20.2713182 3.28137726,18.959869 6.03986977,17.7204542 M10.1076928,14.9619617 C10.6585439,13.8602596 11.4170234,11.9280436 11.6945676,11.1017671 C12.3153343,12.1335535 13.3471207,13.3772056 13.9000904,13.9280566 C13.9000904,13.9979724 11.7623646,14.4111106 10.1076928,14.9619617 M10.2454056,1.58687472 C10.3831183,1.37924625 10.5886282,1.2415335 10.7962566,1.2415335 C11.4170234,1.2415335 11.5568548,2.000013 11.5568548,2.62077975 C11.4869391,4.06994171 11.2115136,5.51698502 10.7284596,6.89623127 C9.69455455,4.13773876 9.90006436,2.20764147 10.2454056,1.58687472 M21.760311,15.7903569 C21.6903952,16.2712922 21.0696285,16.7543462 19.9679264,16.4789207 C18.6564772,16.1335795 17.4848594,15.5128127 16.4509544,14.6865362 C17.3471467,14.5488234 19.3471597,14.3433136 20.794203,14.6187391 C21.3471727,14.7543332 21.8980237,15.0996744 21.760311,15.7903569 M23.4827798,14.6187391 C21.6903952,12.7564389 16.794177,13.5149184 15.6225592,13.6526311 C13.9000904,11.9979594 12.7263539,9.99794635 12.3153343,9.3072639 C12.936101,7.44708231 13.3471207,5.58478207 13.4170364,3.58688773 C13.4170364,1.86230024 12.7263539,0 10.7962566,0 C10.1076928,0 9.48692608,0.413138279 9.14158485,0.966107976 C8.3153083,2.41315128 8.65853087,5.30935655 9.96998007,8.27335887 C9.21150056,10.4110846 8.52081811,12.4788947 6.59072081,16.1335795 C4.59070781,16.959856 0.385171996,18.892072 0.0419494253,20.959882 C-0.0957633344,21.5806488 0.109746476,22.2014155 0.592800464,22.6823508 C1.07585445,23.0976078 1.69450254,23.3052363 2.31526929,23.3052363 C4.86825199,23.3052363 7.34920032,19.7882642 9.0737878,16.8242619 C10.5208311,16.3412079 12.7962696,15.6505255 15.0717082,15.2395059 C17.7624036,17.5827414 20.1056392,17.9280827 21.3471727,17.9280827 C23.0018445,17.9280827 23.6226112,17.2374002 23.828121,16.6166334 C24.1734622,15.9280697 23.9679524,15.1695901 23.4827798,14.6187391" id="Fill-1" fill="#E53935" mask="url(#mask-2)"></path>
            </g>
        </g>
    </g>
</svg>`, h0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>photoshop</title>
    <g id="Files/Adobe-Photoshop" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Icons/File-Types/Adobe-Photoshop" transform="translate(14, 14)" fill="#30A8FF">
            <g id="Photoshop-2026" transform="translate(1.7, 5)">
                <path d="M6.25608865,0 C10.7934016,0 13.3479993,2.12417867 13.3479993,5.68437738 C13.3479993,9.83846638 9.88531104,11.5101562 6.63943543,11.5101562 L4.44305218,11.5101562 L4.44305218,16.000469 L0,16.000469 L0,0 L6.25608865,0 Z M4.44305218,3.79587002 L4.44305218,7.71114566 L6.40062641,7.71114566 C7.76119187,7.71114566 8.71642376,7.16124736 8.71642376,5.77550368 C8.71642376,4.50916637 7.90573802,3.79272707 6.49489767,3.79272707 L4.43990693,3.79272707 L4.44305218,3.79587002 Z" id="Vector-2" fill-rule="nonzero"></path>
                <path d="M14.2529501,15.2117561 L14.2780833,11.510153 C15.5443834,12.3459984 17.31029,12.8707591 18.5294573,12.8707591 C19.3652781,12.8707591 19.748626,12.6319469 19.748626,12.2014551 C19.748626,11.7238292 19.223886,11.5321495 18.2215294,11.2210642 C16.2859444,10.6491699 14.1618241,9.86045896 14.1618241,7.32778436 C14.1618241,4.79510976 16.2859423,3.31509775 19.3684245,3.31509775 C20.8263976,3.31509775 22.0204271,3.52877284 23.0699164,3.98440287 L23.0447735,7.51946339 C22.2089527,7.01669922 20.5624558,6.56421119 19.487829,6.56421119 C18.6991409,6.56421119 18.3880648,6.80302466 18.3880648,7.16124412 C18.3880648,7.59173593 18.7714065,7.71114223 19.9151614,8.06936169 C22.1366852,8.73866652 24,9.45510627 24,12.0569107 C24,14.6587152 21.970147,16.211 18.7933995,16.211 C17.1217578,16.211 15.544381,15.9250521 14.2560857,15.2086132 L14.2529501,15.2117561 Z" id="Vector-3" fill-rule="nonzero"></path>
            </g>
        </g>
    </g>
</svg>`, x0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>powerpoint</title>
    <defs>
        <linearGradient x1="44.9267273%" y1="-2.16082818%" x2="-16.338514%" y2="55.3168446%" id="linearGradient-1">
            <stop stop-color="#FF7F48" offset="0%"></stop>
            <stop stop-color="#FF7F48" offset="5.82735986%"></stop>
            <stop stop-color="#E5495B" offset="100%"></stop>
        </linearGradient>
        <radialGradient cx="69.7646995%" cy="29.0151939%" fx="69.7646995%" fy="29.0151939%" r="100.882828%" gradientTransform="translate(0.6976, 0.2902), scale(0.9903, 1), rotate(135.2806), scale(1, 1.6831), translate(-0.6976, -0.2902)" id="radialGradient-2">
            <stop stop-color="#AA1D2D" offset="0%"></stop>
            <stop stop-color="#AA1D2D" offset="15.1522994%"></stop>
            <stop stop-color="#D12B18" stop-opacity="0.439215988" offset="38.0854994%"></stop>
            <stop stop-color="#FF3C00" stop-opacity="0" offset="60.1996005%"></stop>
            <stop stop-color="#FF3C00" stop-opacity="0" offset="100%"></stop>
        </radialGradient>
        <radialGradient cx="-17.4523789%" cy="90.6431963%" fx="-17.4523789%" fy="90.6431963%" r="95.9290503%" gradientTransform="translate(-0.1745, 0.9064), scale(0.9903, 1), rotate(-25.0671), scale(1, 1.8116), translate(0.1745, -0.9064)" id="radialGradient-3">
            <stop stop-color="#FF66FB" stop-opacity="0.501960993" offset="0%"></stop>
            <stop stop-color="#FF66FB" stop-opacity="0.501960993" offset="40.6699985%"></stop>
            <stop stop-color="#EA3D01" stop-opacity="0" offset="100%"></stop>
        </radialGradient>
        <linearGradient x1="45.9737743%" y1="80.8252293%" x2="117.70124%" y2="28.5805536%" id="linearGradient-4">
            <stop stop-color="#FF6E30" offset="0%"></stop>
            <stop stop-color="#FF6E30" offset="31.0768008%"></stop>
            <stop stop-color="#FFA05C" offset="63.4576023%"></stop>
            <stop stop-color="#FFA05C" offset="100%"></stop>
        </linearGradient>
        <radialGradient cx="22.1629649%" cy="74.452448%" fx="22.1629649%" fy="74.452448%" r="86.7794558%" gradientTransform="translate(0.2216, 0.7445), scale(0.9924, 1), rotate(11.7227), scale(1, 0.9533), translate(-0.2216, -0.7445)" id="radialGradient-5">
            <stop stop-color="#FFA05C" stop-opacity="0" offset="0%"></stop>
            <stop stop-color="#FFA05C" stop-opacity="0" offset="78.5929978%"></stop>
            <stop stop-color="#FFCE84" offset="90.4888988%"></stop>
            <stop stop-color="#FFCE84" offset="100%"></stop>
        </radialGradient>
        <radialGradient cx="35.6790698%" cy="65.5027316%" fx="35.6790698%" fy="65.5027316%" r="87.4062592%" gradientTransform="translate(0.3568, 0.655), scale(0.9924, 1), rotate(-32.941), scale(1, 0.9563), translate(-0.3568, -0.655)" id="radialGradient-6">
            <stop stop-color="#FF99E9" stop-opacity="0.800000012" offset="0%"></stop>
            <stop stop-color="#FF99E9" stop-opacity="0.800000012" offset="29.5239002%"></stop>
            <stop stop-color="#FF99E9" stop-opacity="0" offset="72.7967978%"></stop>
            <stop stop-color="#FF99E9" stop-opacity="0" offset="100%"></stop>
        </radialGradient>
        <radialGradient cx="25.9096921%" cy="75.6551271%" fx="25.9096921%" fy="75.6551271%" r="92.818029%" gradientTransform="translate(0.2591, 0.7566), scale(0.9924, 1), rotate(-48.5857), scale(1, 0.9133), translate(-0.2591, -0.7566)" id="radialGradient-7">
            <stop stop-color="#FD6EF9" offset="0%"></stop>
            <stop stop-color="#FF9944" offset="63.7205005%"></stop>
            <stop stop-color="#FCC479" offset="85.1859987%"></stop>
            <stop stop-color="#FCC479" offset="100%"></stop>
        </radialGradient>
        <radialGradient cx="19.8475991%" cy="8.78865796%" fx="19.8475991%" fy="8.78865796%" r="47.0510689%" gradientTransform="translate(0.1985, 0.0879), scale(0.9924, 1), rotate(98.4763), scale(1, 2.26), translate(-0.1985, -0.0879)" id="radialGradient-8">
            <stop stop-color="#FF8D13" offset="0%"></stop>
            <stop stop-color="#FF8D13" offset="14.4282997%"></stop>
            <stop stop-color="#FF7F29" stop-opacity="0" offset="53.7266016%"></stop>
            <stop stop-color="#FF7F29" stop-opacity="0" offset="100%"></stop>
        </radialGradient>
        <radialGradient cx="-0.0121831792%" cy="0%" fx="-0.0121831792%" fy="0%" r="142.119075%" gradientTransform="translate(-0.0001, 0), scale(0.9903, 1), rotate(44.7194), translate(0.0001, -0)" id="radialGradient-9">
            <stop stop-color="#F8193E" offset="0%"></stop>
            <stop stop-color="#920616" offset="93.9061999%"></stop>
            <stop stop-color="#920616" offset="100%"></stop>
        </radialGradient>
        <radialGradient cx="49.9875034%" cy="59.9999898%" fx="49.9875034%" fy="59.9999898%" r="69.9999983%" gradientTransform="translate(0.4999, 0.6), scale(0.9903, 1), rotate(90), scale(1, 1.1384), translate(-0.4999, -0.6)" id="radialGradient-10">
            <stop stop-color="#FFB055" stop-opacity="0" offset="0%"></stop>
            <stop stop-color="#FFB055" stop-opacity="0" offset="57.5892985%"></stop>
            <stop stop-color="#FFF2BE" stop-opacity="0.301961005" offset="97.3806024%"></stop>
            <stop stop-color="#FFF2BE" stop-opacity="0.301961005" offset="100%"></stop>
        </radialGradient>
    </defs>
    <g id="Files/MS-Powerpoint" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Icons/File-Types/MS-Word" transform="translate(14, 14)">
            <g id="surface1" transform="translate(0.5, 1)">
                <path d="M25.0419632,12 C25.0419632,5.3725 19.6170769,0 12.9250037,0 C6.23293046,0 0.807875836,5.3725 0.807875836,12 C0.807875836,18.6275 6.23293046,24 12.9250037,24 C19.6170769,24 25.0419632,18.6275 25.0419632,12 Z" id="Vector" fill="url(#linearGradient-1)" fill-rule="nonzero"></path>
                <path d="M25.0419632,12 C25.0419632,5.3725 19.6170769,0 12.9250037,0 C6.23293046,0 0.807875836,5.3725 0.807875836,12 C0.807875836,18.6275 6.23293046,24 12.9250037,24 C19.6170769,24 25.0419632,18.6275 25.0419632,12 Z" id="Vector" fill="url(#radialGradient-2)" fill-rule="nonzero"></path>
                <path d="M25.0419632,12 C25.0419632,5.3725 19.6170769,0 12.9250037,0 C6.23293046,0 0.807875836,5.3725 0.807875836,12 C0.807875836,18.6275 6.23293046,24 12.9250037,24 C19.6170769,24 25.0419632,18.6275 25.0419632,12 Z" id="Vector" fill="url(#radialGradient-3)" fill-rule="nonzero"></path>
                <path d="M12.9266867,0 C19.6185918,0 25.0434783,5.37266667 25.0434783,12 C25.0434783,14.2046667 24.4419474,16.2696667 23.3944017,18.045 L23.5913214,17.6131667 C24.7905121,14.9765 22.8413433,11.9928333 19.9210404,11.995 L15.0983581,11.9986667 C13.8995039,11.9996667 12.9266867,11.0371667 12.9266867,9.85 L12.9266867,5.06566667 C12.9265184,2.17266667 9.91011192,0.244666667 7.24816095,1.43616667 L6.86054884,1.61 C8.64460804,0.586333333 10.716473,0 12.9266867,0 Z" id="Vector" fill="url(#linearGradient-4)" fill-rule="nonzero"></path>
                <path d="M12.9266867,0 C19.6185918,0 25.0434783,5.37266667 25.0434783,12 C25.0434783,14.2046667 24.4419474,16.2696667 23.3944017,18.045 L23.5913214,17.6131667 C24.7905121,14.9765 22.8413433,11.9928333 19.9210404,11.995 L15.0983581,11.9986667 C13.8995039,11.9996667 12.9266867,11.0371667 12.9266867,9.85 L12.9266867,5.06566667 C12.9265184,2.17266667 9.91011192,0.244666667 7.24816095,1.43616667 L6.86054884,1.61 C8.64460804,0.586333333 10.716473,0 12.9266867,0 Z" id="Vector" fill="url(#radialGradient-5)" fill-rule="nonzero"></path>
                <path d="M12.9266867,0 C19.6185918,0 25.0434783,5.37266667 25.0434783,12 C25.0434783,14.2046667 24.4419474,16.2696667 23.3944017,18.045 L23.5913214,17.6131667 C24.7905121,14.9765 22.8413433,11.9928333 19.9210404,11.995 L15.0983581,11.9986667 C13.8995039,11.9996667 12.9266867,11.0371667 12.9266867,9.85 L12.9266867,5.06566667 C12.9265184,2.17266667 9.91011192,0.244666667 7.24816095,1.43616667 L6.86054884,1.61 C8.64460804,0.586333333 10.716473,0 12.9266867,0 Z" id="Vector" fill="url(#radialGradient-6)" fill-rule="nonzero"></path>
                <path d="M12.9266867,0 C19.6185918,0 25.0434783,5.37266667 25.0434783,12 C25.0434783,14.2046667 24.4419474,16.2696667 23.3944017,18.045 L23.5913214,17.6131667 C24.7905121,14.9765 22.8413433,11.9928333 19.9210404,11.995 L15.0983581,11.9986667 C13.8995039,11.9996667 12.9266867,11.0371667 12.9266867,9.85 L12.9266867,5.06566667 C12.9265184,2.17266667 9.91011192,0.244666667 7.24816095,1.43616667 L6.86054884,1.61 C8.64460804,0.586333333 10.716473,0 12.9266867,0 Z" id="Vector" fill="url(#radialGradient-7)" fill-rule="nonzero"></path>
                <path d="M12.9266867,0 C19.6185918,0 25.0434783,5.37266667 25.0434783,12 C25.0434783,14.2046667 24.4419474,16.2696667 23.3944017,18.045 L23.5913214,17.6131667 C24.7905121,14.9765 22.8413433,11.9928333 19.9210404,11.995 L15.0983581,11.9986667 C13.8995039,11.9996667 12.9266867,11.0371667 12.9266867,9.85 L12.9266867,5.06566667 C12.9265184,2.17266667 9.91011192,0.244666667 7.24816095,1.43616667 L6.86054884,1.61 C8.64460804,0.586333333 10.716473,0 12.9266867,0 Z" id="Vector" fill="url(#radialGradient-8)" fill-rule="nonzero"></path>
                <path d="M2.10047717,11.36 L8.24033353,11.36 C9.40047689,11.36 10.3408107,12.2911667 10.3408107,13.44 L10.3408107,19.52 C10.3408107,20.6688333 9.40047689,21.6 8.24033353,21.6 L2.10047717,21.6 C0.940333812,21.6 0,20.6688333 0,19.52 L0,13.44 C0,12.2911667 0.940333812,11.36 2.10047717,11.36 Z" id="Vector" fill="url(#radialGradient-9)" fill-rule="nonzero"></path>
                <path d="M2.10047717,11.36 L8.24033353,11.36 C9.40047689,11.36 10.3408107,12.2911667 10.3408107,13.44 L10.3408107,19.52 C10.3408107,20.6688333 9.40047689,21.6 8.24033353,21.6 L2.10047717,21.6 C0.940333812,21.6 0,20.6688333 0,19.52 L0,13.44 C0,12.2911667 0.940333812,11.36 2.10047717,11.36 Z" id="Vector" fill="url(#radialGradient-10)" fill-rule="nonzero"></path>
                <path d="M4.66598797,17.4999999 L4.66598797,19.4056665 L3.33568571,19.4056665 L3.33568571,13.5541667 L5.39088825,13.5541667 C6.12672844,13.5541667 6.68685575,13.7133333 7.07127005,14.0316667 C7.45854555,14.3498333 7.65209914,14.8218333 7.65209914,15.4474999 C7.65209914,16.0923333 7.43515077,16.5954999 7.00125414,16.9573332 C6.57021867,17.3191666 5.99073608,17.4999999 5.26314288,17.4999999 L4.66598797,17.4999999 Z M4.66598797,14.5661666 L4.66598797,16.4879999 L5.22207586,16.4879999 C5.55145356,16.4879999 5.8055979,16.4025 5.98400378,16.2309999 C6.16240974,16.0596666 6.25178097,15.8134999 6.25178097,15.4924999 C6.25178097,15.1959999 6.1637562,14.9675 5.98804316,14.8068333 C5.81502312,14.6463333 5.56660123,14.5661666 5.24260937,14.5661666 L4.66598797,14.5661666 Z" id="Vector" fill="#FFFFFF" fill-rule="nonzero"></path>
            </g>
        </g>
    </g>
</svg>`, m0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>premiere</title>
    <g id="Files/Adobe-Premier-Pro" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Icons/File-Types/Adobe-Photoshop" transform="translate(14, 14)" fill="#9A99FF">
            <g id="Premier-2026" transform="translate(2.15, 5)">
                <path d="M6.25293903,0 C10.7902475,0 13.3448409,2.12411395 13.3448409,5.68420419 C13.3448409,9.83816662 9.88215785,11.5098055 6.63628544,11.5098055 L4.43990075,11.5098055 L4.43990075,15.9999815 L0,15.9999815 L0,0 L6.25608069,0 L6.25293903,0 Z M4.43990075,3.79575437 L4.43990075,7.71091072 L6.39747905,7.71091072 C7.75804317,7.71091072 8.71326573,7.16102917 8.71326573,5.77532771 C8.71326573,4.50902899 7.90258319,3.79261151 6.49174422,3.79261151 L4.4367591,3.79261151 L4.43990075,3.79575437 Z" id="Vector-2" fill-rule="nonzero"></path>
                <path d="M19.5380797,3.31816078 C20.5184399,3.31816078 21.3039833,3.43756311 21.6621918,3.55696596 L21.6621918,6.80598058 C21.3762534,6.73371043 20.8263724,6.68657739 20.3738984,6.68657739 C19.4909457,6.68657739 18.9881974,6.75884822 18.5357234,6.92538377 L18.5357234,16 L14.3566226,16 L14.3566226,4.37079074 C15.8617269,3.70150627 17.3668331,3.32130243 19.5380797,3.32130243 L19.5380797,3.31816078 Z" id="Vector-3" fill-rule="nonzero"></path>
            </g>
        </g>
    </g>
</svg>`, y0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>publisher</title>
    <defs>
        <polygon id="path-1" points="0 0 11.9997 0 11.9997 12.2222222 0 12.2222222"></polygon>
    </defs>
    <g id="Files/MS-Publisher" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Icons/File-Types/MS-Word" transform="translate(14, 14)">
            <g id="Group-14" transform="translate(0, 2)">
                <path d="M22.9919748,19.5555556 L12.599715,19.5555556 L12.599715,2.44444444 L22.9919748,2.44444444 C23.5487887,2.44444444 24,2.904 24,3.47111111 L24,18.5288889 C24,19.096 23.5487887,19.5555556 22.9919748,19.5555556" id="Fill-1" fill="#006064"></path>
                <path d="M21.000525,15.8888889 L21.000525,20.9366667 C21.000525,21.5245556 20.5337133,22 19.9564989,22 L6.4441611,22 C5.86694667,22 5.400135,21.5245556 5.400135,20.9366667 L5.400135,15.8888889 L13.20033,14.6666667 L21.000525,15.8888889 Z" id="Fill-3" fill="#00838F"></path>
                <polygon id="Fill-5" fill="#0097A7" points="21.000525 10.3888889 21.000525 15.8888889 5.400135 15.8888889 5.400135 10.3888889 12.600315 8.55555556"></polygon>
                <path d="M21.000525,1.06333333 L21.000525,10.3888889 L5.400135,10.3888889 L5.400135,1.06333333 C5.400135,0.476666667 5.8681467,0 6.4441611,0 L19.9564989,0 C20.5325133,0 21.000525,0.476666667 21.000525,1.06333333" id="Fill-7" fill="#26C6DA"></path>
                <g id="Group-11" transform="translate(0, 4.8889)">
                    <mask id="mask-2" fill="white">
                        <use xlink:href="#path-1"></use>
                    </mask>
                    <g id="Clip-10"></g>
                    <path d="M10.9916748,12.2222222 L1.00862522,12.2222222 C0.451811295,12.2222222 -0.000600015,11.7626667 -0.000600015,11.1955556 L-0.000600015,1.02666667 C-0.000600015,0.459555556 0.451811295,0 1.00862522,0 L10.9916748,0 C11.5484887,0 11.9997,0.459555556 11.9997,1.02666667 L11.9997,11.1955556 C11.9997,11.7626667 11.5484887,12.2222222 10.9916748,12.2222222" id="Fill-9" fill="#006064" mask="url(#mask-2)"></path>
                </g>
                <path d="M7.03277582,9.98922222 C7.03277582,10.5135556 6.61396535,10.9401111 6.09915248,10.9401111 L4.90512263,10.9401111 L4.90512263,8.90755556 L6.09915248,8.90755556 C6.61396535,8.90755556 7.03277582,9.33411111 7.03277582,9.85844444 L7.03277582,9.98922222 Z M6.49516238,7.94444444 L3.69069227,7.94444444 L3.69069227,14.0555556 L4.90512263,14.0555556 L4.90512263,11.9032222 L6.27075677,11.9032222 C7.39638491,11.9032222 8.30960774,10.9743333 8.30960774,9.82788889 L8.30960774,9.79244444 C8.30840771,8.77188889 7.4959874,7.94444444 6.49516238,7.94444444 L6.49516238,7.94444444 Z" id="Fill-12" fill="#FFFFFF"></path>
            </g>
        </g>
    </g>
</svg>`, A0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>table</title>
    <g id="Files/Table" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Group" transform="translate(0, 6.5)" fill="#2D2D2D">
            <g id="Icons/Audio" transform="translate(14, 8)">
                <g id="Outline" transform="translate(1, 4)">
                    <path d="M24.75,18.75 L-0.75,18.75 L-0.75,-0.75 L24.75,-0.75 L24.75,18.75 Z M0.75,0.75 L0.75,17.25 L23.25,17.25 L23.25,0.75 L0.75,0.75 Z" id="Rectangle" fill-rule="nonzero"></path>
                    <polygon id="Line-Copy-3" fill-rule="nonzero" points="8.75 18.25 7.25 18.25 7.25 -0.25 8.75 -0.25"></polygon>
                    <polygon id="Line-Copy-5" fill-rule="nonzero" transform="translate(12, 6) rotate(-90) translate(-12, -6)" points="12.75 18.75 11.25 18.75 11.25 -6.75 12.75 -6.75"></polygon>
                    <polygon id="Line-Copy-6" fill-rule="nonzero" transform="translate(12, 12) rotate(-90) translate(-12, -12)" points="12.75 24.75 11.25 24.75 11.25 -0.75 12.75 -0.75"></polygon>
                    <polygon id="Line-Copy-4" fill-rule="nonzero" points="16.75 18.25 15.25 18.25 15.25 -0.25 16.75 -0.25"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>`, b0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>text</title>
    <g id="Files/Text" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Icons/Audio" transform="translate(14, 14)" fill="#2D2D2D">
            <g id="Outlines" transform="translate(13, 12.25) rotate(90) translate(-13, -12.25)translate(4.75, 0.25)">
                <polygon id="Path" fill-rule="nonzero" points="1.5 0 1.5 24 0 24 0 0"></polygon>
                <polygon id="Path" fill-rule="nonzero" points="6.5 0 6.5 24 5 24 5 0"></polygon>
                <polygon id="Path-Copy-2" fill-rule="nonzero" points="11.5 0 11.5 24 10 24 10 0"></polygon>
                <polygon id="Path-Copy-4" fill-rule="nonzero" points="16.5 11 16.5 24 15 24 15 11"></polygon>
            </g>
        </g>
    </g>
</svg>`, C0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>vector</title>
    <defs>
        <polygon id="path-1" points="0 24 24 24 24 0 0 0"></polygon>
    </defs>
    <g id="Files/Vector" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Group" transform="translate(6.5, 0)">
            <g id="Icons/Audio" transform="translate(8, 14)">
                <g id="Outline" transform="translate(1, 1)">
                    <path d="M12.7115747,4.51347944 C13.0044679,4.22058622 13.4793416,4.22058622 13.7722348,4.51347944 C14.0385014,4.779746 14.0627075,5.19640968 13.844853,5.49002118 L13.7722348,5.57413961 L5.57413961,13.7722348 C5.28124639,14.0651281 4.80637266,14.0651281 4.51347944,13.7722348 C4.24721288,13.5059683 4.22300682,13.0893046 4.44086128,12.7956931 L4.51347944,12.7115747 L12.7115747,4.51347944 Z" id="Stroke-1" fill="#2D2D2D" fill-rule="nonzero"></path>
                    <path d="M14.8571429,0.392857143 C13.181215,0.392857143 11.8214286,1.75264358 11.8214286,3.42857143 C11.8214286,5.10449928 13.181215,6.46428571 14.8571429,6.46428571 C16.5330707,6.46428571 17.8928571,5.10449928 17.8928571,3.42857143 C17.8928571,1.75264358 16.5330707,0.392857143 14.8571429,0.392857143 Z M14.8571429,1.89285714 C15.7046436,1.89285714 16.3928571,2.58107071 16.3928571,3.42857143 C16.3928571,4.27607215 15.7046436,4.96428571 14.8571429,4.96428571 C14.0096421,4.96428571 13.3214286,4.27607215 13.3214286,3.42857143 C13.3214286,2.58107071 14.0096421,1.89285714 14.8571429,1.89285714 Z" id="Stroke-2" fill="#2D2D2D" fill-rule="nonzero"></path>
                    <path d="M3.42857143,11.8214286 C1.75264358,11.8214286 0.392857143,13.181215 0.392857143,14.8571429 C0.392857143,16.5330707 1.75264358,17.8928571 3.42857143,17.8928571 C5.10449928,17.8928571 6.46428571,16.5330707 6.46428571,14.8571429 C6.46428571,13.181215 5.10449928,11.8214286 3.42857143,11.8214286 Z M3.42857143,13.3214286 C4.27607215,13.3214286 4.96428571,14.0096421 4.96428571,14.8571429 C4.96428571,15.7046436 4.27607215,16.3928571 3.42857143,16.3928571 C2.58107071,16.3928571 1.89285714,15.7046436 1.89285714,14.8571429 C1.89285714,14.0096421 2.58107071,13.3214286 3.42857143,13.3214286 Z" id="Stroke-4" fill="#2D2D2D" fill-rule="nonzero"></path>
                    <path d="M18.2857143,10.6785714 C18.6999278,10.6785714 19.0357143,11.0143579 19.0357143,11.4285714 C19.0357143,11.8082672 18.7535604,12.1220624 18.3874848,12.1717248 L18.2857143,12.1785714 L15.2380952,12.1785714 C13.6132545,12.1785714 12.2839694,13.4449059 12.1845136,15.0438727 L12.1785714,15.2228571 L12.1785714,18.2704762 C12.1785714,18.6846898 11.842785,19.0204762 11.4285714,19.0204762 C11.0488757,19.0204762 10.7350805,18.7383223 10.685418,18.3722467 L10.6785714,18.2704762 L10.6785714,15.2195892 C10.6892088,12.7799562 12.6122635,10.7949436 15.0240577,10.6835059 L15.2380952,10.6785714 L18.2857143,10.6785714 Z" id="Stroke-6" fill="#2D2D2D" fill-rule="nonzero"></path>
                    <mask id="mask-2" fill="white">
                        <use xlink:href="#path-1"></use>
                    </mask>
                    <g id="Clip-9"></g>
                    <path d="M23.6071429,8.39285714 L17.5357143,8.39285714 L17.5357143,14.4642857 L23.6071429,14.4642857 L23.6071429,8.39285714 Z M22.107,9.892 L22.107,12.964 L19.035,12.964 L19.035,9.892 L22.107,9.892 Z" id="Stroke-8" fill="#2D2D2D" fill-rule="nonzero" mask="url(#mask-2)"></path>
                    <path d="M14.4642857,17.5357143 L8.39285714,17.5357143 L8.39285714,23.6071429 L14.4642857,23.6071429 L14.4642857,17.5357143 Z M12.964,19.035 L12.964,22.107 L9.892,22.107 L9.892,19.035 L12.964,19.035 Z" id="Stroke-10" fill="#2D2D2D" fill-rule="nonzero" mask="url(#mask-2)"></path>
                </g>
            </g>
        </g>
    </g>
</svg>`, w0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>video</title>
    <g id="Files/Video" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Group" transform="translate(0, 6.5)" fill="#2D2D2D">
            <g id="Icons/Audio" transform="translate(14, 8)" fill-rule="nonzero">
                <path d="M5.25,5 L5.25,21.3926798 C5.25,21.953422 5.84287768,22.3158507 6.34194715,22.0601917 L22.3419472,13.8638518 C22.8860176,13.5851402 22.8860176,12.8075397 22.3419472,12.528828 L6.34194715,4.33248809 C5.84287768,4.07682915 5.25,4.43925778 5.25,5 Z M6.75,6.226 L20.355,13.196 L6.75,20.166 L6.75,6.226 Z" id="Outline"></path>
            </g>
        </g>
    </g>
</svg>`, k0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>word</title>
    <defs>
        <path d="M23,2.33312932 L23,13.6671748 C22.9999828,13.7975487 22.989363,13.9254548 22.9689783,14.0500563 L23,14.0733293 L23,21.6668748 C22.999899,22.9534279 21.9682619,23.9999683 20.7000732,24 L7.22848613,24 C5.77159666,23.999968 4.49749953,23.1954114 3.81493797,22.0010023 L2.13571401,22.0000033 C0.956193825,22.0000033 3.37678687e-06,21.0299573 1.03455804e-08,19.8333418 L1.03455804e-08,13.4999981 C3.37678687e-06,12.3033826 0.956193825,11.3333366 2.13571401,11.3333366 L3.285,11.333 L3.28572291,4.00000081 C3.28572291,1.79333419 5.05343738,8.13802083e-07 7.22858037,8.13802083e-07 L20.70001,8.13802083e-07 C21.9682276,8.13802083e-07 22.9998993,1.04655497 23,2.33312932 Z" id="path-1"></path>
        <radialGradient cx="103.715669%" cy="99.0923142%" fx="103.715669%" fy="99.0923142%" r="180.347818%" gradientTransform="translate(1.0372, 0.9909), scale(0.8792, 1), scale(1, 0.4277), translate(-1.0372, -0.9909)" id="radialGradient-2">
            <stop stop-color="#1657F4" offset="0%"></stop>
            <stop stop-color="#1657F4" offset="18.0000007%"></stop>
            <stop stop-color="#0036C4" offset="56.9999993%"></stop>
            <stop stop-color="#0036C4" offset="100%"></stop>
        </radialGradient>
        <linearGradient x1="0%" y1="50.0000031%" x2="76.5666665%" y2="50.0000031%" id="linearGradient-3">
            <stop stop-color="#66C0FF" offset="0%"></stop>
            <stop stop-color="#0094F0" offset="25.999999%"></stop>
            <stop stop-color="#0094F0" offset="100%"></stop>
        </linearGradient>
        <radialGradient cx="91.681923%" cy="27.618695%" fx="91.681923%" fy="27.618695%" r="132.552946%" gradientTransform="translate(0.9168, 0.2762), scale(0.744, 1), rotate(133.1385), scale(1, 2.4604), translate(-0.9168, -0.2762)" id="radialGradient-4">
            <stop stop-color="#D471FF" offset="0%"></stop>
            <stop stop-color="#D471FF" offset="14.0000001%"></stop>
            <stop stop-color="#509DF5" stop-opacity="0" offset="82.9999983%"></stop>
            <stop stop-color="#509DF5" stop-opacity="0" offset="100%"></stop>
        </radialGradient>
        <radialGradient cx="89.4233435%" cy="56.8127285%" fx="89.4233435%" fy="56.8127285%" r="84.6363644%" gradientTransform="translate(0.8942, 0.5681), scale(0.744, 1), rotate(90), scale(1, 5.3379), translate(-0.8942, -0.5681)" id="radialGradient-5">
            <stop stop-color="#4F006F" stop-opacity="0" offset="0%"></stop>
            <stop stop-color="#4F006F" stop-opacity="0" offset="28.0000001%"></stop>
            <stop stop-color="#4F006F" offset="100%"></stop>
        </radialGradient>
        <linearGradient x1="4.00537688e-08%" y1="49.5471531%" x2="99.9999998%" y2="50.5763485%" id="linearGradient-6">
            <stop stop-color="#9DEAFF" offset="0%"></stop>
            <stop stop-color="#3BD5FF" offset="20.0000003%"></stop>
            <stop stop-color="#3BD5FF" offset="100%"></stop>
        </linearGradient>
        <radialGradient cx="96.697253%" cy="-16.9602249%" fx="96.697253%" fy="-16.9602249%" r="161.614842%" gradientTransform="translate(0.967, -0.1696), scale(0.6087, 1), rotate(166.6662), scale(1, 2.4847), translate(-0.967, 0.1696)" id="radialGradient-7">
            <stop stop-color="#E4A7FE" offset="0%"></stop>
            <stop stop-color="#E4A7FE" offset="5.99999987%"></stop>
            <stop stop-color="#E4A7FE" stop-opacity="0" offset="54.0000021%"></stop>
            <stop stop-color="#E4A7FE" stop-opacity="0" offset="100%"></stop>
        </radialGradient>
        <radialGradient cx="-1.09781637%" cy="-13.3063842%" fx="-1.09781637%" fy="-13.3063842%" r="142.466096%" gradientTransform="translate(-0.011, -0.1331), scale(1, 0.9857), rotate(45.4122), translate(0.011, 0.1331)" id="radialGradient-8">
            <stop stop-color="#367AF2" offset="0%"></stop>
            <stop stop-color="#367AF2" offset="7.99999982%"></stop>
            <stop stop-color="#001A8F" offset="87.0000005%"></stop>
            <stop stop-color="#001A8F" offset="100%"></stop>
        </radialGradient>
        <radialGradient cx="67.7174983%" cy="59.6999986%" fx="67.7174983%" fy="59.6999986%" r="71.0144911%" gradientTransform="translate(0.6772, 0.597), scale(1, 0.9857), rotate(90), scale(1, 1.1402), translate(-0.6772, -0.597)" id="radialGradient-9">
            <stop stop-color="#2763E5" stop-opacity="0" offset="0%"></stop>
            <stop stop-color="#2763E5" stop-opacity="0" offset="58.9999974%"></stop>
            <stop stop-color="#58AAFE" offset="97.0000029%"></stop>
            <stop stop-color="#58AAFE" offset="100%"></stop>
        </radialGradient>
    </defs>
    <g id="Files/MS-Word" stroke="none" fill="none" fill-rule="nonzero">
        <g id="Icons/File-Types/MS-Word" transform="translate(14, 14)">
            <g id="Microsoft_Office_Word_(2025–present)-1" transform="translate(0, 1)" xlink:href="#path-1">
                <path d="M3.28572291,18.0600034 L12.4857237,6.66666992 L23.0000102,14.073337 L23.0000102,21.6666699 C23.0000102,22.9533366 21.9682958,24.0000033 20.70001,24.0000033 L7.22858037,24.0000033 C5.05343738,24.0000033 3.28572291,22.2066699 3.28572291,20.0000033 L3.28572291,18.0600034 Z" id="Vector" fill="url(#radialGradient-2)"></path>
                <path d="M3.28572291,10.0266711 C3.28572291,8.36667111 4.60658015,7.02667112 6.24286601,7.02667112 L19.6420096,7.02667112 L23.0000102,5.33333781 L23.0000102,13.6666711 C23.0000102,14.9533378 21.9682958,16.0000045 20.70001,16.0000045 L7.22858037,16.0000045 C5.05343738,16.0000045 3.28572291,17.7933378 3.28572291,20.0000045 L3.28572291,10.0266711 Z" id="Vector" fill="url(#linearGradient-3)"></path>
                <path d="M3.28572291,10.0266711 C3.28572291,8.36667111 4.60658015,7.02667112 6.24286601,7.02667112 L19.6420096,7.02667112 L23.0000102,5.33333781 L23.0000102,13.6666711 C23.0000102,14.9533378 21.9682958,16.0000045 20.70001,16.0000045 L7.22858037,16.0000045 C5.05343738,16.0000045 3.28572291,17.7933378 3.28572291,20.0000045 L3.28572291,10.0266711 Z" id="Vector" fill-opacity="0.600000024" fill="url(#radialGradient-4)"></path>
                <path d="M3.28572291,10.0266711 C3.28572291,8.36667111 4.60658015,7.02667112 6.24286601,7.02667112 L19.6420096,7.02667112 L23.0000102,5.33333781 L23.0000102,13.6666711 C23.0000102,14.9533378 21.9682958,16.0000045 20.70001,16.0000045 L7.22858037,16.0000045 C5.05343738,16.0000045 3.28572291,17.7933378 3.28572291,20.0000045 L3.28572291,10.0266711 Z" id="Vector" fill-opacity="0.100000001" fill="url(#radialGradient-5)"></path>
                <path d="M3.28572291,4.00000081 C3.28572291,1.79333419 5.05343738,8.13802083e-07 7.22858037,8.13802083e-07 L20.70001,8.13802083e-07 C21.9682958,8.13802083e-07 23.0000102,1.04666752 23.0000102,2.33333415 L23.0000102,5.66666748 C23.0000102,6.95333411 21.9682958,8.00000081 20.70001,8.00000081 L7.22858037,8.00000081 C5.05343738,8.00000081 3.28572291,9.79333419 3.28572291,12.0000008 L3.28572291,4.00000081 Z" id="Vector" fill="url(#linearGradient-6)"></path>
                <path d="M3.28572291,4.00000081 C3.28572291,1.79333419 5.05343738,8.13802083e-07 7.22858037,8.13802083e-07 L20.70001,8.13802083e-07 C21.9682958,8.13802083e-07 23.0000102,1.04666752 23.0000102,2.33333415 L23.0000102,5.66666748 C23.0000102,6.95333411 21.9682958,8.00000081 20.70001,8.00000081 L7.22858037,8.00000081 C5.05343738,8.00000081 3.28572291,9.79333419 3.28572291,12.0000008 L3.28572291,4.00000081 Z" id="Vector" fill-opacity="0.800000012" fill="url(#radialGradient-7)"></path>
                <path d="M2.13571401,11.3333366 L8.37857116,11.3333366 C9.5580936,11.3333366 10.5142854,12.3033863 10.5142854,13.5000033 L10.5142854,19.8333366 C10.5142854,21.0299536 9.5580936,22.0000033 8.37857116,22.0000033 L2.13571401,22.0000033 C0.956191576,22.0000033 -2.70796366e-07,21.0299536 -2.70796366e-07,19.8333366 L-2.70796366e-07,13.5000033 C-2.70796366e-07,12.3033863 0.956191576,11.3333366 2.13571401,11.3333366 Z" id="Vector" fill="url(#radialGradient-8)"></path>
                <path d="M2.13571401,11.3333366 L8.37857116,11.3333366 C9.5580936,11.3333366 10.5142854,12.3033863 10.5142854,13.5000033 L10.5142854,19.8333366 C10.5142854,21.0299536 9.5580936,22.0000033 8.37857116,22.0000033 L2.13571401,22.0000033 C0.956191576,22.0000033 -2.70796366e-07,21.0299536 -2.70796366e-07,19.8333366 L-2.70796366e-07,13.5000033 C-2.70796366e-07,12.3033863 0.956191576,11.3333366 2.13571401,11.3333366 Z" id="Vector" fill-opacity="0.649999976" fill="url(#radialGradient-9)"></path>
                <polygon id="Vector" fill="#FFFFFF" points="8.86488311 13.6199976 7.57031205 19.7133307 6.02602631 19.7133307 5.26374064 16.0599976 4.46202613 19.7199976 2.89802596 19.7199976 1.65602597 13.6266644 2.93088323 13.6266644 3.69974047 17.6466637 4.46202613 13.6266644 6.02602631 13.6266644 6.82116924 17.6466637 7.57031205 13.6266644 8.86488311 13.6266644"></polygon>
            </g>
        </g>
    </g>
</svg>`, L0 = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>zip</title>
    <g id="Files/Zip" stroke="none" fill="none" fill-rule="evenodd" stroke-width="1">
        <g id="Group" transform="translate(6.5, 0)" fill="#2D2D2D">
            <g id="Icons/Audio" transform="translate(8, 3)">
                <g id="Outline" transform="translate(7.75, 0.75)">
                    <path d="M8,15 L1.83333333,15 L1.83333333,20.4166667 C1.83333333,22.1188802 3.2144531,23.5 4.91666667,23.5 C6.61888023,23.5 8,22.1188802 8,20.4166667 L8,15 Z M3.333,16.5 L6.499,16.5 L6.5,20.4166667 C6.5,21.2904531 5.7904531,22 4.91666667,22 L4.77264983,21.9935236 C3.96623164,21.9206545 3.33333333,21.2419094 3.33333333,20.4166667 L3.333,16.5 Z" id="Stroke-7" fill-rule="nonzero" transform="translate(4.9167, 19.25) rotate(180) translate(-4.9167, -19.25)"></path>
                    <polygon id="Path" fill-rule="nonzero" points="4.5 0 4.5 1.5 0 1.5 0 0"></polygon>
                    <polygon id="Path" fill-rule="nonzero" points="9.5 2 9.5 3.5 5 3.5 5 2"></polygon>
                    <polygon id="Path" fill-rule="nonzero" points="4.5 4 4.5 5.5 0 5.5 0 4"></polygon>
                    <polygon id="Path" fill-rule="nonzero" points="9.5 6 9.5 7.5 5 7.5 5 6"></polygon>
                    <polygon id="Path" fill-rule="nonzero" points="4.5 8 4.5 9.5 0 9.5 0 8"></polygon>
                    <polygon id="Path" fill-rule="nonzero" points="9.5 10 9.5 11.5 5 11.5 5 10"></polygon>
                    <polygon id="Path" fill-rule="nonzero" points="4.5 12 4.5 13.5 0 13.5 0 12"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>`, E0 = {
  folder: "none",
  generic: "vertical",
  image: "vertical",
  video: "horizontal",
  audio: "horizontal",
  pdf: "vertical",
  text: "vertical",
  code: "vertical",
  table: "horizontal",
  vector: "vertical",
  zip: "vertical",
  "3d": "vertical",
  photoshop: "vertical",
  illustrator: "vertical",
  indesign: "vertical",
  premiere: "vertical",
  "after-effects": "vertical",
  audition: "vertical",
  excel: "horizontal",
  word: "vertical",
  powerpoint: "horizontal",
  access: "vertical",
  publisher: "vertical",
  autocad: "vertical",
  fusion: "vertical",
  maya: "vertical",
  autodesk: "vertical",
  cinema4d: "vertical",
  davinci: "vertical"
}, Ne = {
  folder: r0,
  generic: c0,
  image: p0,
  video: w0,
  audio: t0,
  pdf: v0,
  text: b0,
  code: a0,
  table: A0,
  vector: C0,
  zip: L0,
  "3d": J1,
  photoshop: h0,
  illustrator: u0,
  indesign: f0,
  premiere: m0,
  "after-effects": e0,
  audition: n0,
  excel: i0,
  word: k0,
  powerpoint: x0,
  access: $1,
  publisher: y0,
  autocad: o0,
  fusion: d0,
  maya: g0,
  autodesk: l0,
  cinema4d: s0,
  davinci: _1
}, I0 = ["aria-label"], F0 = ["src", "alt"], z0 = {
  key: "fallback",
  class: "absolute inset-0",
  "aria-hidden": "true"
}, B0 = ["src"], G0 = ["innerHTML"], Me = /* @__PURE__ */ new Set(), gl = /* @__PURE__ */ B({
  inheritAttrs: !1,
  __name: "Thumbnail",
  props: {
    type: { default: "generic" },
    src: {},
    alt: {}
  },
  setup(e) {
    const t = e, n = M(!1), l = M(!1), a = M(!1);
    let i = 0;
    $(
      () => t.src,
      (y) => {
        if (i += 1, l.value = !1, !y) {
          n.value = !1, a.value = !1;
          return;
        }
        if (Me.has(y) || typeof Image > "u") {
          n.value = !0, a.value = !1;
          return;
        }
        n.value = !1, a.value = !1;
        const b = i, E = new Image();
        E.onload = () => {
          b === i && (n.value || (Me.add(y), a.value = !0, n.value = !0));
        }, E.onerror = () => {
          b === i && (l.value = !0);
        }, E.src = y, E.complete && E.naturalWidth > 0 && (Me.add(y), a.value = !1, n.value = !0);
      },
      {
        immediate: !0
      }
    );
    const d = r(() => t.src ?? void 0), c = r(() => !!t.src && n.value && !l.value), v = r(
      () => a.value ? "transition-opacity duration-200" : ""
    ), f = r(
      () => a.value ? "opacity-0" : ""
    ), g = r(
      () => a.value ? "opacity-100" : ""
    ), w = r(
      () => a.value ? "transition-opacity duration-100" : ""
    ), G = r(
      () => a.value ? "opacity-100" : ""
    ), k = r(
      () => a.value ? "opacity-0" : ""
    ), F = r(() => Ne[t.type] ?? Ne.generic), L = r(() => E0[t.type] ?? "vertical"), C = r(() => F.value.startsWith("data:")), I = pe(), A = r(
      () => C.value ? "" : F.value.replace(/<\?xml[^>]*\?>|<title>.*?<\/title>/g, "").replace(/(id="|url\(#|href="#)([^")]+)/g, `$1$2-${I}`)
    );
    return (y, b) => (o(), s("div", {
      class: "relative aspect-square w-full",
      role: "img",
      "aria-label": e.alt
    }, [
      V(oe, {
        mode: "out-in",
        "enter-active-class": v.value,
        "enter-from-class": f.value,
        "enter-to-class": g.value,
        "leave-active-class": w.value,
        "leave-from-class": G.value,
        "leave-to-class": k.value
      }, {
        default: U(() => [
          c.value ? (o(), s("img", he({ key: d.value }, y.$attrs, {
            src: d.value,
            alt: e.alt,
            class: "absolute inset-0 z-1 m-auto max-h-full max-w-full",
            onError: b[0] || (b[0] = (E) => l.value = !0)
          }), null, 16, F0)) : (o(), s("div", z0, [
            L.value !== "none" ? (o(), s("div", {
              key: 0,
              class: p(["absolute inset-0 m-auto rounded-[2px] border border-[#e2e3e4] bg-white", L.value === "horizontal" ? "h-[72%] w-[96%]" : "h-[96%] w-[72%]"])
            }, null, 2)) : x("", !0),
            C.value ? (o(), s("img", {
              key: 1,
              src: F.value,
              class: "absolute inset-0 size-full object-contain",
              alt: ""
            }, null, 8, B0)) : (o(), s("div", {
              key: 2,
              class: "absolute inset-0 size-full [&>svg]:size-full",
              innerHTML: A.value
            }, null, 8, G0))
          ]))
        ]),
        _: 1
      }, 8, ["enter-active-class", "enter-from-class", "enter-to-class", "leave-active-class", "leave-from-class", "leave-to-class"])
    ], 8, I0));
  }
}), ze = /* @__PURE__ */ Symbol("Modal"), rt = /* @__PURE__ */ Symbol("ModalRuntime"), T0 = { class: "relative mx-auto flex w-full max-w-[500px] flex-col overflow-hidden rounded-[16px] bg-white px-6 py-5 [box-shadow:0_15px_50px_0_rgb(0_0_0_/_18%)]" }, M0 = /* @__PURE__ */ B({
  __name: "Modal",
  props: {
    hideClose: { type: Boolean }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, l = t, a = se(rt, null), i = r(() => !!n.hideClose || !!a?.hideClose.value), d = () => a ? a.close() : l("close"), c = M("none");
    return ge(ze, { media: c }), (v, f) => (o(), s("div", T0, [
      i.value ? x("", !0) : (o(), s("button", {
        key: 0,
        type: "button",
        "aria-label": "Close",
        "data-testid": "modal-close",
        class: p(["absolute z-10 hidden size-[22px] cursor-pointer items-center justify-center rounded-[6px] text-gray-500/50 transition hover:bg-gray-200/25 hover:text-gray-500 tablet-v:flex", c.value === "contained" ? "right-[11px] top-[11px]" : "right-2 top-2"]),
        onClick: d
      }, [
        V(u(Re), {
          class: "size-[13px]",
          "aria-hidden": "true"
        })
      ], 2)),
      z(v.$slots, "default")
    ]));
  }
}), R0 = /* @__PURE__ */ B({
  __name: "Body",
  setup(e) {
    const t = se(ze, void 0)?.media ?? M("none"), n = r(
      () => ({
        none: "text-[14px] leading-[22px]",
        contained: "text-[15px] leading-[22px]",
        "full-bleed": "text-[16px] leading-[24px]"
      })[t.value]
    );
    return (l, a) => (o(), s("div", {
      class: p(["text-gray-800", n.value])
    }, [
      z(l.$slots, "default")
    ], 2));
  }
}), D0 = {
  key: 0,
  class: "mr-auto flex items-center"
}, V0 = /* @__PURE__ */ B({
  __name: "Footer",
  props: {
    layout: { default: "horizontal" }
  },
  setup(e) {
    const t = e, n = r(
      () => t.layout === "vertical" ? "flex-col items-center gap-[10px] [&>button]:w-full" : "items-center gap-2 [&>button]:flex-1 tablet-h:justify-end tablet-h:[&>button]:flex-none"
    );
    return (l, a) => (o(), s("div", {
      class: p(["mt-6 flex", n.value])
    }, [
      l.$slots.left ? (o(), s("div", D0, [
        z(l.$slots, "left")
      ])) : x("", !0),
      z(l.$slots, "default")
    ], 2));
  }
}), S0 = "-mx-[18px] -mt-[14px] mb-[18px] overflow-hidden rounded-[12px] border border-[#292C30]/15 bg-gray-100 [&_img]:block [&_img]:w-full", Z0 = "-mx-6 -mt-5 mb-[18px] [&_img]:block [&_img]:w-full", U0 = /* @__PURE__ */ B({
  __name: "Media",
  props: {
    fullBleed: { type: Boolean }
  },
  setup(e) {
    const t = e, n = se(ze, void 0);
    return Ee(() => {
      n && (n.media.value = t.fullBleed ? "full-bleed" : "contained");
    }), q(() => {
      n && (n.media.value = "none");
    }), (l, a) => (o(), s("div", {
      class: p(e.fullBleed ? Z0 : S0)
    }, [
      z(l.$slots, "default")
    ], 2));
  }
}), O0 = /* @__PURE__ */ B({
  __name: "Title",
  setup(e) {
    const t = se(ze, void 0)?.media ?? M("none"), n = r(
      () => ({
        none: "mb-[14px] text-[17px] leading-[24px]",
        contained: "mb-[8px] text-[24px] leading-[30px]",
        "full-bleed": "mb-[10px] text-[28px] leading-[34px]"
      })[t.value]
    );
    return (l, a) => (o(), s("h2", {
      class: p(["font-medium text-gray-800", n.value])
    }, [
      z(l.$slots, "default")
    ], 2));
  }
}), vl = Object.assign(M0, { Media: U0, Title: O0, Body: R0, Footer: V0 });
let Y0 = 0;
const K = M([]), Ye = M(!1), dt = () => {
  setTimeout(() => {
    K.value.length || (Ye.value = !1);
  }, 300);
}, P0 = (e, t = {}) => {
  const n = {
    id: Y0++,
    // markRaw: don't let the reactive stack proxy the component definition.
    component: _e(e),
    props: t.props,
    events: t.events,
    name: t.name,
    hideClose: !!t.hideClose,
    preventOutsideClick: !!t.preventOutsideClick
  };
  return t.stack ? K.value = [...K.value, n] : (K.value.at(-1)?.events?.close?.(), K.value = [n]), Ye.value = !0, n.id;
}, j0 = (e) => {
  const t = K.value.at(-1);
  t && (t.events?.close?.(e), K.value = K.value.slice(0, -1), K.value.length || dt());
}, ct = () => {
  K.value.forEach((e) => e.events?.close?.()), K.value = [], dt();
}, Q0 = (e, t) => {
  const n = K.value.at(-1)?.events?.[e];
  return n?.(t), !!n;
}, K0 = (e, t) => {
  const n = t !== void 0 ? K.value.find((l) => l.id === t) : K.value.at(-1);
  n && Object.assign(n, e);
}, X0 = () => ({ open: P0, close: j0, closeAll: ct, updateOptions: K0, triggerEvent: Q0 }), H0 = () => ({
  modals: we(K),
  isOpen: we(Ye),
  closeAll: ct
}), N0 = /* @__PURE__ */ B({
  __name: "ModalSlot",
  props: {
    modal: {},
    index: {}
  },
  setup(e) {
    const t = e, { close: n } = X0();
    return ge(rt, {
      close: (l) => n(l),
      hideClose: r(() => t.modal.hideClose),
      index: t.index
    }), (l, a) => (o(), R(H(e.modal.component), yt(At(e.modal.props)), null, 16));
  }
}), q0 = {
  key: 0,
  class: "fixed inset-0 z-250"
}, W0 = ["data-dialog", "data-dialog-index"], hl = /* @__PURE__ */ B({
  __name: "ModalHost",
  setup(e) {
    const { modals: t, isOpen: n, closeAll: l } = H0(), a = r(() => t.value.at(-1)), i = () => {
      a.value && !a.value.preventOutsideClick && l();
    }, d = (c) => {
      c.key === "Escape" && a.value && !a.value.hideClose && l();
    };
    return Ee(() => {
      document.body.style.overflow = n.value ? "hidden" : "";
    }), le(() => window.addEventListener("keydown", d)), q(() => {
      window.removeEventListener("keydown", d), document.body.style.overflow = "";
    }), (c, v) => (o(), R(ue, { to: "body" }, [
      u(n) ? (o(), s("div", q0, [
        V(oe, {
          name: "modal-backdrop",
          appear: ""
        }, {
          default: U(() => [
            u(t).length ? (o(), s("div", {
              key: 0,
              class: "absolute inset-0 bg-black/20 tablet-h:bg-gray-800/35",
              onClick: i
            })) : x("", !0)
          ]),
          _: 1
        }),
        m("div", {
          class: "absolute inset-0 flex overflow-y-auto p-4 tablet-h:p-0 tablet-h:py-5",
          onClick: _(i, ["self"])
        }, [
          V(oe, {
            name: "modal-card",
            appear: ""
          }, {
            default: U(() => [
              u(t).length ? (o(), s("div", {
                key: 0,
                class: "m-auto flex w-full justify-center",
                onClick: _(i, ["self"])
              }, [
                (o(!0), s(j, null, J(u(t), (f, g) => (o(), s("div", {
                  key: f.id,
                  "data-testid": "modal",
                  "data-dialog": f.name,
                  "data-dialog-index": g,
                  class: p(["w-full", { "pointer-events-none absolute -top-[9999px] opacity-0": g !== u(t).length - 1 }]),
                  onClick: _(i, ["self"])
                }, [
                  V(N0, {
                    modal: f,
                    index: g
                  }, null, 8, ["modal", "index"])
                ], 10, W0))), 128))
              ])) : x("", !0)
            ]),
            _: 1
          })
        ])
      ])) : x("", !0)
    ]));
  }
}), ut = /* @__PURE__ */ Symbol("dacr-table"), Be = (e) => {
  const t = se(ut);
  if (!t)
    throw new Error(`[Table] <Table.${e}> must be used inside <Table>.`);
  return t;
}, J0 = /* @__PURE__ */ B({
  __name: "Table",
  props: /* @__PURE__ */ W({
    selection: {},
    rowIds: {},
    stickyHeader: { type: Boolean, default: !0 }
  }, {
    selected: { default: () => [] },
    selectedModifiers: {},
    sort: { default: null },
    sortModifiers: {},
    mobileSelecting: { type: Boolean, default: !1 },
    mobileSelectingModifiers: {}
  }),
  emits: ["update:selected", "update:sort", "update:mobileSelecting"],
  setup(e) {
    const t = e, n = N(e, "selected"), l = N(e, "sort"), a = r(() => new Set(n.value)), i = (h) => a.value.has(h), d = r(
      () => t.rowIds ? new Set(t.rowIds) : null
    ), c = (h) => !!t.selection && (!d.value || d.value.has(h)), v = (h, T) => h.length === T.length && h.every((Z, Y) => Z === T[Y]);
    $([n, d, () => t.selection], () => {
      if (!t.selection) return;
      const h = d.value, T = h ? n.value.filter((Z) => h.has(Z)) : [...n.value];
      t.selection === "single" && T.splice(1), v(T, n.value) || (n.value = T);
    }, {
      immediate: !0
    });
    const g = (h) => {
      if (!c(h)) return;
      if (t.selection === "single") {
        n.value = a.value.has(h) ? [] : [h];
        return;
      }
      const T = new Set(n.value);
      T.has(h) ? T.delete(h) : T.add(h), n.value = [...T];
    }, w = r(() => {
      const h = t.rowIds;
      return !h || !h.length ? !1 : h.every((T) => a.value.has(T));
    }), G = r(() => {
      if (w.value) return !1;
      const h = t.rowIds;
      return h && h.length ? h.some((T) => a.value.has(T)) : n.value.length > 0;
    }), k = r(() => n.value.length > 0), F = () => {
      if (t.selection === "multiple") {
        if (!t.rowIds) {
          n.value = [];
          return;
        }
        n.value = w.value ? [] : [...t.rowIds];
      }
    }, L = N(e, "mobileSelecting"), C = r(() => [
      "w-full",
      t.selection ? "relative" : "border-t border-gray-200"
    ]), I = r(() => [
      "pointer-events-none absolute right-0 top-0 z-30 h-px bg-gray-200",
      t.selection === "single" ? "left-0" : L.value ? "left-7" : "left-0 tablet-h:left-7"
    ]);
    $(L, (h) => {
      h || (n.value = []);
    });
    const A = M(!0);
    let y = null;
    const b = () => {
      A.value = y?.matches ?? !0;
    };
    le(() => {
      typeof window > "u" || !window.matchMedia || (y = window.matchMedia("(min-width: 1024px)"), b(), y.addEventListener("change", b));
    }), bt(() => y?.removeEventListener("change", b));
    const E = (h) => {
      const T = l.value;
      T && T.field === h ? l.value = { field: h, direction: T.direction === "asc" ? "desc" : "asc" } : l.value = { field: h, direction: "asc" };
    };
    return ge(ut, {
      selection: r(() => t.selection),
      stickyHeader: r(() => t.stickyHeader),
      isSelected: i,
      isSelectable: c,
      toggleRow: g,
      allSelected: w,
      indeterminate: G,
      hasSelection: k,
      toggleAll: F,
      mobileSelecting: L,
      isDesktop: A,
      sort: l,
      setSort: E
    }), (h, T) => (o(), s("div", {
      class: p(C.value)
    }, [
      t.selection ? (o(), s("div", {
        key: 0,
        "aria-hidden": "true",
        class: p(I.value)
      }, null, 2)) : x("", !0),
      z(h.$slots, "default")
    ], 2));
  }
}), $0 = /* @__PURE__ */ B({
  __name: "Cell",
  props: {
    align: { default: "left" },
    primary: { type: Boolean }
  },
  setup(e) {
    const t = e;
    Be("Cell");
    const n = r(
      () => t.align === "right" ? "justify-end text-right" : t.align === "center" ? "justify-center text-center" : "justify-start text-left"
    );
    return (l, a) => (o(), s("div", {
      role: "cell",
      class: p([
        "flex min-h-[41px] min-w-0 items-center px-[10px] py-[8px] text-[14px] leading-[18px] text-gray-800",
        e.primary ? "min-w-0 flex-1" : "",
        n.value
      ])
    }, [
      z(l.$slots, "default")
    ], 2));
  }
}), _0 = { class: "group relative flex h-[41px] items-stretch" }, eo = /* @__PURE__ */ B({
  __name: "Head",
  setup(e) {
    const t = Be("Head"), n = r(() => t.selection.value !== "multiple" ? "left-0" : t.mobileSelecting.value ? "left-7" : "left-0 tablet-h:left-7"), l = r(() => [
      "pointer-events-none absolute right-0 h-px",
      n.value
    ]), a = r(() => [
      ...l.value,
      "bottom-0 bg-[#EFEFEF]"
    ]);
    return (i, d) => (o(), s("div", {
      class: p([
        "relative bg-white",
        u(t).stickyHeader.value ? "sticky top-0 z-20" : ""
      ])
    }, [
      m("div", _0, [
        u(t).selection.value ? (o(), s("div", {
          key: 0,
          class: p([
            "w-7 shrink-0 items-center justify-start",
            u(t).mobileSelecting.value || u(t).selection.value === "single" ? "flex" : "tablet-h:flex hidden",
            u(t).selection.value !== "multiple" || u(t).hasSelection.value ? "" : "tablet-h:opacity-0 tablet-h:group-hover:opacity-100"
          ]),
          onClick: d[1] || (d[1] = _(() => {
          }, ["stop"]))
        }, [
          u(t).selection.value === "multiple" ? (o(), R(ke, {
            key: 0,
            "model-value": u(t).allSelected.value,
            indeterminate: u(t).indeterminate.value,
            "onUpdate:modelValue": d[0] || (d[0] = (c) => u(t).toggleAll())
          }, null, 8, ["model-value", "indeterminate"])) : x("", !0)
        ], 2)) : x("", !0),
        z(i.$slots, "default"),
        u(t).selection.value === "multiple" ? (o(), s("div", {
          key: 1,
          class: "tablet-h:hidden mr-[18px] flex shrink-0 items-center justify-center",
          onClick: d[3] || (d[3] = _(() => {
          }, ["stop"]))
        }, [
          m("button", {
            type: "button",
            class: "flex items-center justify-center text-gray-800",
            onClick: d[2] || (d[2] = (c) => u(t).mobileSelecting.value = !u(t).mobileSelecting.value)
          }, [
            (o(), R(H(
              u(t).mobileSelecting.value ? u(Gt) : u(Tt)
            ), { class: "size-[18px]" }))
          ])
        ])) : x("", !0),
        m("div", {
          "aria-hidden": "true",
          class: p(a.value)
        }, null, 2)
      ])
    ], 2));
  }
}), to = { class: "truncate" }, no = /* @__PURE__ */ B({
  __name: "Header",
  props: {
    field: {},
    sortable: { type: Boolean },
    align: { default: "left" },
    primary: { type: Boolean }
  },
  setup(e) {
    const t = e, n = Be("Header"), l = r(() => t.sortable && n.sort.value?.field === t.field), a = r(() => n.sort.value?.direction), i = r(
      () => t.align === "right" ? "justify-end text-right" : t.align === "center" ? "justify-center text-center" : "justify-start text-left"
    ), d = () => {
      t.sortable && t.field && n.setSort(t.field);
    };
    return (c, v) => (o(), R(H(e.sortable ? "button" : "div"), {
      type: e.sortable ? "button" : void 0,
      role: "columnheader",
      class: p([
        "h-full min-w-0 items-center gap-[6px] px-[10px] text-[13px] font-medium leading-[18px] text-gray-800",
        e.primary ? "flex min-w-0 flex-1" : "hidden tablet-h:flex",
        i.value,
        e.sortable ? "cursor-pointer select-none hover:text-gray-900" : ""
      ]),
      onClick: d
    }, {
      default: U(() => [
        m("span", to, [
          z(c.$slots, "default")
        ]),
        e.sortable && l.value ? (o(), R(u(Mt), {
          key: 0,
          class: p(["size-[12px] shrink-0 transition-transform", { "rotate-180": a.value === "desc" }]),
          "aria-hidden": "true"
        }, null, 8, ["class"])) : x("", !0)
      ]),
      _: 3
    }, 8, ["type", "class"]));
  }
}), oo = { class: "tablet-h:flex hidden min-h-[41px] items-stretch" }, lo = { class: "tablet-h:hidden flex min-h-[64px] items-stretch" }, pt = /* @__PURE__ */ B({
  __name: "Row",
  props: {
    id: {},
    disabled: { type: Boolean },
    hover: { type: Boolean, default: !0 },
    divider: { type: Boolean, default: !0 }
  },
  emits: ["row-click"],
  setup(e) {
    const t = e, n = Be("Row"), l = ce(), a = Ct(), i = r(() => t.id ? n.isSelected(t.id) : !1), d = r(
      () => t.id ? n.isSelectable(t.id) : !1
    ), c = r(() => !!l.media), v = r(() => [
      "group relative block w-full",
      t.disabled ? "pointer-events-none opacity-50" : "cursor-pointer"
    ]), f = r(() => [
      "transition-colors",
      i.value ? "bg-green-700/15" : "",
      !i.value && !t.disabled && t.hover ? "group-hover:bg-[#F9F9FA]/50" : ""
    ]), g = r(() => [
      "pointer-events-none absolute right-0 bottom-0 h-px",
      c.value ? "left-[10px]" : "left-0",
      i.value ? "bg-[#BCD7DC]" : "bg-[#EFEFEF]"
    ]), w = () => {
      t.id && n.toggleRow(t.id);
    }, G = (k) => {
      if (t.disabled) return;
      const F = n.selection.value && (n.isDesktop.value || n.mobileSelecting.value || n.selection.value === "single");
      t.id && F && n.toggleRow(t.id), a?.emit("row-click", k);
    };
    return (k, F) => (o(), s("div", {
      role: "row",
      "data-testid": "table-row",
      class: p(v.value),
      onClick: G
    }, [
      m("div", oo, [
        u(n).selection.value ? (o(), s("div", {
          key: 0,
          class: p([
            "flex w-7 shrink-0 items-center justify-start",
            u(n).selection.value !== "multiple" || u(n).hasSelection.value ? "opacity-100" : "opacity-0 group-hover:opacity-100"
          ]),
          onClick: F[0] || (F[0] = _(() => {
          }, ["stop"]))
        }, [
          d.value ? (o(), R(ke, {
            key: 0,
            "model-value": i.value,
            "onUpdate:modelValue": w
          }, null, 8, ["model-value"])) : x("", !0)
        ], 2)) : x("", !0),
        c.value ? (o(), s("div", {
          key: 1,
          class: p(["flex shrink-0 items-center pl-[10px]", f.value])
        }, [
          z(k.$slots, "media")
        ], 2)) : x("", !0),
        m("div", {
          class: p(["relative flex min-w-0 flex-1 items-stretch", f.value])
        }, [
          z(k.$slots, "default"),
          e.divider ? (o(), s("div", {
            key: 0,
            "aria-hidden": "true",
            class: p(g.value)
          }, null, 2)) : x("", !0)
        ], 2)
      ]),
      m("div", lo, [
        u(n).selection.value && (u(n).mobileSelecting.value || u(n).selection.value === "single") ? (o(), s("div", {
          key: 0,
          class: "flex w-7 shrink-0 items-center justify-start",
          onClick: F[1] || (F[1] = _(() => {
          }, ["stop"]))
        }, [
          d.value ? (o(), R(ke, {
            key: 0,
            "model-value": i.value,
            "onUpdate:modelValue": w
          }, null, 8, ["model-value"])) : x("", !0)
        ])) : x("", !0),
        c.value ? (o(), s("div", {
          key: 1,
          class: p(["flex shrink-0 items-center pl-[10px]", f.value])
        }, [
          z(k.$slots, "media")
        ], 2)) : x("", !0),
        m("div", {
          class: p(["relative flex min-w-0 flex-1 items-center", f.value])
        }, [
          z(k.$slots, "mobile", {}, () => [
            z(k.$slots, "default")
          ]),
          e.divider ? (o(), s("div", {
            key: 0,
            "aria-hidden": "true",
            class: p(g.value)
          }, null, 2)) : x("", !0)
        ], 2)
      ])
    ], 2));
  }
}), so = /* @__PURE__ */ B({
  __name: "Virtual",
  props: {
    rows: {},
    rowHeight: {},
    idKey: { default: "id" },
    buffer: { default: 200 }
  },
  emits: ["row-click", "scroll-end"],
  setup(e, { emit: t }) {
    const n = e, l = t, a = ce(), i = (d) => String(d?.[n.idKey]);
    return (d, c) => (o(), R(u(Vt), {
      class: "h-full w-full",
      items: e.rows,
      "item-size": e.rowHeight,
      "key-field": e.idKey,
      buffer: e.buffer,
      onScrollEnd: c[0] || (c[0] = (v) => l("scroll-end"))
    }, {
      default: U(({ item: v, index: f }) => [
        V(pt, {
          id: i(v),
          onRowClick: (g) => l("row-click", g, v)
        }, wt({
          default: U(() => [
            z(d.$slots, "row", {
              row: v,
              index: f
            })
          ]),
          _: 2
        }, [
          u(a)["media-row"] ? {
            name: "media",
            fn: U(() => [
              z(d.$slots, "media-row", {
                row: v,
                index: f
              })
            ]),
            key: "0"
          } : void 0,
          u(a)["mobile-row"] ? {
            name: "mobile",
            fn: U(() => [
              z(d.$slots, "mobile-row", {
                row: v,
                index: f
              })
            ]),
            key: "1"
          } : void 0
        ]), 1032, ["id", "onRowClick"])
      ]),
      _: 3
    }, 8, ["items", "item-size", "key-field", "buffer"]));
  }
}), xl = Object.assign(J0, { Head: eo, Header: no, Row: pt, Cell: $0, Virtual: so }), ft = /* @__PURE__ */ Symbol("SheetRuntime"), ao = {
  key: 0,
  class: "flex h-[54px] shrink-0 items-center px-4"
}, io = { class: "flex w-[44px] justify-start" }, ro = { class: "flex-1 truncate px-2 text-center text-[17px] font-medium leading-[22px] text-gray-900" }, co = { class: "flex w-[44px] justify-end" }, uo = /* @__PURE__ */ B({
  __name: "Sheet",
  props: {
    height: {}
  },
  setup(e) {
    const t = e, n = ce(), l = r(
      () => !!(n.leading || n.title || n.trailing)
    ), a = se(ft, void 0), i = r(
      () => t.height ?? a?.height.value ?? "content"
    ), d = r(
      () => i.value === "content" ? "max-h-[90dvh]" : "h-[calc(100dvh-var(--sheet-safe-area-top,15px))]"
    );
    return (c, v) => (o(), s("div", {
      class: p(["flex w-full flex-col overflow-hidden rounded-t-[38px] bg-white", d.value])
    }, [
      v[0] || (v[0] = m("div", { class: "flex shrink-0 justify-center pt-[6px]" }, [
        m("div", { class: "h-[4px] w-[36px] rounded-full bg-[#CFCFCF]" })
      ], -1)),
      l.value ? (o(), s("div", ao, [
        m("div", io, [
          z(c.$slots, "leading")
        ]),
        m("div", ro, [
          z(c.$slots, "title")
        ]),
        m("div", co, [
          z(c.$slots, "trailing")
        ])
      ])) : x("", !0),
      z(c.$slots, "default")
    ], 2));
  }
}), po = 0, fo = /* @__PURE__ */ new Set([
  "text",
  "search",
  "email",
  "password",
  "tel",
  "url",
  "number"
]);
function qe(e) {
  return (e instanceof HTMLTextAreaElement || e instanceof HTMLInputElement && fo.has(e.type)) && !e.disabled && !e.readOnly;
}
function go() {
  let e = () => {
  }, t = () => {
  };
  return q(() => {
    t(), e();
  }), { handleTouchEnd: (a) => {
    const i = /iP(ad|hone|od)/.test(navigator.userAgent) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1, d = a.target, c = d instanceof Element ? d.closest("label")?.control ?? d : d;
    if (!i || !qe(c)) return;
    const v = window.visualViewport, f = v && v.height < window.innerHeight - 100;
    if (document.activeElement === c && f) return;
    a.preventDefault(), t();
    const g = c.style.opacity, w = c.selectionStart, G = c.selectionEnd, k = c instanceof HTMLTextAreaElement ? document.createElement("textarea") : document.createElement("input");
    k instanceof HTMLInputElement && c instanceof HTMLInputElement && (k.type = c.type), k.style.cssText = "position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;border:0;padding:0;font-size:16px", k.autocomplete = "off", k.inputMode = c.inputMode, k.enterKeyHint = c.enterKeyHint, k.autocapitalize = c.autocapitalize, k.spellcheck = c.spellcheck, document.body.appendChild(k), k.focus({ preventScroll: !0 });
    let F = 0;
    const L = window.setTimeout(() => {
      if (!c.isConnected || document.activeElement !== k) {
        t();
        return;
      }
      if (k.value) {
        const C = w ?? c.value.length, I = G ?? C;
        c.value = c.value.slice(0, C) + k.value + c.value.slice(I), c.dispatchEvent(new Event("input", { bubbles: !0 }));
      }
      c.style.opacity = "0", c.focus({ preventScroll: !0 }), k.remove(), F = window.requestAnimationFrame(() => t());
    }, po);
    t = () => {
      window.clearTimeout(L), window.cancelAnimationFrame(F), k.remove(), c.style.opacity = g, t = () => {
      };
    };
  }, handleFocus: (a) => {
    const i = a.target, d = a.currentTarget;
    if (!qe(i) || !(d instanceof HTMLElement)) return;
    e();
    const c = d.style.maxHeight, v = window.visualViewport, f = () => {
      if (!i.isConnected || document.activeElement !== i) {
        e();
        return;
      }
      v && (d.style.maxHeight = `${Math.max(0, v.height - d.getBoundingClientRect().top)}px`);
      const g = Math.min(
        d.getBoundingClientRect().bottom,
        v?.height ?? window.innerHeight
      ), w = i.getBoundingClientRect().bottom - g;
      w > 0 && (d.scrollTop += w + 16);
    };
    e = () => {
      d.style.maxHeight = c, i.removeEventListener("blur", e), v?.removeEventListener("resize", f), e = () => {
      };
    }, i.addEventListener("blur", e, { once: !0 }), v?.addEventListener("resize", f), f();
  } };
}
const vo = /* @__PURE__ */ B({
  __name: "Body",
  setup(e) {
    const { handleFocus: t, handleTouchEnd: n } = go();
    return (l, a) => (o(), s("div", {
      class: "min-h-0 flex-1 overflow-y-auto px-4 pb-4 text-[14px] leading-[22px] text-gray-800",
      onFocusin: a[0] || (a[0] = //@ts-ignore
      (...i) => u(t) && u(t)(...i)),
      onTouchendCapture: a[1] || (a[1] = //@ts-ignore
      (...i) => u(n) && u(n)(...i))
    }, [
      z(l.$slots, "default")
    ], 32));
  }
}), ho = ["data-variant", "disabled"], xo = "pointer-events-none bg-[#78788029] text-gray-300", mo = /* @__PURE__ */ B({
  __name: "Button",
  props: {
    variant: { default: "default" },
    icon: {},
    disabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = {
      default: "bg-[#78788029] text-gray-800 hover:bg-[#7878803d]",
      primary: "bg-green-900 text-white hover:brightness-[1.2]"
    };
    return (n, l) => (o(), s("button", {
      type: "button",
      "data-testid": "sheet-button",
      "data-variant": e.variant,
      disabled: e.disabled,
      class: p([
        "flex size-[44px] shrink-0 items-center justify-center rounded-full transition",
        e.disabled ? xo : t[e.variant],
        !e.disabled && "cursor-pointer"
      ])
    }, [
      (o(), R(H(e.icon), {
        class: "size-[24px] [--icon-stroke:2px]",
        "aria-hidden": "true"
      }))
    ], 10, ho));
  }
}), yo = ["role", "aria-checked", "disabled"], Ao = { class: "flex min-w-0 flex-1 flex-col gap-[4px]" }, bo = { class: "truncate text-[16px] leading-[20px]" }, Co = /* @__PURE__ */ B({
  __name: "MenuItem",
  props: {
    icon: {},
    control: {},
    selected: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(e) {
    const t = e, n = r(
      () => t.control === "checkbox" ? "menuitemcheckbox" : t.control === "radio" ? "menuitemradio" : "menuitem"
    ), l = r(() => [
      "flex size-5 shrink-0 items-center justify-center border transition-colors",
      t.control === "radio" ? "rounded-full" : "rounded-[5px]",
      t.selected ? "border-green-200 bg-green-200" : "border-[#2d2d2d]/25 bg-white"
    ]);
    return (a, i) => (o(), s("button", {
      type: "button",
      role: n.value,
      "aria-checked": e.control ? !!e.selected : void 0,
      disabled: e.disabled,
      class: p(["flex min-h-[44px] w-full items-start gap-[16px] px-[20px] py-[12px] text-left outline-none transition-colors active:bg-gray-100", e.disabled ? "pointer-events-none text-gray-300" : "text-gray-800"])
    }, [
      e.icon ? (o(), R(H(e.icon), {
        key: 0,
        class: "size-5 shrink-0",
        "aria-hidden": "true"
      })) : x("", !0),
      m("span", Ao, [
        m("span", bo, [
          z(a.$slots, "default")
        ]),
        a.$slots.description ? (o(), s("span", {
          key: 0,
          class: p(["line-clamp-2 text-[14px] leading-[18px]", e.disabled ? "text-gray-300" : "text-gray-500"])
        }, [
          z(a.$slots, "description")
        ], 2)) : x("", !0)
      ]),
      e.control ? (o(), s("span", {
        key: 1,
        class: p(l.value)
      }, [
        e.selected ? (o(), R(u(Ie), {
          key: 0,
          class: "size-3 text-green-900",
          "aria-hidden": "true"
        })) : x("", !0)
      ], 2)) : x("", !0)
    ], 10, yo));
  }
}), wo = { class: "flex items-center px-[20px] py-[10px] text-[16px] font-medium leading-[18px] text-gray-800" }, ko = /* @__PURE__ */ B({
  __name: "MenuLabel",
  props: {
    label: {}
  },
  setup(e) {
    return (t, n) => (o(), s("div", wo, [
      z(t.$slots, "default", {}, () => [
        ee(D(e.label), 1)
      ])
    ]));
  }
}), Lo = {}, Eo = {
  role: "separator",
  class: "flex h-[14px] items-center px-[20px]"
};
function Io(e, t) {
  return o(), s("div", Eo, [...t[0] || (t[0] = [
    m("div", { class: "h-px w-full bg-gray-800/10" }, null, -1)
  ])]);
}
const Fo = /* @__PURE__ */ te(Lo, [["render", Io]]), ml = Object.assign(uo, { Body: vo, Button: mo, MenuItem: Co, MenuLabel: ko, MenuSeparator: Fo });
let zo = 0;
const X = M([]), Pe = M(!1), gt = () => {
  setTimeout(() => {
    X.value.length || (Pe.value = !1);
  }, 400);
}, Bo = (e, t = {}) => {
  const n = {
    id: zo++,
    component: _e(e),
    props: t.props,
    events: t.events,
    name: t.name,
    height: t.height ?? "content",
    stackMode: typeof t.stack == "string" ? t.stack : "peek",
    preventOutsideClick: !!t.preventOutsideClick,
    disableDrag: !!t.disableDrag
  };
  return t.stack ? X.value = [...X.value, n] : (X.value.at(-1)?.events?.close?.(), X.value = [n]), Pe.value = !0, n.id;
}, vt = (e) => {
  const t = X.value.at(-1);
  t && (t.events?.close?.(e), X.value = X.value.slice(0, -1), X.value.length || gt());
}, Go = () => {
  X.value.forEach((e) => e.events?.close?.()), X.value = [], gt();
}, To = (e, t) => {
  const n = X.value.at(-1)?.events?.[e];
  return n?.(t), !!n;
}, Mo = (e, t) => {
  const n = t !== void 0 ? X.value.find((l) => l.id === t) : X.value.at(-1);
  n && Object.assign(n, e);
}, Ro = () => ({ open: Bo, close: vt, closeAll: Go, updateOptions: Mo, triggerEvent: To }), Do = () => ({
  sheets: we(X),
  isOpen: we(Pe),
  close: vt
}), Vo = /* @__PURE__ */ B({
  __name: "SheetSlot",
  props: {
    sheet: {},
    coverStyle: { type: [Boolean, null, String, Object, Array] }
  },
  emits: ["drag"],
  setup(e, { emit: t }) {
    const n = e, l = t, { close: a } = Ro();
    ge(ft, {
      close: (L) => a(L),
      height: r(() => n.sheet.height)
    });
    const i = M(), d = M(0), c = M(0), v = M(!1), f = M(!1), g = () => {
      v.value = !0, setTimeout(() => v.value = !1, 300);
    }, w = (L) => {
      for (; L && L !== i.value; ) {
        if (L.scrollHeight > L.clientHeight && L.scrollTop > 0) return L;
        L = L.parentElement;
      }
      return null;
    }, G = (L) => {
      if (!n.sheet.disableDrag) {
        if (w(L.target)) {
          f.value = !1;
          return;
        }
        f.value = !0, d.value = L.touches[0].pageY, l("drag", 0, !0);
      }
    }, k = (L) => {
      if (!f.value) return;
      const C = L.touches[0].pageY - d.value;
      if (C <= 0) return;
      L.preventDefault(), c.value = C;
      const I = i.value?.clientHeight || 1;
      l("drag", Math.min(C / I, 1), !0);
    }, F = () => {
      if (!f.value) return;
      f.value = !1;
      const L = i.value?.clientHeight || 0;
      g(), c.value >= L * 0.5 && a(), l("drag", 0, !1), c.value = 0;
    };
    return le(() => {
      i.value?.addEventListener("touchstart", G, { passive: !0 }), i.value?.addEventListener("touchmove", k, { passive: !1 }), i.value?.addEventListener("touchend", F, { passive: !0 });
    }), q(() => {
      i.value?.removeEventListener("touchstart", G), i.value?.removeEventListener("touchmove", k), i.value?.removeEventListener("touchend", F);
    }), (L, C) => (o(), s("div", {
      ref_key: "el",
      ref: i,
      class: p(["w-full", { "transition-transform duration-300 ease-[cubic-bezier(0.25,1,0.5,1)]": v.value }]),
      style: Q({ transform: `translateY(${c.value}px)` })
    }, [
      (o(), R(H(e.sheet.component), he(e.sheet.props, { style: e.coverStyle }), null, 16, ["style"]))
    ], 6));
  }
}), So = {
  key: 0,
  class: "fixed inset-0 z-250"
}, Zo = {
  key: 0,
  class: "absolute inset-0",
  style: { zIndex: 1 }
}, Uo = ["data-sheet-id", "data-dialog", "data-dialog-index"], Oo = 12, Yo = 0.96, Po = 0.2, yl = /* @__PURE__ */ B({
  __name: "SheetHost",
  setup(e) {
    const { sheets: t, isOpen: n, close: l } = Do(), a = r(() => t.value.at(-1)), i = () => {
      a.value && !a.value.preventOutsideClick && l();
    }, d = (A) => {
      A.key === "Escape" && a.value && !a.value.preventOutsideClick && l();
    };
    Ee(() => {
      document.body.style.overflow = n.value ? "hidden" : "";
    }), le(() => window.addEventListener("keydown", d)), q(() => {
      window.removeEventListener("keydown", d), document.body.style.overflow = "";
    });
    const c = M({}), v = () => {
      const A = {};
      for (const y of t.value) {
        const b = document.querySelector(`[data-sheet-id="${y.id}"]`);
        b && (A[y.id] = b.offsetHeight);
      }
      c.value = A;
    };
    $(() => t.value.length, () => re(v));
    const f = (A) => {
      if (A === 0 || t.value[A].stackMode !== "peek") return;
      const y = t.value[A - 1], b = y ? c.value[y.id] : void 0;
      if (b)
        return { maxHeight: `${Math.max(b - Oo, 0)}px` };
    }, g = M(0), w = M(!1), G = M(-1), k = (A, y, b) => {
      w.value = b, g.value = b ? y : 0, G.value = b ? A : -1;
    }, F = (A) => t.value[A + 1] ? w.value && G.value === A + 1 ? 1 - g.value : 1 : 0, L = (A) => ({
      transform: `scale(${1 - (1 - Yo) * F(A)})`,
      transition: w.value ? "none" : "transform 0.3s"
    }), C = (A) => {
      const y = F(A);
      return {
        opacity: Po * y,
        pointerEvents: y > 0 ? "auto" : "none",
        transition: w.value ? "none" : "opacity 0.3s"
      };
    }, I = r(() => ({
      opacity: t.value.length ? w.value && t.value.length === 1 ? 1 - g.value : 1 : 0,
      transition: w.value ? "none" : "opacity 0.3s"
    }));
    return (A, y) => (o(), R(ue, { to: "body" }, [
      u(n) ? (o(), s("div", So, [
        V(oe, {
          name: "sheet-backdrop",
          appear: ""
        }, {
          default: U(() => [
            u(t).length ? (o(), s("div", Zo, [
              m("div", {
                class: "h-full w-full bg-black/20",
                style: Q(I.value),
                onClick: i
              }, null, 4)
            ])) : x("", !0)
          ]),
          _: 1
        }),
        V(kt, {
          tag: "div",
          name: "sheet-slide",
          appear: "",
          class: "pointer-events-none absolute inset-0"
        }, {
          default: U(() => [
            (o(!0), s(j, null, J(u(t), (b, E) => (o(), s("div", {
              key: b.id,
              "data-sheet-id": b.id,
              "data-testid": "sheet",
              "data-dialog": b.name,
              "data-dialog-index": E,
              class: "absolute inset-x-0 bottom-0 flex justify-center",
              style: Q({ zIndex: (E + 1) * 10 })
            }, [
              m("div", {
                class: "pointer-events-auto relative w-full max-w-[520px] origin-top",
                style: Q(L(E))
              }, [
                V(Vo, {
                  sheet: b,
                  "cover-style": f(E),
                  onDrag: (h, T) => k(E, h, T)
                }, null, 8, ["sheet", "cover-style", "onDrag"]),
                m("div", {
                  class: "absolute inset-0 rounded-t-[38px] bg-black",
                  style: Q(C(E)),
                  onClick: i
                }, null, 4)
              ], 4)
            ], 12, Uo))), 128))
          ]),
          _: 1
        })
      ])) : x("", !0)
    ]));
  }
});
export {
  qo as Alert,
  al as Autocomplete,
  tt as Avatar,
  pl as Breadcrumb,
  Ho as Button,
  ke as Checkbox,
  sl as Chip,
  No as FloatingButton,
  ol as Input,
  el as Link,
  fl as LinkBreadcrumb,
  Le as Menu,
  vl as Modal,
  hl as ModalHost,
  $o as Pill,
  _o as Progress,
  Wo as Radio,
  ll as Search,
  cl as Segment,
  ul as Select,
  ml as Sheet,
  yl as SheetHost,
  Wt as Skeleton,
  dl as TabCards,
  xl as Table,
  rl as Tabs,
  il as Textarea,
  gl as Thumbnail,
  vn as Toast,
  nl as ToastHost,
  Jo as Toggle,
  me as Tooltip,
  X0 as useModal,
  H0 as useModalHost,
  Ro as useSheet,
  Do as useSheetHost,
  tl as useToast
};
